import {gql} from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {[key: string]: unknown}> = {[K in keyof T]: T[K]};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]?: Maybe<T[SubKey]>};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]: Maybe<T[SubKey]>};
export type MakeEmpty<T extends {[key: string]: unknown}, K extends keyof T> = {[_ in K]?: never};
export type Incremental<T> =
  | T
  | {[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: {input: string; output: string};
  String: {input: string; output: string};
  Boolean: {input: boolean; output: boolean};
  Int: {input: number; output: number};
  Float: {input: number; output: number};
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: {input: any; output: any};
  /** Custom scalar type for JSON objects */
  JSON: {input: any; output: any};
};

export type AccessToken = {
  __typename?: 'AccessToken';
  /** The email for this access token. */
  email: Scalars['String']['output'];
  /** The access token string. */
  token: Scalars['String']['output'];
  /** The type of the access token. */
  type: AccessTokenType;
  /** The ID of the associated User. This field is only present for 'Authentication' token type. */
  userId?: Maybe<Scalars['String']['output']>;
};

export enum AccessTokenType {
  Authentication = 'Authentication',
}

export type ActionPlan = {
  __typename?: 'ActionPlan';
  active: Scalars['Boolean']['output'];
  adjustments: Array<HealthFactorAdjustment>;
  id: Scalars['ID']['output'];
};

export enum ActionPlanImpactLevel {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
}

export type Address = {
  __typename?: 'Address';
  /** Street Address. */
  address: Scalars['String']['output'];
  /** Details. i.e. Apartment, Suite, Floor, etc */
  addressDetail?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  province: Scalars['String']['output'];
  provinceCode: Scalars['String']['output'];
};

export enum AssessmentStatusEnum {
  CompleteEnum = 'CompleteEnum',
  ProcessingEnum = 'ProcessingEnum',
}

export enum AssetStatus {
  PendingUpload = 'PENDING_UPLOAD',
  Ready = 'READY',
}

export enum BirthSex {
  Female = 'FEMALE',
  Male = 'MALE',
  Unknown = 'UNKNOWN',
}

export type Category = {
  __typename?: 'Category';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: CategoryKeyEnum;
  steps: Array<Step>;
  title: Scalars['String']['output'];
};

export type CategoryAssessment = {
  __typename?: 'CategoryAssessment';
  category: Category;
  categoryId: Scalars['String']['output'];
  categoryScore: Scalars['Float']['output'];
  factorAssessments: Array<HealthFactorAssessment>;
  id: Scalars['ID']['output'];
  maxCategoryScore: Scalars['Float']['output'];
  meetsRequirements: Scalars['Boolean']['output'];
};

export enum CategoryKeyEnum {
  Diet = 'diet',
  Fitness = 'fitness',
  Habits = 'habits',
  Mental = 'mental',
  Research = 'research',
  Sleep = 'sleep',
  You = 'you',
}

export type ChangeEmailInput = {
  /** The email change verification token for the user. */
  token: Scalars['String']['input'];
};

export type CheckIn = {
  __typename?: 'CheckIn';
  /** The percentage of affirmatively-answered questions for this CheckIn. */
  actionItemsHitPercentage: Scalars['Float']['output'];
  /** Indicates if the user completed this CheckIn, as derived by the presence of a `submittedAt` field. */
  completed: Scalars['Boolean']['output'];
  /** An "YYYY-MM-DD"-formatted DateString representing the CheckInʼs end date */
  endedOn: Scalars['String']['output'];
  /** The CheckInʼs ID */
  id: Scalars['String']['output'];
  /**
   * The array of questions for the given check-in.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  questions: Array<CheckInQuestion>;
  /** An "YYYY-MM-DD"-formatted DateString representing the CheckInʼs start date */
  startedOn: Scalars['String']['output'];
  /** The date the CheckIn was completed */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The TestPeriod the given CheckIn is associated with.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  testPeriod?: Maybe<TestPeriod>;
};

export type CheckInInput = {
  id: Scalars['String']['input'];
};

export type CheckInQuestion = {
  __typename?: 'CheckInQuestion';
  /** An alternate title, phrased as a statement, for the CheckInQuestion. */
  actionItemTitle?: Maybe<Scalars['String']['output']>;
  /** The userʼs response for the CheckInQuestion. */
  answerBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** A markdown-formatted string for the CheckInQuestionʼs "benefits" content */
  benefits?: Maybe<Scalars['String']['output']>;
  /** A markdown-formatted string for the CheckInQuestionʼs "context" content */
  context?: Maybe<Scalars['String']['output']>;
  /** The HealthFactor associated with the CheckInQuestion, if one exists. */
  healthFactor?: Maybe<HealthFactor>;
  /** The number of times the user has answered this CheckInQuestion within a TestPeriod */
  hitCount: Scalars['Float']['output'];
  /** The CheckInQuestionʼs ID */
  id: Scalars['String']['output'];
  /** The URL of the image for the check-in question */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The impact level of the CheckInQuestion associated healthFactor, if available */
  impactLevel?: Maybe<Scalars['String']['output']>;
  /** A markdown-formatted string for the CheckInQuestionʼs "tips" content */
  tips?: Maybe<Scalars['String']['output']>;
  /** The CheckInQuestionʼs title */
  title: Scalars['String']['output'];
};

export type CheckInStat = {
  __typename?: 'CheckInStat';
  /** Indicates if a user submitted answers for their check in this week. */
  completed: Scalars['Boolean']['output'];
  /** The end date for the check in period. */
  endedOn: Scalars['String']['output'];
  /** The start date for the check in period. */
  startedOn: Scalars['String']['output'];
};

export type CheckInsInput = {
  /** If this flag is set, an attempt to create the current week's CheckIn will be made before fetching existing CheckIns */
  includeCurrentCheckIn: Scalars['Boolean']['input'];
};

export type CreateAndApplyDiscountInput = {
  /** The category of the discount to be created. */
  discountCategory: Scalars['String']['input'];
  /** The level of the discount to be applied (order or product). */
  discountLevel: Scalars['String']['input'];
  /** The value of the discount to be applied. */
  discountValue: Scalars['Float']['input'];
  /** What type of value the discount is (percentage or fixed amount). */
  discountValueType: Scalars['String']['input'];
  /** The product variants that the discount can be applied to. */
  productVariantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateCheckInAnswersInput = {
  /** An array of question IDs, and the userʼs `answerBoolean` response to the question */
  answers: Array<CreateCheckInAnswersInputAnswer>;
  /** The ID of the CheckIn to submit answers for */
  checkInId: Scalars['String']['input'];
};

export type CreateCheckInAnswersInputAnswer = {
  /** The userʼs answer to the CheckInQuestion */
  answerBoolean: Scalars['Boolean']['input'];
  /** The ID of the CheckInQuestion the user is answering */
  questionId: Scalars['String']['input'];
};

export type CreateFileInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: FileType;
};

export type CreateLabSubmissionInput = {
  registrationId: Scalars['String']['input'];
};

export type CreateUserAccountInput = {
  /** If true the user account will be auto-verified. */
  autoVerify?: InputMaybe<Scalars['Boolean']['input']>;
  /** The birth sex of the user. */
  birthSex: BirthSex;
  /** The birthday of the user. Must be in the format of YYYY-MM-DD. */
  birthday: Scalars['String']['input'];
  /** The email address of the user. */
  email: Scalars['String']['input'];
  /** The first name of the user. */
  firstName: Scalars['String']['input'];
  /** Indicates if the user received their test kit as a gift */
  isGiftedTestKit?: InputMaybe<Scalars['Boolean']['input']>;
  /** The last name of the user. */
  lastName: Scalars['String']['input'];
  /** The password for the user. */
  password: Scalars['String']['input'];
  /** Optional confirmation of password for the user, and if present, the value must match the value of the `password` field. */
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the user. Must be in E.164 format including leading `+` and country code. */
  phoneNumber: Scalars['String']['input'];
  /** The timezone of the user. Must be a valid timezone name (i.e. "America/Vancouver"). */
  timezone: Scalars['String']['input'];
};

export type CustomerAccount = {
  __typename?: 'CustomerAccount';
  /** Shopify Customer ID. */
  id: Scalars['ID']['output'];
  /** Order information of the user. */
  orders: Array<Order>;
  /** Payment information of the user. returns all payment methods found */
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  shippingAddress?: Maybe<Address>;
  /** Subscription information of the user. */
  subscription?: Maybe<Subscription>;
  /** Subscription information of the user. */
  upcomingOrder?: Maybe<Order>;
};

export type File = {
  __typename?: 'File';
  /** The status of the file asset. */
  assetStatus: AssetStatus;
  /** The content type of the file. */
  contentType?: Maybe<Scalars['String']['output']>;
  /** The ID of the file. */
  id: Scalars['ID']['output'];
  /** The name of the file. */
  name: Scalars['String']['output'];
  /** The type (image, video, etc.) of file. */
  type: FileType;
  /** The method to upload the file asset. */
  uploadMethod?: Maybe<FileUploadMethod>;
  /** The URL used to upload the file asset. */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** The uploader of the file. */
  uploader: User;
  /** The ID of the uploader. */
  uploaderId: Scalars['String']['output'];
  /**
   * The URL used to download the file asset.
   * When `raw` is omitted or set to `false`, the returned value is an URL pointing to an endpoint on the API server,
   * which when visited will use HTTP 302 response to redirect the request to the actual asset URL;
   * When `raw` is set to `true`, the returned value is an URL pointing directly to the raw asset.
   */
  url?: Maybe<Scalars['String']['output']>;
};

export type FileUrlArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
  variant: FileImageVariant;
};

export enum FileImageVariant {
  Original = 'ORIGINAL',
  Size_40x40 = 'SIZE_40x40',
  Size_80x80 = 'SIZE_80x80',
  Size_120x120 = 'SIZE_120x120',
  Size_160x160 = 'SIZE_160x160',
}

export enum FileType {
  Image = 'IMAGE',
}

export enum FileUploadMethod {
  PostMultipartWithFile = 'POST_MULTIPART_WITH_FILE',
}

export type FindHealthFactorByPlanIdsInput = {
  /** The action plan IDs to retrieve health factors for. When omitted, all health factors from all plans will be returned. */
  actionPlanIds: Array<Scalars['String']['input']>;
};

export type FindLearningResourceByIdInput = {
  learningResourceId: Scalars['String']['input'];
};

export type FindLearningResourcesInput = {
  context: Array<LearningResourceContext>;
  matchContext?: InputMaybe<LearningResourceContextMatchMode>;
};

export type FormattedAge = {
  __typename?: 'FormattedAge';
  /** The number of years for a given age. */
  months: Scalars['Int']['output'];
  /** The remaining number of months for a given age. */
  years: Scalars['Int']['output'];
};

export type GenericResponse = {
  __typename?: 'GenericResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GetAccessTokenInput = {
  /** Get access token for this email. */
  email: Scalars['String']['input'];
  /** Get access token with this password. This field is required for 'Authentication' token type. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Get access token of this type. */
  type: AccessTokenType;
};

export type GetCustomerOrderInput = {
  /** Get Order Summary by Id */
  orderId: Scalars['Float']['input'];
};

export type GetHealthFactorInput = {
  /** Get healthfactor by id */
  healthfactorId: Scalars['String']['input'];
};

export type GetSurveyAssessmentInput = {
  /** Get assessment by this submission ID. */
  submissionId: Scalars['String']['input'];
};

export type GetSurveyCategoryAssessmentInput = {
  /** Get category assessment by this category ID. */
  categoryId: Scalars['String']['input'];
  /** Get category assessment by this submission ID. */
  submissionId: Scalars['String']['input'];
};

export type GetSurveyInput = {
  /** Get survey by this ID. This parameter has precedence over `key`. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Get survey by this key */
  key?: InputMaybe<Scalars['String']['input']>;
};

export type GetUserSurveySubmissionInput = {
  /** The ID of the submission. This parameter has precedence over `surveyId`. */
  submissionId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the survey. If specified, the latest submission for the survey will be returned. */
  surveyId?: InputMaybe<Scalars['String']['input']>;
};

export type HealthFactor = {
  __typename?: 'HealthFactor';
  benefits?: Maybe<Scalars['String']['output']>;
  emergingResearch?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  impactLevel?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Media>;
  questionId: Scalars['String']['output'];
  recommendationDescription?: Maybe<Scalars['String']['output']>;
  recommendationTitle?: Maybe<Scalars['String']['output']>;
  recommendedResponse?: Maybe<Scalars['String']['output']>;
  references: Array<Reference>;
  researchSnack?: Maybe<ResearchSnack>;
  tips?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HealthFactorAdjustment = {
  __typename?: 'HealthFactorAdjustment';
  default: Scalars['Boolean']['output'];
  emergingResearch: Scalars['Boolean']['output'];
  healthFactorAssessment?: Maybe<HealthFactorAssessment>;
  healthFactorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  impactLevel?: Maybe<ActionPlanImpactLevel>;
  impactValue: Scalars['Float']['output'];
  recommended: Scalars['Boolean']['output'];
  recommendedResponse: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
};

export type HealthFactorAssessment = {
  __typename?: 'HealthFactorAssessment';
  answerId: Scalars['String']['output'];
  categoryAssessment?: Maybe<CategoryAssessment>;
  healthFactor?: Maybe<HealthFactor>;
  id: Scalars['ID']['output'];
  meetsRequirements: Scalars['Boolean']['output'];
};

export type LabAssessment = {
  __typename?: 'LabAssessment';
  bioAge: Scalars['Float']['output'];
  chronologicalAge: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  deltaAge: Scalars['Float']['output'];
  /** The bioAge, as a count of years and months. */
  formattedBioAge: FormattedAge;
  /** The chronologicalAge, as a count of years and months. */
  formattedChronologicalAge: FormattedAge;
  /** The deltaAge, as a count of years and months. */
  formattedDeltaAge: FormattedAge;
  id: Scalars['ID']['output'];
  /**
   * Find lab result metrics for this LabAssessment
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  labResultMetrics: Array<LabResultMetric>;
  /**
   * The LabSubmission associated to this LabAssessment
   *
   * #### Errors
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **Unauthorized**
   *
   * - `extensions.code`: `UNAUTHORIZED`
   */
  labSubmission: LabSubmission;
  /** The URL of the lab assessment report. */
  reportUrl: Scalars['String']['output'];
};

export type LabAssessmentLabResultMetricsArgs = {
  metricTypes?: InputMaybe<Array<LabResultMetricTypeEnum>>;
};

export type LabResultMetric = {
  __typename?: 'LabResultMetric';
  id: Scalars['ID']['output'];
  percentile: Scalars['Float']['output'];
  type: LabResultMetricTypeEnum;
};

export enum LabResultMetricTypeEnum {
  TallyCohortAgePercentile = 'TallyCohortAgePercentile',
  TallyGeneralAgePercentile = 'TallyGeneralAgePercentile',
}

export type LabStatus = {
  __typename?: 'LabStatus';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: LabSubmissionStatusEnum;
};

export type LabSubmission = {
  __typename?: 'LabSubmission';
  id: Scalars['ID']['output'];
  /**
   * The LabAssessment associated to this LabSubmission
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   */
  labAssessment?: Maybe<LabAssessment>;
  labAssessmentId?: Maybe<Scalars['String']['output']>;
  /** Indicate if this LabSubmission has results */
  labRecord?: Maybe<LabSubmissionRecord>;
  /**
   * Get the LabStatuses for this LabSubmission
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  labStatuses: Array<LabStatus>;
  registeredDate: Scalars['DateTime']['output'];
  registrationId: Scalars['String']['output'];
  status: LabSubmissionStatusEnum;
  surveySubmissionId?: Maybe<Scalars['String']['output']>;
  /**
   * The `TestPeriod` associated with this `labSubmission`.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  testPeriod: TestPeriod;
  userId: Scalars['String']['output'];
  /** The `UserSurveySubmission` associated with this `labSubmission`. */
  userSurveySubmission?: Maybe<UserSurveySubmission>;
};

export type LabSubmissionInput = {
  labSubmissionId: Scalars['String']['input'];
};

export type LabSubmissionRecord = {
  __typename?: 'LabSubmissionRecord';
  hasResult: Scalars['Boolean']['output'];
  hasViewedResultStory: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export enum LabSubmissionStatusEnum {
  Canceled = 'Canceled',
  DnaExtraction2ndTryAccepted = 'DNAExtraction2ndTryAccepted',
  DnaExtraction2ndTryFailed = 'DNAExtraction2ndTryFailed',
  DnaExtractionAccepted = 'DNAExtractionAccepted',
  DnaExtractionFailed = 'DNAExtractionFailed',
  DataDelivered = 'DataDelivered',
  KitReceived = 'KitReceived',
  KitRegistered = 'KitRegistered',
  QcFailed = 'QCFailed',
  QcPassed = 'QCPassed',
  Ready = 'Ready',
  ReplacementRequested = 'ReplacementRequested',
  Sequencing2ndTryAccepted = 'Sequencing2ndTryAccepted',
  Sequencing2ndTryFailed = 'Sequencing2ndTryFailed',
  SequencingAccepted = 'SequencingAccepted',
  SequencingFailed = 'SequencingFailed',
}

export type LearningResource = {
  __typename?: 'LearningResource';
  author?: Maybe<LearningResourceAuthor>;
  body?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  publishedDate?: Maybe<Scalars['DateTime']['output']>;
  references: Array<Reference>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: LearningResourceType;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type LearningResourceAuthor = {
  __typename?: 'LearningResourceAuthor';
  avatarUrl: Scalars['String']['output'];
  credentials: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum LearningResourceContext {
  Dashboard = 'Dashboard',
  Learning = 'Learning',
  Lifestyle = 'Lifestyle',
}

export enum LearningResourceContextMatchMode {
  All = 'All',
  Some = 'Some',
}

export enum LearningResourceType {
  Article = 'Article',
  Audio = 'Audio',
  Video = 'Video',
}

export enum MeasurementUnit {
  Imperial = 'IMPERIAL',
  Metric = 'METRIC',
}

export type Media = {
  __typename?: 'Media';
  id: Scalars['ID']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type MultipleChoiceOption = {
  __typename?: 'MultipleChoiceOption';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefaultSelection?: Maybe<Scalars['Boolean']['output']>;
  /** Overrides Step array order, if present */
  nextStepId?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type MultipleChoiceScale = {
  __typename?: 'MultipleChoiceScale';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Apply email update for the user of the token.
   * After successful update, the user session will be invalidated and will need re-authentication.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  changeEmail: GenericResponse;
  /**
   * Create an access token.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **Forbidden**
   *
   * - `extensions.code`: `FORBIDDEN`
   *
   * **InvalidInput**
   *
   * - `extensions.code`: `BAD_REQUEST`
   * - `extensions.error.classCode`: `INVALID_INPUT`
   * - `extensions.error.invalidFields`: Error messages indexed by field name
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   */
  createAccessToken: AccessToken;
  /**
   * Create a discount and apply it to items in a subscription
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  createAndApplyDiscount: User;
  /**
   * Submit answers for the given CheckIn
   *
   * #### Errors
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  createCheckInAnswers: CheckIn;
  /**
   * Create a file.
   *
   * #### Errors
   *
   * **InvalidInput**
   *
   * - `extensions.code`: `BAD_REQUEST`
   * - `extensions.error.classCode`: `INVALID_INPUT`
   * - `extensions.error.invalidFields`: Error messages indexed by field name
   */
  createFile: File;
  /**
   * Create a lab submission.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  createLabSubmission: LabSubmission;
  /**
   * Create user account.
   *
   * #### Errors
   *
   * **InvalidInput**
   *
   * - `extensions.code`: `BAD_REQUEST`
   * - `extensions.error.classCode`: `INVALID_INPUT`
   * - `extensions.error.invalidFields`: Error messages indexed by field name
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   */
  createUserAccount: NewUserAccountInfo;
  /**
   * Mark the user as having completed action plan onboarding.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **Unauthorized**
   *
   * - `extensions.code`: `UNAUTHORIZED`
   */
  markActionPlanOnboardingComplete: User;
  /**
   * Pause items in a subscription
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  pauseSubscriptionItems: SubscriptionItem;
  /**
   * Re-request email change for the current user.
   *
   * #### Errors
   *
   * **InvalidInput**
   *
   * - `extensions.code`: `BAD_REQUEST`
   * - `extensions.error.classCode`: `INVALID_INPUT`
   * - `extensions.error.invalidFields`: Error messages indexed by field name
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   */
  reRequestEmailChange: GenericResponse;
  /**
   * Request account creation link via email.
   *
   * #### Errors
   *
   * **InvalidInput**
   *
   * - `extensions.code`: `BAD_REQUEST`
   * - `extensions.error.classCode`: `INVALID_INPUT`
   * - `extensions.error.invalidFields`: Error messages indexed by field name
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   */
  requestCreateAccountLink: GenericResponse;
  /**
   * Request email change for the current user.
   *
   * #### Errors
   *
   * **InvalidInput**
   *
   * - `extensions.code`: `BAD_REQUEST`
   * - `extensions.error.classCode`: `INVALID_INPUT`
   * - `extensions.error.invalidFields`: Error messages indexed by field name
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  requestEmailChange: GenericResponse;
  /**
   * Request password reset for the current user.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   */
  requestPasswordReset: GenericResponse;
  /**
   * Request verification for the current user.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **AccountAlreadyVerified**
   *
   * - `extensions.code`: `BAD_REQUEST`
   * - `extensions.error.classCode`: `ACCOUNT_ALREADY_VERIFIED`
   */
  requestVerification: GenericResponse;
  /**
   * Reset the password for the user of the token.
   * After successful update, the user session will be invalidated and will need re-authentication.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  resetPassword: GenericResponse;
  /**
   * Save the user survey answers for a survey. Existing submission for the user for the survey will be overwritten.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  saveUserSurveySubmission: UserSurveySubmission;
  /**
   * Trigger update payment method email.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  sendPaymentMethodUpdateLink: GenericResponse;
  /**
   * Update an action plan
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   *
   * **Unauthorized**
   *
   * - `extensions.code`: `UNAUTHORIZED`
   *
   * **BadRequest**
   *
   * - `extensions.code`: `BAD_REQUEST`
   */
  updateActionPlan: Array<UpdatedIds>;
  /**
   * Update a customers default shopify address.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  updateCustomerAccountShippingAddress: Address;
  /**
   * Update a lab submission.
   *
   * #### Errors
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **Unauthorized**
   *
   * - `extensions.code`: `UNAUTHORIZED`
   */
  updateLabSubmission: LabSubmission;
  /**
   * Applies changes to the subscription of the user
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  updateSubscription: User;
  /**
   * Update the current user.
   *
   * #### Errors
   *
   * **InvalidInput**
   *
   * - `extensions.code`: `BAD_REQUEST`
   * - `extensions.error.classCode`: `INVALID_INPUT`
   * - `extensions.error.invalidFields`: Error messages indexed by field name
   */
  updateUser: User;
  /**
   * Update the password for the current user.
   * After successful update, the current user session will be invalidated and will need re-authentication.
   *
   * #### Errors
   *
   * **InvalidInput**
   *
   * - `extensions.code`: `BAD_REQUEST`
   * - `extensions.error.classCode`: `INVALID_INPUT`
   * - `extensions.error.invalidFields`: Error messages indexed by field name
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   *
   * **Unauthorized**
   *
   * - `extensions.code`: `UNAUTHORIZED`
   */
  updateUserPassword: GenericResponse;
  /**
   * Update the profile for the current user.
   *
   * #### Errors
   *
   * **InvalidInput**
   *
   * - `extensions.code`: `BAD_REQUEST`
   * - `extensions.error.classCode`: `INVALID_INPUT`
   * - `extensions.error.invalidFields`: Error messages indexed by field name
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  updateUserProfile: UserProfile;
  /** Mark the user as having viewed their lab result story. */
  updateUserViewedLabResultStory: User;
  /**
   * Mark the user as having viewed their results history.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  updateViewedResultsHistory: User;
  /**
   * Mark the user as verified.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  verifyUser: GenericResponse;
};

export type MutationChangeEmailArgs = {
  input: ChangeEmailInput;
};

export type MutationCreateAccessTokenArgs = {
  input: GetAccessTokenInput;
};

export type MutationCreateAndApplyDiscountArgs = {
  input: CreateAndApplyDiscountInput;
};

export type MutationCreateCheckInAnswersArgs = {
  input: CreateCheckInAnswersInput;
};

export type MutationCreateFileArgs = {
  input: CreateFileInput;
};

export type MutationCreateLabSubmissionArgs = {
  input: CreateLabSubmissionInput;
};

export type MutationCreateUserAccountArgs = {
  input: CreateUserAccountInput;
};

export type MutationPauseSubscriptionItemsArgs = {
  input: PauseSubscriptionItemsInput;
};

export type MutationReRequestEmailChangeArgs = {
  input: ReRequestEmailChangeInput;
};

export type MutationRequestCreateAccountLinkArgs = {
  input: RequestCreateAccountLinkInput;
};

export type MutationRequestEmailChangeArgs = {
  input: RequestEmailChangeInput;
};

export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};

export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};

export type MutationSaveUserSurveySubmissionArgs = {
  input: SaveUserSurveySubmissionInput;
};

export type MutationUpdateActionPlanArgs = {
  input: UpdateActionPlanInput;
};

export type MutationUpdateCustomerAccountShippingAddressArgs = {
  input: UpdateShippingAddressInput;
};

export type MutationUpdateLabSubmissionArgs = {
  input: UpdateLabSubmissionInput;
};

export type MutationUpdateSubscriptionArgs = {
  subscriptionChanges: UpdateSubscriptionInput;
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationUpdateUserPasswordArgs = {
  input: UpdateUserPasswordInput;
};

export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};

export type MutationUpdateUserViewedLabResultStoryArgs = {
  input: UpdateUserViewedLabResultStoryInput;
};

export type MutationVerifyUserArgs = {
  input: VerifyUserInput;
};

export type NewUserAccountInfo = {
  __typename?: 'NewUserAccountInfo';
  /** The access token string. */
  authToken: Scalars['String']['output'];
  /** The ID of the associated User. */
  userId: Scalars['String']['output'];
};

export type Order = {
  __typename?: 'Order';
  /** Billing Address */
  billingAddress?: Maybe<Address>;
  /** Billing date */
  billingDate: Scalars['DateTime']['output'];
  /** Total discount defaulted to 0 */
  discountTotal: Scalars['Float']['output'];
  /** Discount Codes applied to the order */
  discounts: Array<OrderDiscount>;
  /** Shopify Order ID */
  id: Scalars['Float']['output'];
  /** The order name i.e. #123 */
  name: Scalars['String']['output'];
  /** Items in the order */
  orderItems: Array<OrderItem>;
  /** Adds payment method information */
  paymentMethod?: Maybe<PaymentMethod>;
  /** Shipping Address */
  shippingAddress?: Maybe<Address>;
  /** Shipping fees defaulted to 0 */
  shippingTotal: Scalars['Float']['output'];
  /** Order payment Status */
  status: Scalars['String']['output'];
  /** Total before taxes and discounts */
  subTotal: Scalars['Float']['output'];
  /** Total tax defaulted to 0 */
  taxTotal: Scalars['Float']['output'];
  /** Total price */
  total: Scalars['Float']['output'];
};

export type OrderDiscount = {
  __typename?: 'OrderDiscount';
  /** Discount category */
  category: Scalars['String']['output'];
  /** Product variant id if product discount */
  productVariantId?: Maybe<Scalars['String']['output']>;
  /** Total price */
  title: Scalars['String']['output'];
  /** Type of discount */
  type: Scalars['String']['output'];
  /** Discount value */
  value: Scalars['Float']['output'];
};

export type OrderItem = {
  __typename?: 'OrderItem';
  cost?: Maybe<Scalars['Float']['output']>;
  /** Item ID. */
  id: Scalars['ID']['output'];
  /** True when this item is a membership product (current or legacy) */
  isMembership?: Maybe<Scalars['Boolean']['output']>;
  /** Item title */
  productTitle: Scalars['String']['output'];
  /** Quantity */
  quantity: Scalars['Float']['output'];
  /** Item Status */
  status: Scalars['String']['output'];
  /** Price */
  unitPrice: Scalars['Float']['output'];
};

export type PauseSubscriptionItemsInput = {
  /** An array of productVariantIds to be paused for the given subscription */
  pauseProductVariantIds: Array<Scalars['String']['input']>;
  /** A subscription ID to identify which subscription will have items paused in its next order. */
  subscriptionId: Scalars['Float']['input'];
  /** An array of productVariantIds to be unpaused for the given subscription */
  unpauseProductVariantIds: Array<Scalars['String']['input']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  billingAddress: Address;
  brand?: Maybe<Scalars['String']['output']>;
  expiryMonth?: Maybe<Scalars['Float']['output']>;
  expiryYear?: Maybe<Scalars['Float']['output']>;
  /** Payment method shopify GID short id */
  id: Scalars['ID']['output'];
  inactive?: Maybe<Scalars['Boolean']['output']>;
  lastDigits?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Instrument type */
  type: PaymentMethodType;
};

export enum PaymentMethodType {
  Creditcard = 'creditcard',
  Paypal = 'paypal',
  Shoppay = 'shoppay',
}

export type Product = {
  __typename?: 'Product';
  /** Products can be categorized as testkit, supplement, membership, or other */
  category: ProductCategoryEnum;
  /** Order in which the product should be displayed */
  displayOrder: Scalars['Float']['output'];
  /** Visual theme in which the product should be displayed */
  displayTheme?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Product Thumbnail URL */
  thumbnail: Scalars['String']['output'];
  /** Uniquely identify a product with a semantic identifier */
  tid: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** Comma separated list of variant ids */
  variantIds: Array<Scalars['Float']['output']>;
};

export enum ProductCategoryEnum {
  Membership = 'membership',
  Other = 'other',
  Supplement = 'supplement',
  Testkit = 'testkit',
}

export enum ProductPackageTypeEnum {
  Bottle = 'bottle',
  Other = 'other',
  Pouch = 'pouch',
}

export type ProductVariant = {
  __typename?: 'ProductVariant';
  id: Scalars['ID']['output'];
  packageType: ProductPackageTypeEnum;
  price: Scalars['Float']['output'];
  product?: Maybe<Product>;
  productId: Scalars['Float']['output'];
  sku: Scalars['String']['output'];
  /** Uniquely identify product variant with a semantic identifier */
  tid: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: ProductVariantTypeEnum;
};

export enum ProductVariantTypeEnum {
  Single = 'single',
  Subscription = 'subscription',
}

export type PromotionalBanner = {
  __typename?: 'PromotionalBanner';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isBannerActive: Scalars['Boolean']['output'];
  textColor?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /**
   * Returns the requested CheckIn.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  checkIn?: Maybe<CheckIn>;
  /**
   * Returns the currently active CheckIn for the user's currently active TestPeriod, if available.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  currentCheckIn?: Maybe<CheckIn>;
  /**
   * Returns the currently active TestPeriod, if available.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  currentTestPeriod?: Maybe<TestPeriod>;
  /** Fetch a file by ID. */
  file: File;
  /**
   * Returns a discount.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  getDiscount: ValidatedDiscount;
  /**
   * Returns simulated discounts.
   *
   * #### Errors
   *
   * **BadRequest**
   *
   * - `extensions.code`: `BAD_REQUEST`
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  getSimulatedDiscounts: SimulatedDiscountsResponse;
  /** Failed to retrieve healthfactor by id. */
  healthFactor?: Maybe<HealthFactor>;
  /**
   * Find a lab submission by its ID.
   *
   * #### Errors
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **Unauthorized**
   *
   * - `extensions.code`: `UNAUTHORIZED`
   */
  labSubmission?: Maybe<LabSubmission>;
  /**
   * Retrieve a single learning resource by id
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   */
  learningResource: LearningResource;
  /**
   * Retrieve a list of learning resources.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  learningResources: Array<LearningResource>;
  /** Fetch the current user. */
  me: User;
  /**
   * Fetch order
   *
   * #### Errors
   *
   * **BadRequest**
   *
   * - `extensions.code`: `BAD_REQUEST`
   */
  order?: Maybe<Order>;
  /**
   * Fetch a promotional banner by ID.
   *
   * #### Errors
   *
   * **InvalidInput**
   *
   * - `extensions.code`: `BAD_REQUEST`
   * - `extensions.error.classCode`: `INVALID_INPUT`
   * - `extensions.error.invalidFields`: Error messages indexed by field name
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   */
  promotionalBanner?: Maybe<PromotionalBanner>;
  /**
   * Search user by email.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **InternalServerError**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   */
  searchAccount: UserSearchResult;
  /**
   * Fetch store objects
   *
   * #### Errors
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   */
  store?: Maybe<Store>;
  /**
   * Fetch a survey.
   *
   * #### Errors
   *
   * **InvalidInput**
   *
   * - `extensions.code`: `BAD_REQUEST`
   * - `extensions.error.classCode`: `INVALID_INPUT`
   * - `extensions.error.invalidFields`: Error messages indexed by field name
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   */
  survey?: Maybe<Survey>;
  /**
   * Fetch survey assessment for the current user.
   *
   * #### Errors
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **Unauthorized**
   *
   * - `extensions.code`: `UNAUTHORIZED`
   */
  surveyAssessment?: Maybe<SurveyAssessment>;
  /**
   * Fetch survey category assessment for the current user.
   *
   * #### Errors
   *
   * **NotFound**
   *
   * - `extensions.code`: `NOT_FOUND`
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **Unauthorized**
   *
   * - `extensions.code`: `UNAUTHORIZED`
   */
  surveyCategoryAssessment?: Maybe<CategoryAssessment>;
  /**
   * Returns the requested TestPeriod.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  testPeriod?: Maybe<TestPeriod>;
  /**
   * Returns the a CheckIn for for the specified TestPeriod and on the specified date, if available.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  testPeriodCheckIn?: Maybe<CheckIn>;
  /**
   * Fetch a single user survey submission.
   *
   * #### Errors
   *
   * **InvalidInput**
   *
   * - `extensions.code`: `BAD_REQUEST`
   * - `extensions.error.classCode`: `INVALID_INPUT`
   * - `extensions.error.invalidFields`: Error messages indexed by field name
   *
   * **Forbidden**
   *
   * - `extensions.code`: `FORBIDDEN`
   */
  userSurveySubmission?: Maybe<UserSurveySubmission>;
  /**
   * Returns the trends of lifestyle score and delta age for the current user
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   *
   * **InvalidInput**
   *
   * - `extensions.code`: `BAD_REQUEST`
   * - `extensions.error.classCode`: `INVALID_INPUT`
   * - `extensions.error.invalidFields`: Error messages indexed by field name
   */
  userTrends: Array<UserTrend>;
};

export type QueryCheckInArgs = {
  input: CheckInInput;
};

export type QueryFileArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetDiscountArgs = {
  code: Scalars['String']['input'];
};

export type QueryGetSimulatedDiscountsArgs = {
  input: SimulatedDiscountsInput;
};

export type QueryHealthFactorArgs = {
  input: GetHealthFactorInput;
};

export type QueryLabSubmissionArgs = {
  input: LabSubmissionInput;
};

export type QueryLearningResourceArgs = {
  input: FindLearningResourceByIdInput;
};

export type QueryLearningResourcesArgs = {
  input: FindLearningResourcesInput;
};

export type QueryOrderArgs = {
  input: GetCustomerOrderInput;
};

export type QuerySearchAccountArgs = {
  email: Scalars['String']['input'];
};

export type QuerySurveyArgs = {
  input: GetSurveyInput;
};

export type QuerySurveyAssessmentArgs = {
  input: GetSurveyAssessmentInput;
};

export type QuerySurveyCategoryAssessmentArgs = {
  input: GetSurveyCategoryAssessmentInput;
};

export type QueryTestPeriodArgs = {
  input: TestPeriodInput;
};

export type QueryTestPeriodCheckInArgs = {
  input: TestPeriodCheckInInput;
};

export type QueryUserSurveySubmissionArgs = {
  input: GetUserSurveySubmissionInput;
};

export type QueryUserTrendsArgs = {
  input: UserTrendsInputModel;
};

export type Question = {
  __typename?: 'Question';
  booleanConfiguration?: Maybe<QuestionBooleanConfiguration>;
  dateConfiguration?: Maybe<QuestionDateConfiguration>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longTextConfiguration?: Maybe<QuestionLongTextConfiguration>;
  matrixConfiguration?: Maybe<QuestionMatrixConfiguration>;
  multipleChoiceConfiguration?: Maybe<QuestionMultipleChoiceConfiguration>;
  numericConfiguration?: Maybe<QuestionNumericConfiguration>;
  questionType: QuestionTypeEnum;
  selectConfiguration?: Maybe<QuestionSelectConfiguration>;
  shortTextConfiguration?: Maybe<QuestionShortTextConfiguration>;
  text: Scalars['String']['output'];
};

export type QuestionBooleanConfiguration = {
  __typename?: 'QuestionBooleanConfiguration';
  defaultValue?: Maybe<Scalars['Boolean']['output']>;
  falsyOptionDescription?: Maybe<Scalars['String']['output']>;
  falsyOptionText?: Maybe<Scalars['String']['output']>;
  truthyOptionDescription?: Maybe<Scalars['String']['output']>;
  truthyOptionText?: Maybe<Scalars['String']['output']>;
};

export enum QuestionChoiceTypeEnum {
  MultiEnum = 'MultiEnum',
  SingleEnum = 'SingleEnum',
}

export type QuestionDateConfiguration = {
  __typename?: 'QuestionDateConfiguration';
  /** Must be in the format of YYYY-MM-DD */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Must be in the format of YYYY-MM-DD */
  maxDate?: Maybe<Scalars['String']['output']>;
  /** Must be in the format of YYYY-MM-DD */
  minDate?: Maybe<Scalars['String']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
};

export type QuestionLongTextConfiguration = {
  __typename?: 'QuestionLongTextConfiguration';
  defaultValue?: Maybe<Scalars['String']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  minLength?: Maybe<Scalars['Int']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
};

export type QuestionMatrix = {
  __typename?: 'QuestionMatrix';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type QuestionMatrixConfiguration = {
  __typename?: 'QuestionMatrixConfiguration';
  /** Order of array determines display order */
  options: Array<MultipleChoiceOption>;
  /** Order of array determines display order */
  subQuestions: Array<QuestionMatrix>;
};

export type QuestionMultipleChoiceConfiguration = {
  __typename?: 'QuestionMultipleChoiceConfiguration';
  options: Array<MultipleChoiceOption>;
  questionChoiceType: QuestionChoiceTypeEnum;
  scale?: Maybe<MultipleChoiceScale>;
};

export type QuestionNumericConfiguration = {
  __typename?: 'QuestionNumericConfiguration';
  defaultValue?: Maybe<Scalars['Int']['output']>;
  maxAmount?: Maybe<Scalars['Int']['output']>;
  minAmount?: Maybe<Scalars['Int']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  unitLabel?: Maybe<Scalars['String']['output']>;
};

export type QuestionSelectConfiguration = {
  __typename?: 'QuestionSelectConfiguration';
  /** Order of array determines display order */
  options: Array<Scalars['String']['output']>;
};

export type QuestionShortTextConfiguration = {
  __typename?: 'QuestionShortTextConfiguration';
  defaultValue?: Maybe<Scalars['String']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  minLength?: Maybe<Scalars['Int']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
};

export enum QuestionTypeEnum {
  DateEnum = 'DateEnum',
  LongTextEnum = 'LongTextEnum',
  MultipleChoiceEnum = 'MultipleChoiceEnum',
  NumericEnum = 'NumericEnum',
  SelectEnum = 'SelectEnum',
  ShortTextEnum = 'ShortTextEnum',
}

export type ReRequestEmailChangeInput = {
  /** The return URL after completing email change. */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  /** The email change verification token for the user. */
  token: Scalars['String']['input'];
};

export type Reference = {
  __typename?: 'Reference';
  id: Scalars['ID']['output'];
  labels: Array<Scalars['String']['output']>;
  publication?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type RequestCreateAccountLinkInput = {
  /** Optional delay in minutes before sending the email. */
  delay?: InputMaybe<Scalars['Float']['input']>;
  /** The email address of the user. */
  email: Scalars['String']['input'];
};

export type RequestEmailChangeInput = {
  /** The new email address of the user. */
  newEmail: Scalars['String']['input'];
  /** The return URL after completing email change. */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type RequestPasswordResetInput = {
  /** The email address of the user. */
  email: Scalars['String']['input'];
  /** The return URL after completing password reset. */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ResearchSnack = {
  __typename?: 'ResearchSnack';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ResetPasswordInput = {
  /** The new password for the user. */
  newPassword: Scalars['String']['input'];
  /** The password reset token for the user. */
  token: Scalars['String']['input'];
};

export type SaveUserSurveySubmissionAnswerInput = {
  /** The date answer value for this question. Only applicable if `questionType` is a date. Must be in the format of YYYY-MM-DD. */
  answerDate?: InputMaybe<Scalars['String']['input']>;
  /** The numeric answer value of this question. Only applicable if `questionType` is a number. */
  answerNumeric?: InputMaybe<Scalars['Int']['input']>;
  /** The option answer value of this question. Only applicable if `questionType` is a choice. */
  answerOptionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The string answer value of this question. Only applicable if `questionType` is a string. */
  answerText?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the question. */
  questionId: Scalars['String']['input'];
  /** The type of the question. */
  questionType: QuestionTypeEnum;
};

export type SaveUserSurveySubmissionInput = {
  /** The answers of the survey from the user. */
  answers: Array<SaveUserSurveySubmissionAnswerInput>;
  /** The ID of the `labSubmission` to associate with this `userSurveySubmission`. */
  labSubmissionId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the survey. */
  surveyId: Scalars['String']['input'];
  /** The key of the survey. */
  surveyKey: Scalars['String']['input'];
};

export type SimulatedDiscount = {
  __typename?: 'SimulatedDiscount';
  category: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** PERCENTAGE | FIXED_AMOUNT | DISCOUNT_AUTOMATIC_BASIC */
  type: Scalars['String']['output'];
  value: Scalars['Float']['output'];
  variantId?: Maybe<Scalars['String']['output']>;
};

export type SimulatedDiscountError = {
  __typename?: 'SimulatedDiscountError';
  code: Scalars['String']['output'];
  discount: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type SimulatedDiscountsInput = {
  /** discount codes considered for the simulate discounts process */
  discountCodes: Array<Scalars['String']['input']>;
  /** A subscription ID to identify which subscription will have items paused in its next order. */
  subscriptionId: Scalars['Float']['input'];
  /** variantIds considered for the simulate discounts process */
  variantIds: Array<Scalars['String']['input']>;
};

export type SimulatedDiscountsResponse = {
  __typename?: 'SimulatedDiscountsResponse';
  discountErrors?: Maybe<Array<SimulatedDiscountError>>;
  discounts: Array<SimulatedDiscount>;
};

export type Step = {
  __typename?: 'Step';
  id: Scalars['ID']['output'];
  question: Question;
  stepType: StepTypeEnum;
};

export enum StepTypeEnum {
  QuestionEnum = 'QuestionEnum',
}

export type Store = {
  __typename?: 'Store';
  productVariants: Array<ProductVariant>;
  products: Array<Product>;
};

export type Subscription = {
  __typename?: 'Subscription';
  discounts: Array<SubscriptionDiscount>;
  /** The userʼs Shopify Customer email. */
  email: Scalars['String']['output'];
  /** Indicates if the user has a currently active subscription. */
  hasActiveSubscription: Scalars['Boolean']['output'];
  /** Indicates if the user has an active membership or a membership purchase during the last 30 days */
  hasMembership: Scalars['Boolean']['output'];
  /** Indicates if the user has a has ever had an active subscription. */
  hasSubscribed: Scalars['Boolean']['output'];
  /** The ID of the first SubscriptionItem in the items array. */
  id: Scalars['ID']['output'];
  /** An array of SubscriptionItems, indicating the types of active subscriptions associated with the user. */
  items: Array<SubscriptionItem>;
  /** A number indicating the total amount to be billed. */
  nextBillingAmount?: Maybe<Scalars['Float']['output']>;
  /** A Date string in ISO format, indicating when the customer will next be billed. */
  nextBillingAttemptAt?: Maybe<Scalars['String']['output']>;
  /** A Date string in YYYY-MM-DD format, indicated the estimated date the userʼs next shipment will be dispatched */
  nextEstimateShipOn?: Maybe<Scalars['String']['output']>;
  /** An array of Subscription Items, indicating the items to be paused for the next user order. */
  pausedProductVariantIds: Array<Scalars['String']['output']>;
  /** The payment method ID associated with the subscription. */
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  /** The subscription shipping address. */
  shippingAddress: Address;
  /** The userʼs Shopify Customer ID. */
  shopifyCustomerId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type SubscriptionDiscount = {
  __typename?: 'SubscriptionDiscount';
  amount: Scalars['Float']['output'];
  category: Scalars['String']['output'];
  productVariantId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** All subscription discounts are a fixed amount. */
  type: Scalars['String']['output'];
};

export type SubscriptionItem = {
  __typename?: 'SubscriptionItem';
  id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  variantId: Scalars['String']['output'];
  variantSku: Scalars['String']['output'];
};

export type Survey = {
  __typename?: 'Survey';
  categories: Array<Category>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  questions: Array<Question>;
};

export type SurveyAssessment = {
  __typename?: 'SurveyAssessment';
  /** The available action plans of the user related to this assessment. */
  actionPlans: Array<ActionPlan>;
  categories: Array<CategoryAssessment>;
  createdAt: Scalars['DateTime']['output'];
  /** The heal factors associated with the given list of action plan IDs. */
  healthFactors: Array<HealthFactor>;
  id: Scalars['ID']['output'];
  lifestyleScore?: Maybe<Scalars['Float']['output']>;
  maxLifestyleScore: Scalars['Float']['output'];
  /**
   * The selected action plan of the user related to this assessment.
   * @deprecated only 1 plan is generated with customizable items, use actionPlans and check active flag instead
   */
  selectedActionPlan?: Maybe<ActionPlan>;
  status: AssessmentStatusEnum;
  submissionId: Scalars['String']['output'];
  survey: Survey;
  surveyId: Scalars['String']['output'];
  surveyKey: Scalars['String']['output'];
  /** The user survey submission record related to this assessment. */
  userSurveySubmission: UserSurveySubmission;
};

export type SurveyAssessmentHealthFactorsArgs = {
  input?: InputMaybe<FindHealthFactorByPlanIdsInput>;
};

export type TestPeriod = {
  __typename?: 'TestPeriod';
  /**
   * The array of weeks within a TestPeriod where a CheckIn could have been completed.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  checkInStats: Array<CheckInStat>;
  /** The current count of consecutively-completed check-ins for this test period. */
  checkInStreakCount: Scalars['Float']['output'];
  /**
   * The array of questions for the given check-in.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  checkIns: Array<CheckIn>;
  /** The current count of all completed check-ins for this test period. */
  completedCheckIns: Scalars['Float']['output'];
  /** The earliest date on which check-in may start. This is a date string in the format of YYYY-MM-DD, and is denoted in the user's local timezone. If this value is null then it means check-in can not start. */
  earliestCheckInStartOn?: Maybe<Scalars['String']['output']>;
  /** The test period's end date */
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The test period's ID */
  id: Scalars['String']['output'];
  /** The ID of the labSubmission the testPeriod is associated with */
  labSubmissionId?: Maybe<Scalars['String']['output']>;
  /** The test period's start date */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current count of all check-ins for this test period. */
  totalCheckIns: Scalars['Float']['output'];
};

export type TestPeriodCheckInStatsArgs = {
  input?: InputMaybe<CheckInsInput>;
};

export type TestPeriodCheckInsArgs = {
  input?: InputMaybe<CheckInsInput>;
};

export type TestPeriodCheckInInput = {
  date: Scalars['String']['input'];
  testPeriodId: Scalars['String']['input'];
};

export type TestPeriodInput = {
  id: Scalars['String']['input'];
};

export type UpdateActionPlanInput = {
  /** Active status flag */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Items of the plan to update */
  adjustments?: InputMaybe<Array<UpdateActionPlanItemInput>>;
  /** Action plan to update ID */
  id: Scalars['String']['input'];
};

export type UpdateActionPlanItemInput = {
  /** Action plan item to update ID */
  id: Scalars['String']['input'];
  /** Selected status flag */
  selected: Scalars['Boolean']['input'];
};

export type UpdateLabSubmissionInput = {
  labSubmissionId: Scalars['String']['input'];
  registrationDate?: InputMaybe<Scalars['String']['input']>;
  registrationId?: InputMaybe<Scalars['String']['input']>;
  surveySubmissionId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateShippingAddressInput = {
  /** Street Address. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Details. i.e. Apartment, Suite, Floor, etc */
  addressDetail?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionInput = {
  /** Array of discount codes to be applied to the user subscription */
  addDiscountCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Array of products to be added to the user's subscription */
  addProductVariantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Array of discount codes to be removed from the user subscription */
  removeDiscountCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Array of products to be removed from the user's subscription */
  removeProductVariantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** New status of the subscription */
  updateStatusTo?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  /** The ID of the image file to be used as avatar for the user. Set this to `null` to clear the avatar of the user. */
  avatarFileId?: InputMaybe<Scalars['String']['input']>;
  /** If the user would receive email notification or not. */
  receiveEmailNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the user would receive SMS notification or not. */
  receiveSMSNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** The timezone of the user. Must be a valid timezone name (i.e. "America/Vancouver"). */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserPasswordInput = {
  /** The current password for the user. */
  currentPassword: Scalars['String']['input'];
  /** The new password for the user. */
  newPassword: Scalars['String']['input'];
  /** Optional confirmation of new password for the user, and if present, the value must match the value of the `newPassword` field. */
  newPasswordConfirmation?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserProfileInput = {
  /** The birth sex of the user. */
  birthSex?: InputMaybe<BirthSex>;
  /** The birthday of the user. Must be in the format of YYYY-MM-DD. */
  birthday?: InputMaybe<Scalars['String']['input']>;
  /** Setting this attribute has no effect. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the user. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The height of the user in centimeters. */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** The display unit of the height of the user. */
  heightDisplayUnit?: InputMaybe<MeasurementUnit>;
  /** The last name of the user. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the user. Must be in E.164 format including leading `+` and country code. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The pronouns of the user. */
  pronouns?: InputMaybe<Scalars['String']['input']>;
  /** The birth weight of the user in kilograms. */
  weight?: InputMaybe<Scalars['Float']['input']>;
  /** The display unit of the weight of the user. */
  weightDisplayUnit?: InputMaybe<MeasurementUnit>;
};

export type UpdateUserViewedLabResultStoryInput = {
  /** Ths ID of the lab submission to mark the user having viewed result story of. If omitted, the most recently submitted lab submission will be used. */
  labSubmissionId?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  /** The date the user applied a cancelation discount */
  appliedDiscountCancelationOn?: Maybe<Scalars['DateTime']['output']>;
  /** The avatar file attached to this user. */
  avatar?: Maybe<File>;
  /** The avatar URL for this user. This URL is different from the URL from `user.avatar.url` which is a general file URL with expiration, whereas this `avatarURL` is an avatar-specific, non-expiring URL that also basically never changes. */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Indicate if the user has completed an action */
  completedActionPlanOnboarding: Scalars['Boolean']['output'];
  /** Indicates the total number of Check-Ins a User has ever completed. */
  completedCheckIns: Scalars['Int']['output'];
  /**
   * The customer account of this user
   *
   * #### Errors
   *
   * **Unauthorized**
   *
   * - `extensions.code`: `UNAUTHORIZED`
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  customerAccount?: Maybe<CustomerAccount>;
  hasReceivedLabResults: Scalars['Boolean']['output'];
  /** Indicates if the user has viewed results history or not. */
  hasViewedResultsHistory: Scalars['Boolean']['output'];
  /** The ID of the user. */
  id: Scalars['ID']['output'];
  /** Indicates if the user had failed to link a Klaviyo profile or not. */
  isKlaviyoProfileFailedToLink: Scalars['Boolean']['output'];
  /** Indicates if the user has a Klaviyo profile linked or not. */
  isKlaviyoProfileLinked: Scalars['Boolean']['output'];
  /** Indicates if the user account is verified or not. */
  isVerified: Scalars['Boolean']['output'];
  /** The reason the user had failed to link a Klaviyo profile */
  klaviyoProfileFailedToLinkReason?: Maybe<Scalars['String']['output']>;
  /**
   * Get a list of all LabSubmissions on this user
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  labSubmissions: Array<LabSubmission>;
  /** Return the number of lab submissions with result for the user. */
  labSubmissionsWithResultCount: Scalars['Int']['output'];
  /**
   * The user's most recent `LabSubmission`. Unlike `mostRecentLabSubmissionWithResults`, this may or may not have an associated `LabAssessment`.
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  mostRecentLabSubmission?: Maybe<LabSubmission>;
  /**
   * The user's most recent `LabSubmission` that has results (i.e. has an associated `LabAssessment`).
   *
   * #### Errors
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  mostRecentLabSubmissionWithResults?: Maybe<LabSubmission>;
  /** The Shopify Multipass URL for this user. This field will always be null for users other than the currently logged-in user. Shopify Multipass URL expires in 15 minutes so this URL should be re-queried immediately prior to use. This URL should not be cached after use. */
  multipassUrl?: Maybe<Scalars['String']['output']>;
  /** Indicates if the user want to receive email notification or not. */
  receiveEmailNotification: Scalars['Boolean']['output'];
  /** Indicates if the user want to receive SMS notification or not. */
  receiveSMSNotification: Scalars['Boolean']['output'];
  /**
   * Returns subscription object from Seals API.
   *
   * #### Errors
   *
   * **Unauthorized**
   *
   * - `extensions.code`: `UNAUTHORIZED`
   *
   * **ServiceFailed**
   *
   * - `extensions.code`: `INTERNAL_SERVER_ERROR`
   * - `extensions.error.classCode`: `SERVICE_FAILED`
   * - `extensions.error.serviceErrors`: Error messages indexed by service name
   */
  subscription?: Maybe<Subscription>;
  /**
   * All survey submission IDs of the user.
   *
   * #### Errors
   *
   * **Unauthorized**
   *
   * - `extensions.code`: `UNAUTHORIZED`
   */
  surveySubmissionIds: Array<Scalars['String']['output']>;
  /** The timezone of the user. */
  timezone?: Maybe<Scalars['String']['output']>;
  /** The profile record related to this user. */
  userProfile?: Maybe<UserProfile>;
};

export type UserAvatarUrlArgs = {
  variant: FileImageVariant;
};

export type UserMultipassUrlArgs = {
  returnUrl: Scalars['String']['input'];
};

export type UserSurveySubmissionIdsArgs = {
  input: UserSurveySubmissionIdsInput;
};

export type UserCategoryTrend = {
  __typename?: 'UserCategoryTrend';
  /** The ID of the survey category */
  categoryId: Scalars['String']['output'];
  /** The percentage of the survey category score against the max category score */
  categoryScorePercentage: Scalars['Float']['output'];
  /** The title of the survey category assessment */
  title: Scalars['String']['output'];
};

export type UserProfile = {
  __typename?: 'UserProfile';
  /** The birth sex of the user. */
  birthSex?: Maybe<BirthSex>;
  /** The birthday of the user. In the format of YYYY-MM-DD. */
  birthday?: Maybe<Scalars['String']['output']>;
  /** The email of the user. */
  email?: Maybe<Scalars['String']['output']>;
  /** The first name of the user. */
  firstName?: Maybe<Scalars['String']['output']>;
  formattedBirthSex: Scalars['String']['output'];
  formattedBirthday?: Maybe<Scalars['String']['output']>;
  formattedHeight?: Maybe<Scalars['String']['output']>;
  formattedPhoneNumber?: Maybe<Scalars['String']['output']>;
  formattedWeight?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  /** The height of the user in centimeters. */
  height?: Maybe<Scalars['Float']['output']>;
  /** The display unit of the height of the user. */
  heightDisplayUnit?: Maybe<MeasurementUnit>;
  /** The ID of the user profile. */
  id: Scalars['ID']['output'];
  initials: Scalars['String']['output'];
  /** The last name of the user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The phone number of the user. In E.164 format including `+` and country code. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The pronouns of the user. */
  pronouns?: Maybe<Scalars['String']['output']>;
  /** The user associated with the profile. */
  user: User;
  /** The ID of the user. */
  userId: Scalars['String']['output'];
  /** The birth weight of the user in kilograms. */
  weight?: Maybe<Scalars['Float']['output']>;
  /** The display unit of the weight of the user. */
  weightDisplayUnit?: Maybe<MeasurementUnit>;
};

export type UserSearchResult = {
  __typename?: 'UserSearchResult';
  /** Search result */
  hasAccount: Scalars['Boolean']['output'];
  /** Current subscription status */
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
};

export type UserSurveySubmission = {
  __typename?: 'UserSurveySubmission';
  /** The answers of the survey submission. */
  answers: Array<UserSurveySubmissionAnswer>;
  /** The creation timestamp of the survey submission. */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the survey submission. */
  id: Scalars['ID']['output'];
  /** The survey record related to this submission. */
  survey: Survey;
  /** The assessment record related to this submission. */
  surveyAssessment?: Maybe<SurveyAssessment>;
  /** The ID of the survey of the survey submission. */
  surveyId: Scalars['String']['output'];
  /** The key of the survey of the survey submission. */
  surveyKey: Scalars['String']['output'];
  /** The user record related to this submission. */
  user: User;
  /** The ID of the user of the survey submission. */
  userId: Scalars['String']['output'];
};

export type UserSurveySubmissionAnswer = {
  __typename?: 'UserSurveySubmissionAnswer';
  /** The date answer of the question. Only applicable if `questionType` is a date. In the format of YYYY-MM-DD. */
  answerDate?: Maybe<Scalars['String']['output']>;
  /** The numeric answer of the question. Only applicable if `questionType` is a number. */
  answerNumeric?: Maybe<Scalars['Int']['output']>;
  /** The option answer of the question. Only applicable if `questionType` is a choice. */
  answerOptionIds?: Maybe<Array<Scalars['String']['output']>>;
  /** The string answer of the question. Only applicable if `questionType` is a string. */
  answerText?: Maybe<Scalars['String']['output']>;
  /** The ID of the question. */
  questionId: Scalars['String']['output'];
};

export type UserSurveySubmissionIdsInput = {
  /** The ID of the survey. */
  surveyId: Scalars['String']['input'];
};

export type UserTrend = {
  __typename?: 'UserTrend';
  /** Creation date of the associated SurveyAssessment */
  assessmentCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Category trends from associated SurveyAssessment */
  categories: Array<UserCategoryTrend>;
  /** Delta age from associated LabAssessment */
  deltaAge: Scalars['Float']['output'];
  /** Formatted delta age from associated LabAssessment */
  formattedDeltaAge: FormattedAge;
  /** The ID of the associated LabSubmission */
  labSubmissionId: Scalars['String']['output'];
  /** Lifestyle score from associated SurveyAssessment */
  lifestyleScorePercentage?: Maybe<Scalars['Float']['output']>;
  /** Registration date of the LabSubmission */
  registeredDate: Scalars['DateTime']['output'];
};

export type UserTrendsInputModel = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type ValidatedDiscount = {
  __typename?: 'ValidatedDiscount';
  discountCode?: Maybe<Scalars['String']['output']>;
};

export type VerifyUserInput = {
  /** The verification token for the user. */
  token: Scalars['String']['input'];
};

export type UpdatedIds = {
  __typename?: 'updatedIds';
  id: Scalars['String']['output'];
};

export type MarkVariables = Exact<{
  input: VerifyUserInput;
}>;

export type Mark = {
  __typename?: 'Mutation';
  verifyUser: {__typename?: 'GenericResponse'; message?: string | null; success: boolean};
};

export type CreateAuthenticationTokenMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type CreateAuthenticationTokenMutation = {
  __typename?: 'Mutation';
  accessToken: {__typename?: 'AccessToken'; token: string; userId?: string | null};
};

export type CreateFileMutationVariables = Exact<{
  input: CreateFileInput;
}>;

export type CreateFileMutation = {
  __typename?: 'Mutation';
  createFile: {
    __typename?: 'File';
    id: string;
    uploadUrl?: string | null;
    contentType?: string | null;
  };
};

export type CreateLabSubmissionMutationVariables = Exact<{
  input: CreateLabSubmissionInput;
}>;

export type CreateLabSubmissionMutation = {
  __typename?: 'Mutation';
  labSubmission: {__typename?: 'LabSubmission'; id: string};
};

export type UpdateLabSubmissionMutationVariables = Exact<{
  input: UpdateLabSubmissionInput;
}>;

export type UpdateLabSubmissionMutation = {
  __typename?: 'Mutation';
  labSubmission: {__typename?: 'LabSubmission'; id: string};
};

export type MarkActionPlanOnboardingCompleteVariables = Exact<{[key: string]: never}>;

export type MarkActionPlanOnboardingComplete = {
  __typename?: 'Mutation';
  markActionPlanOnboardingComplete: {
    __typename?: 'User';
    id: string;
    completedActionPlanOnboarding: boolean;
  };
};

export type RequestVerificationMutationVariables = Exact<{[key: string]: never}>;

export type RequestVerificationMutation = {
  __typename?: 'Mutation';
  requestVerification: {__typename?: 'GenericResponse'; message?: string | null; success: boolean};
};

export type SetTimeZoneVariables = Exact<{
  input: UpdateUserInput;
}>;

export type SetTimeZone = {
  __typename?: 'Mutation';
  updateUser: {__typename?: 'User'; id: string; timezone?: string | null};
};

export type UpdateViewedResultsHistoryVariables = Exact<{[key: string]: never}>;

export type UpdateViewedResultsHistory = {
  __typename?: 'Mutation';
  updateViewedResultsHistory: {__typename?: 'User'; hasViewedResultsHistory: boolean; id: string};
};

export type VerifyUserVariables = Exact<{
  input: VerifyUserInput;
}>;

export type VerifyUser = {
  __typename?: 'Mutation';
  verifyUser: {__typename?: 'GenericResponse'; message?: string | null; success: boolean};
};

export type MultipassUrlQueryVariables = Exact<{
  returnUrl: Scalars['String']['input'];
}>;

export type MultipassUrlQuery = {
  __typename?: 'Query';
  me: {__typename?: 'User'; id: string; multipassUrl?: string | null};
};

export type SurveyIdQueryVariables = Exact<{
  input: GetSurveyInput;
}>;

export type SurveyIdQuery = {
  __typename?: 'Query';
  survey?: {__typename?: 'Survey'; id: string} | null;
};

export type RequestEmailChangeVariables = Exact<{
  input: RequestEmailChangeInput;
}>;

export type RequestEmailChange = {
  __typename?: 'Mutation';
  requestEmailChange: {__typename?: 'GenericResponse'; success: boolean};
};

export type ActionPlanFragment = {
  __typename?: 'ActionPlan';
  id: string;
  active: boolean;
  adjustments: Array<{
    __typename?: 'HealthFactorAdjustment';
    id: string;
    healthFactorId?: string | null;
    selected: boolean;
    default: boolean;
    impactValue: number;
    impactLevel?: ActionPlanImpactLevel | null;
    recommended: boolean;
    recommendedResponse: string;
    emergingResearch: boolean;
    healthFactorAssessment?: {
      __typename?: 'HealthFactorAssessment';
      id: string;
      meetsRequirements: boolean;
      healthFactor?: {
        __typename?: 'HealthFactor';
        id: string;
        benefits?: string | null;
        tips?: string | null;
        imageUrl?: string | null;
        title?: string | null;
        recommendationDescription?: string | null;
      } | null;
      categoryAssessment?: {
        __typename?: 'CategoryAssessment';
        id: string;
        category: {__typename?: 'Category'; id: string; title: string; key: CategoryKeyEnum};
      } | null;
    } | null;
  }>;
};

export type CheckInFragment = {
  __typename?: 'CheckIn';
  id: string;
  completed: boolean;
  endedOn: string;
  startedOn: string;
};

export type ActionPlanPageQueryVariables = Exact<{[key: string]: never}>;

export type ActionPlanPageQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    completedActionPlanOnboarding: boolean;
    subscription?: {
      __typename?: 'Subscription';
      id: string;
      hasActiveSubscription: boolean;
      hasMembership: boolean;
    } | null;
    userProfile?: {__typename?: 'UserProfile'; id: string; firstName?: string | null} | null;
    mostRecentLabSubmission?: {
      __typename?: 'LabSubmission';
      id: string;
      userSurveySubmission?: {__typename?: 'UserSurveySubmission'; id: string} | null;
    } | null;
    mostRecentLabSubmissionWithResults?: {
      __typename?: 'LabSubmission';
      id: string;
      registeredDate: any;
      labAssessment?: {__typename?: 'LabAssessment'; deltaAge: number; id: string} | null;
      userSurveySubmission?: {
        __typename?: 'UserSurveySubmission';
        id: string;
        surveyAssessment?: {
          __typename?: 'SurveyAssessment';
          id: string;
          submissionId: string;
          actionPlans: Array<{
            __typename?: 'ActionPlan';
            id: string;
            active: boolean;
            adjustments: Array<{
              __typename?: 'HealthFactorAdjustment';
              id: string;
              healthFactorId?: string | null;
              selected: boolean;
              default: boolean;
              impactValue: number;
              impactLevel?: ActionPlanImpactLevel | null;
              recommended: boolean;
              recommendedResponse: string;
              emergingResearch: boolean;
              healthFactorAssessment?: {
                __typename?: 'HealthFactorAssessment';
                id: string;
                meetsRequirements: boolean;
                healthFactor?: {
                  __typename?: 'HealthFactor';
                  id: string;
                  benefits?: string | null;
                  tips?: string | null;
                  imageUrl?: string | null;
                  title?: string | null;
                  recommendationDescription?: string | null;
                } | null;
                categoryAssessment?: {
                  __typename?: 'CategoryAssessment';
                  id: string;
                  category: {
                    __typename?: 'Category';
                    id: string;
                    title: string;
                    key: CategoryKeyEnum;
                  };
                } | null;
              } | null;
            }>;
          }>;
        } | null;
      } | null;
    } | null;
  };
  currentCheckIn?: {
    __typename?: 'CheckIn';
    id: string;
    completed: boolean;
    endedOn: string;
    startedOn: string;
  } | null;
  currentTestPeriod?: {
    __typename?: 'TestPeriod';
    id: string;
    startedAt?: any | null;
    checkInStats: Array<{
      __typename?: 'CheckInStat';
      completed: boolean;
      endedOn: string;
      startedOn: string;
    }>;
  } | null;
};

export type ChangePasswordQueryVariables = Exact<{[key: string]: never}>;

export type ChangePasswordQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    userProfile?: {__typename?: 'UserProfile'; id: string; email?: string | null} | null;
  };
};

export type UpdateUserPasswordMutationVariables = Exact<{
  input: UpdateUserPasswordInput;
}>;

export type UpdateUserPasswordMutation = {
  __typename?: 'Mutation';
  updateUserPassword: {__typename?: 'GenericResponse'; success: boolean};
};

export type CheckInCheckInQuestionFragment = {
  __typename?: 'CheckInQuestion';
  actionItemTitle?: string | null;
  answerBoolean?: boolean | null;
  benefits?: string | null;
  context?: string | null;
  hitCount: number;
  id: string;
  imageUrl?: string | null;
  impactLevel?: string | null;
  tips?: string | null;
  title: string;
  healthFactor?: {__typename?: 'HealthFactor'; id: string; title?: string | null} | null;
};

export type CheckInCurrentTestPeriodCheckInFragment = {
  __typename?: 'CheckIn';
  completed: boolean;
  id: string;
  startedOn: string;
};

export type CheckInCurrentTestPeriodFragment = {
  __typename?: 'TestPeriod';
  checkInStreakCount: number;
  completedCheckIns: number;
  earliestCheckInStartOn?: string | null;
  id: string;
  startedAt?: any | null;
  checkInStats: Array<{
    __typename?: 'CheckInStat';
    completed: boolean;
    endedOn: string;
    startedOn: string;
  }>;
};

export type CheckInQueryVariables = Exact<{[key: string]: never}>;

export type CheckInQuery = {
  __typename?: 'Query';
  currentCheckIn?: {
    __typename?: 'CheckIn';
    actionItemsHitPercentage: number;
    endedOn: string;
    submittedAt?: any | null;
    completed: boolean;
    id: string;
    startedOn: string;
    questions: Array<{
      __typename?: 'CheckInQuestion';
      actionItemTitle?: string | null;
      answerBoolean?: boolean | null;
      benefits?: string | null;
      context?: string | null;
      hitCount: number;
      id: string;
      imageUrl?: string | null;
      impactLevel?: string | null;
      tips?: string | null;
      title: string;
      healthFactor?: {__typename?: 'HealthFactor'; id: string; title?: string | null} | null;
    }>;
  } | null;
  me: {
    __typename?: 'User';
    id: string;
    subscription?: {__typename?: 'Subscription'; hasActiveSubscription: boolean} | null;
    mostRecentLabSubmissionWithResults?: {
      __typename?: 'LabSubmission';
      id: string;
      userSurveySubmission?: {
        __typename?: 'UserSurveySubmission';
        id: string;
        surveyAssessment?: {
          __typename?: 'SurveyAssessment';
          id: string;
          selectedActionPlan?: {__typename?: 'ActionPlan'; id: string} | null;
        } | null;
      } | null;
    } | null;
  };
  currentTestPeriod?: {
    __typename?: 'TestPeriod';
    checkInStreakCount: number;
    completedCheckIns: number;
    earliestCheckInStartOn?: string | null;
    id: string;
    startedAt?: any | null;
    checkInStats: Array<{
      __typename?: 'CheckInStat';
      completed: boolean;
      endedOn: string;
      startedOn: string;
    }>;
  } | null;
};

export type CreateCheckInAnswersVariables = Exact<{
  input: CreateCheckInAnswersInput;
}>;

export type CreateCheckInAnswers = {
  __typename?: 'Mutation';
  createCheckInAnswers: {
    __typename?: 'CheckIn';
    actionItemsHitPercentage: number;
    completed: boolean;
    id: string;
    questions: Array<{
      __typename?: 'CheckInQuestion';
      answerBoolean?: boolean | null;
      hitCount: number;
      id: string;
    }>;
    testPeriod?: {
      __typename?: 'TestPeriod';
      checkInStreakCount: number;
      completedCheckIns: number;
      earliestCheckInStartOn?: string | null;
      id: string;
      startedAt?: any | null;
      checkInStats: Array<{
        __typename?: 'CheckInStat';
        completed: boolean;
        endedOn: string;
        startedOn: string;
      }>;
    } | null;
  };
};

export type CreateUserAccountMutationVariables = Exact<{
  input: CreateUserAccountInput;
}>;

export type CreateUserAccountMutation = {
  __typename?: 'Mutation';
  createUserAccount: {__typename?: 'NewUserAccountInfo'; authToken: string; userId: string};
};

export type UserAccountSearchVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type UserAccountSearch = {
  __typename?: 'Query';
  searchAccount: {
    __typename?: 'UserSearchResult';
    hasAccount: boolean;
    subscriptionStatus?: string | null;
  };
};

export type CheckInCardTestPeriodFragment = {
  __typename?: 'TestPeriod';
  id: string;
  startedAt?: any | null;
  checkInStats: Array<{
    __typename?: 'CheckInStat';
    completed: boolean;
    endedOn: string;
    startedOn: string;
  }>;
};

export type DashboardLabStatusFragment = {
  __typename?: 'LabStatus';
  id: string;
  createdAt: any;
  status: LabSubmissionStatusEnum;
};

export type AgeFormattedAgeFragment = {__typename?: 'FormattedAge'; months: number; years: number};

export type AgeLabResultMetric = {
  __typename?: 'LabResultMetric';
  id: string;
  percentile: number;
  type: LabResultMetricTypeEnum;
};

export type AgeLabAssessmentFragment = {
  __typename?: 'LabAssessment';
  deltaAge: number;
  id: string;
  formattedBioAge: {__typename?: 'FormattedAge'; months: number; years: number};
  formattedChronologicalAge: {__typename?: 'FormattedAge'; months: number; years: number};
  formattedDeltaAge: {__typename?: 'FormattedAge'; months: number; years: number};
  labResultMetrics: Array<{
    __typename?: 'LabResultMetric';
    id: string;
    percentile: number;
    type: LabResultMetricTypeEnum;
  }>;
};

export type DashboardQueryVariables = Exact<{[key: string]: never}>;

export type DashboardQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    labSubmissions: Array<{__typename?: 'LabSubmission'; id: string}>;
    mostRecentLabSubmission?: {
      __typename?: 'LabSubmission';
      id: string;
      registeredDate: any;
      status: LabSubmissionStatusEnum;
      userSurveySubmission?: {
        __typename?: 'UserSurveySubmission';
        id: string;
        surveyAssessment?: {
          __typename?: 'SurveyAssessment';
          id: string;
          lifestyleScore?: number | null;
          maxLifestyleScore: number;
        } | null;
      } | null;
      labAssessment?: {__typename?: 'LabAssessment'; id: string} | null;
      labStatuses: Array<{
        __typename?: 'LabStatus';
        id: string;
        createdAt: any;
        status: LabSubmissionStatusEnum;
      }>;
    } | null;
    mostRecentLabSubmissionWithResults?: {
      __typename?: 'LabSubmission';
      id: string;
      registeredDate: any;
      status: LabSubmissionStatusEnum;
      userSurveySubmission?: {
        __typename?: 'UserSurveySubmission';
        id: string;
        surveyAssessment?: {
          __typename?: 'SurveyAssessment';
          id: string;
          lifestyleScore?: number | null;
          maxLifestyleScore: number;
          categories: Array<{
            __typename?: 'CategoryAssessment';
            id: string;
            meetsRequirements: boolean;
            category: {__typename?: 'Category'; id: string; title: string; key: CategoryKeyEnum};
          }>;
          selectedActionPlan?: {
            __typename?: 'ActionPlan';
            id: string;
            adjustments: Array<{
              __typename?: 'HealthFactorAdjustment';
              id: string;
              selected: boolean;
              recommendedResponse: string;
              healthFactorAssessment?: {
                __typename?: 'HealthFactorAssessment';
                id: string;
                healthFactor?: {
                  __typename?: 'HealthFactor';
                  id: string;
                  recommendedResponse?: string | null;
                  title?: string | null;
                } | null;
              } | null;
            }>;
          } | null;
        } | null;
      } | null;
      labAssessment?: {
        __typename?: 'LabAssessment';
        deltaAge: number;
        id: string;
        formattedBioAge: {__typename?: 'FormattedAge'; months: number; years: number};
        formattedChronologicalAge: {__typename?: 'FormattedAge'; months: number; years: number};
        formattedDeltaAge: {__typename?: 'FormattedAge'; months: number; years: number};
        labResultMetrics: Array<{
          __typename?: 'LabResultMetric';
          id: string;
          percentile: number;
          type: LabResultMetricTypeEnum;
        }>;
      } | null;
      labRecord?: {
        __typename?: 'LabSubmissionRecord';
        hasViewedResultStory: boolean;
        id: string;
      } | null;
    } | null;
    subscription?: {
      __typename?: 'Subscription';
      hasActiveSubscription: boolean;
      hasMembership: boolean;
      id: string;
    } | null;
    userProfile?: {__typename?: 'UserProfile'; id: string; firstName?: string | null} | null;
    customerAccount?: {
      __typename?: 'CustomerAccount';
      id: string;
      subscription?: {
        __typename?: 'Subscription';
        id: string;
        status: string;
        hasMembership: boolean;
        pausedProductVariantIds: Array<string>;
        items: Array<{
          __typename?: 'SubscriptionItem';
          id: string;
          productId: string;
          variantId: string;
          variantSku: string;
          title: string;
          quantity: number;
          price: number;
        }>;
      } | null;
    } | null;
  };
  currentTestPeriod?: {
    __typename?: 'TestPeriod';
    id: string;
    startedAt?: any | null;
    checkInStats: Array<{
      __typename?: 'CheckInStat';
      completed: boolean;
      endedOn: string;
      startedOn: string;
    }>;
  } | null;
  learningResources: Array<{
    __typename?: 'LearningResource';
    id: string;
    duration?: string | null;
    imageUrl: string;
    title: string;
    type: LearningResourceType;
  }>;
};

export type DashboardUserFragment = {
  __typename?: 'User';
  id: string;
  labSubmissions: Array<{__typename?: 'LabSubmission'; id: string}>;
  mostRecentLabSubmission?: {
    __typename?: 'LabSubmission';
    id: string;
    registeredDate: any;
    status: LabSubmissionStatusEnum;
    userSurveySubmission?: {
      __typename?: 'UserSurveySubmission';
      id: string;
      surveyAssessment?: {
        __typename?: 'SurveyAssessment';
        id: string;
        lifestyleScore?: number | null;
        maxLifestyleScore: number;
      } | null;
    } | null;
    labAssessment?: {__typename?: 'LabAssessment'; id: string} | null;
    labStatuses: Array<{
      __typename?: 'LabStatus';
      id: string;
      createdAt: any;
      status: LabSubmissionStatusEnum;
    }>;
  } | null;
  mostRecentLabSubmissionWithResults?: {
    __typename?: 'LabSubmission';
    id: string;
    registeredDate: any;
    status: LabSubmissionStatusEnum;
    userSurveySubmission?: {
      __typename?: 'UserSurveySubmission';
      id: string;
      surveyAssessment?: {
        __typename?: 'SurveyAssessment';
        id: string;
        lifestyleScore?: number | null;
        maxLifestyleScore: number;
        categories: Array<{
          __typename?: 'CategoryAssessment';
          id: string;
          meetsRequirements: boolean;
          category: {__typename?: 'Category'; id: string; title: string; key: CategoryKeyEnum};
        }>;
        selectedActionPlan?: {
          __typename?: 'ActionPlan';
          id: string;
          adjustments: Array<{
            __typename?: 'HealthFactorAdjustment';
            id: string;
            selected: boolean;
            recommendedResponse: string;
            healthFactorAssessment?: {
              __typename?: 'HealthFactorAssessment';
              id: string;
              healthFactor?: {
                __typename?: 'HealthFactor';
                id: string;
                recommendedResponse?: string | null;
                title?: string | null;
              } | null;
            } | null;
          }>;
        } | null;
      } | null;
    } | null;
    labAssessment?: {
      __typename?: 'LabAssessment';
      deltaAge: number;
      id: string;
      formattedBioAge: {__typename?: 'FormattedAge'; months: number; years: number};
      formattedChronologicalAge: {__typename?: 'FormattedAge'; months: number; years: number};
      formattedDeltaAge: {__typename?: 'FormattedAge'; months: number; years: number};
      labResultMetrics: Array<{
        __typename?: 'LabResultMetric';
        id: string;
        percentile: number;
        type: LabResultMetricTypeEnum;
      }>;
    } | null;
    labRecord?: {
      __typename?: 'LabSubmissionRecord';
      hasViewedResultStory: boolean;
      id: string;
    } | null;
  } | null;
  subscription?: {
    __typename?: 'Subscription';
    hasActiveSubscription: boolean;
    hasMembership: boolean;
    id: string;
  } | null;
  userProfile?: {__typename?: 'UserProfile'; id: string; firstName?: string | null} | null;
  customerAccount?: {
    __typename?: 'CustomerAccount';
    id: string;
    subscription?: {
      __typename?: 'Subscription';
      id: string;
      status: string;
      hasMembership: boolean;
      pausedProductVariantIds: Array<string>;
      items: Array<{
        __typename?: 'SubscriptionItem';
        id: string;
        productId: string;
        variantId: string;
        variantSku: string;
        title: string;
        quantity: number;
        price: number;
      }>;
    } | null;
  } | null;
};

export type DashboardMostRecentLabSubmissionFragment = {
  __typename?: 'LabSubmission';
  id: string;
  registeredDate: any;
  status: LabSubmissionStatusEnum;
  userSurveySubmission?: {
    __typename?: 'UserSurveySubmission';
    id: string;
    surveyAssessment?: {
      __typename?: 'SurveyAssessment';
      id: string;
      lifestyleScore?: number | null;
      maxLifestyleScore: number;
    } | null;
  } | null;
  labAssessment?: {__typename?: 'LabAssessment'; id: string} | null;
  labStatuses: Array<{
    __typename?: 'LabStatus';
    id: string;
    createdAt: any;
    status: LabSubmissionStatusEnum;
  }>;
};

export type MostRecentLabSubmissionWithResultsFragment = {
  __typename?: 'LabSubmission';
  id: string;
  registeredDate: any;
  status: LabSubmissionStatusEnum;
  userSurveySubmission?: {
    __typename?: 'UserSurveySubmission';
    id: string;
    surveyAssessment?: {
      __typename?: 'SurveyAssessment';
      id: string;
      lifestyleScore?: number | null;
      maxLifestyleScore: number;
      categories: Array<{
        __typename?: 'CategoryAssessment';
        id: string;
        meetsRequirements: boolean;
        category: {__typename?: 'Category'; id: string; title: string; key: CategoryKeyEnum};
      }>;
      selectedActionPlan?: {
        __typename?: 'ActionPlan';
        id: string;
        adjustments: Array<{
          __typename?: 'HealthFactorAdjustment';
          id: string;
          selected: boolean;
          recommendedResponse: string;
          healthFactorAssessment?: {
            __typename?: 'HealthFactorAssessment';
            id: string;
            healthFactor?: {
              __typename?: 'HealthFactor';
              id: string;
              recommendedResponse?: string | null;
              title?: string | null;
            } | null;
          } | null;
        }>;
      } | null;
    } | null;
  } | null;
  labAssessment?: {
    __typename?: 'LabAssessment';
    deltaAge: number;
    id: string;
    formattedBioAge: {__typename?: 'FormattedAge'; months: number; years: number};
    formattedChronologicalAge: {__typename?: 'FormattedAge'; months: number; years: number};
    formattedDeltaAge: {__typename?: 'FormattedAge'; months: number; years: number};
    labResultMetrics: Array<{
      __typename?: 'LabResultMetric';
      id: string;
      percentile: number;
      type: LabResultMetricTypeEnum;
    }>;
  } | null;
  labRecord?: {
    __typename?: 'LabSubmissionRecord';
    hasViewedResultStory: boolean;
    id: string;
  } | null;
};

export type LabSubmissionRecordFragment = {
  __typename?: 'LabSubmissionRecord';
  hasViewedResultStory: boolean;
  id: string;
};

export type SurveyAssessmentFragment = {
  __typename?: 'SurveyAssessment';
  id: string;
  lifestyleScore?: number | null;
  maxLifestyleScore: number;
  categories: Array<{
    __typename?: 'CategoryAssessment';
    id: string;
    meetsRequirements: boolean;
    category: {__typename?: 'Category'; id: string; title: string; key: CategoryKeyEnum};
  }>;
  selectedActionPlan?: {
    __typename?: 'ActionPlan';
    id: string;
    adjustments: Array<{
      __typename?: 'HealthFactorAdjustment';
      id: string;
      selected: boolean;
      recommendedResponse: string;
      healthFactorAssessment?: {
        __typename?: 'HealthFactorAssessment';
        id: string;
        healthFactor?: {
          __typename?: 'HealthFactor';
          id: string;
          recommendedResponse?: string | null;
          title?: string | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type SelectedActionPlanFragment = {
  __typename?: 'ActionPlan';
  id: string;
  adjustments: Array<{
    __typename?: 'HealthFactorAdjustment';
    id: string;
    selected: boolean;
    recommendedResponse: string;
    healthFactorAssessment?: {
      __typename?: 'HealthFactorAssessment';
      id: string;
      healthFactor?: {
        __typename?: 'HealthFactor';
        id: string;
        recommendedResponse?: string | null;
        title?: string | null;
      } | null;
    } | null;
  }>;
};

export type UpdateActionPlanVariables = Exact<{
  input: UpdateActionPlanInput;
}>;

export type UpdateActionPlan = {
  __typename?: 'Mutation';
  updateActionPlan: Array<{__typename?: 'updatedIds'; id: string}>;
};

export type ContactDetailsUserProfileFragment = {
  __typename?: 'UserProfile';
  email?: string | null;
  formattedPhoneNumber?: string | null;
  id: string;
  phoneNumber?: string | null;
};

export type ContactDetailsQueryVariables = Exact<{[key: string]: never}>;

export type ContactDetailsQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    userProfile?: {
      __typename?: 'UserProfile';
      email?: string | null;
      formattedPhoneNumber?: string | null;
      id: string;
      phoneNumber?: string | null;
    } | null;
  };
};

export type UpdateContactDetailsVariables = Exact<{
  input: UpdateUserProfileInput;
}>;

export type UpdateContactDetails = {
  __typename?: 'Mutation';
  updateUserProfile: {
    __typename?: 'UserProfile';
    email?: string | null;
    formattedPhoneNumber?: string | null;
    id: string;
    phoneNumber?: string | null;
  };
};

export type EditProfileQueryVariables = Exact<{
  imageVariant: FileImageVariant;
}>;

export type EditProfileQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    avatar?: {__typename?: 'File'; id: string; url?: string | null} | null;
    userProfile?: {
      __typename?: 'UserProfile';
      email?: string | null;
      birthSex?: BirthSex | null;
      birthday?: string | null;
      firstName?: string | null;
      formattedBirthSex: string;
      formattedBirthday?: string | null;
      formattedHeight?: string | null;
      formattedWeight?: string | null;
      formattedPhoneNumber?: string | null;
      phoneNumber?: string | null;
      height?: number | null;
      heightDisplayUnit?: MeasurementUnit | null;
      id: string;
      initials: string;
      lastName?: string | null;
      pronouns?: string | null;
      weight?: number | null;
      weightDisplayUnit?: MeasurementUnit | null;
    } | null;
  };
};

export type UpdateUserProfileVariables = Exact<{
  input: UpdateUserProfileInput;
}>;

export type UpdateUserProfile = {
  __typename?: 'Mutation';
  updateUserProfile: {
    __typename?: 'UserProfile';
    birthSex?: BirthSex | null;
    birthday?: string | null;
    firstName?: string | null;
    height?: number | null;
    heightDisplayUnit?: MeasurementUnit | null;
    id: string;
    lastName?: string | null;
    pronouns?: string | null;
    weight?: number | null;
    weightDisplayUnit?: MeasurementUnit | null;
  };
};

export type RequestPasswordResetVariables = Exact<{
  input: RequestPasswordResetInput;
}>;

export type RequestPasswordReset = {
  __typename?: 'Mutation';
  requestPasswordReset: {__typename?: 'GenericResponse'; message?: string | null; success: boolean};
};

export type HealthFactorQueryVariables = Exact<{
  input: GetHealthFactorInput;
}>;

export type HealthFactorQuery = {
  __typename?: 'Query';
  healthFactor?: {
    __typename?: 'HealthFactor';
    id: string;
    imageUrl?: string | null;
    impactLevel?: string | null;
    recommendationDescription?: string | null;
    recommendationTitle?: string | null;
    recommendedResponse?: string | null;
    title?: string | null;
    emergingResearch?: boolean | null;
    media?: {
      __typename?: 'Media';
      id: string;
      thumbnailUrl?: string | null;
      url?: string | null;
    } | null;
    references: Array<{
      __typename?: 'Reference';
      id: string;
      labels: Array<string>;
      title?: string | null;
      url?: string | null;
    }>;
    researchSnack?: {
      __typename?: 'ResearchSnack';
      id: string;
      description?: string | null;
      title?: string | null;
    } | null;
  } | null;
};

export type HealthFactorAssessmentQueryVariables = Exact<{
  input: GetSurveyAssessmentInput;
}>;

export type HealthFactorAssessmentQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    mostRecentLabSubmissionWithResults?: {
      __typename?: 'LabSubmission';
      id: string;
      userSurveySubmission?: {
        __typename?: 'UserSurveySubmission';
        id: string;
        surveyAssessment?: {
          __typename?: 'SurveyAssessment';
          id: string;
          selectedActionPlan?: {
            __typename?: 'ActionPlan';
            id: string;
            adjustments: Array<{
              __typename?: 'HealthFactorAdjustment';
              id: string;
              selected: boolean;
              recommendedResponse: string;
              healthFactorAssessment?: {
                __typename?: 'HealthFactorAssessment';
                id: string;
                healthFactor?: {
                  __typename?: 'HealthFactor';
                  id: string;
                  recommendedResponse?: string | null;
                  title?: string | null;
                } | null;
              } | null;
            }>;
          } | null;
        } | null;
      } | null;
    } | null;
  };
  surveyAssessment?: {
    __typename?: 'SurveyAssessment';
    id: string;
    categories: Array<{
      __typename?: 'CategoryAssessment';
      id: string;
      category: {
        __typename?: 'Category';
        id: string;
        steps: Array<{
          __typename?: 'Step';
          id: string;
          question: {
            __typename?: 'Question';
            id: string;
            text: string;
            questionType: QuestionTypeEnum;
            multipleChoiceConfiguration?: {
              __typename?: 'QuestionMultipleChoiceConfiguration';
              questionChoiceType: QuestionChoiceTypeEnum;
              options: Array<{__typename?: 'MultipleChoiceOption'; id: string; text: string}>;
            } | null;
          };
        }>;
      };
      factorAssessments: Array<{
        __typename?: 'HealthFactorAssessment';
        id: string;
        answerId: string;
        meetsRequirements: boolean;
        healthFactor?: {
          __typename?: 'HealthFactor';
          id: string;
          imageUrl?: string | null;
          impactLevel?: string | null;
          questionId: string;
          recommendationDescription?: string | null;
          recommendationTitle?: string | null;
          recommendedResponse?: string | null;
          title?: string | null;
          emergingResearch?: boolean | null;
          media?: {
            __typename?: 'Media';
            id: string;
            thumbnailUrl?: string | null;
            url?: string | null;
          } | null;
          references: Array<{
            __typename?: 'Reference';
            id: string;
            labels: Array<string>;
            title?: string | null;
            url?: string | null;
          }>;
          researchSnack?: {
            __typename?: 'ResearchSnack';
            id: string;
            description?: string | null;
            title?: string | null;
          } | null;
        } | null;
      }>;
    }>;
    userSurveySubmission: {
      __typename?: 'UserSurveySubmission';
      id: string;
      answers: Array<{
        __typename?: 'UserSurveySubmissionAnswer';
        answerDate?: string | null;
        answerNumeric?: number | null;
        answerOptionIds?: Array<string> | null;
        answerText?: string | null;
        questionId: string;
      }>;
    };
  } | null;
};

export type HealthFactorAssessmentQuestion = {
  __typename?: 'Question';
  id: string;
  text: string;
  questionType: QuestionTypeEnum;
  multipleChoiceConfiguration?: {
    __typename?: 'QuestionMultipleChoiceConfiguration';
    questionChoiceType: QuestionChoiceTypeEnum;
    options: Array<{__typename?: 'MultipleChoiceOption'; id: string; text: string}>;
  } | null;
};

export type HealthFactorAssessmentAnswer = {
  __typename?: 'UserSurveySubmissionAnswer';
  answerDate?: string | null;
  answerNumeric?: number | null;
  answerOptionIds?: Array<string> | null;
  answerText?: string | null;
  questionId: string;
};

export type LearningResourceQueryVariables = Exact<{
  learningResourceId: Scalars['String']['input'];
}>;

export type LearningResourceQuery = {
  __typename?: 'Query';
  learningResource: {
    __typename?: 'LearningResource';
    id: string;
    title: string;
    slug: string;
    type: LearningResourceType;
    duration?: string | null;
    imageUrl: string;
    body?: string | null;
    publishedDate?: any | null;
    updatedDate?: any | null;
    videoUrl?: string | null;
    author?: {
      __typename?: 'LearningResourceAuthor';
      name: string;
      credentials: string;
      avatarUrl: string;
    } | null;
    references: Array<{
      __typename?: 'Reference';
      id: string;
      title?: string | null;
      publication?: string | null;
      url?: string | null;
      labels: Array<string>;
    }>;
  };
  learningResources: Array<{
    __typename?: 'LearningResource';
    id: string;
    duration?: string | null;
    imageUrl: string;
    title: string;
    type: LearningResourceType;
  }>;
};

export type LifestylePreviewCategoryFragment = {
  __typename?: 'CategoryAssessment';
  categoryScore: number;
  id: string;
  maxCategoryScore: number;
  category: {__typename?: 'Category'; id: string; title: string};
};

export type LifestylePreviewVariables = Exact<{[key: string]: never}>;

export type LifestylePreview = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    subscription?: {__typename?: 'Subscription'; hasActiveSubscription: boolean} | null;
    mostRecentLabSubmission?: {
      __typename?: 'LabSubmission';
      id: string;
      registeredDate: any;
      userSurveySubmission?: {
        __typename?: 'UserSurveySubmission';
        id: string;
        surveyAssessment?: {
          __typename?: 'SurveyAssessment';
          id: string;
          lifestyleScore?: number | null;
          maxLifestyleScore: number;
          surveyId: string;
          surveyKey: string;
          categories: Array<{
            __typename?: 'CategoryAssessment';
            categoryScore: number;
            id: string;
            maxCategoryScore: number;
            category: {__typename?: 'Category'; id: string; title: string};
          }>;
        } | null;
      } | null;
    } | null;
  };
};

export type LifestyleCategoryAssessmentFragment = {
  __typename?: 'CategoryAssessment';
  id: string;
  categoryScore: number;
  maxCategoryScore: number;
  meetsRequirements: boolean;
  category: {
    __typename?: 'Category';
    id: string;
    key: CategoryKeyEnum;
    description?: string | null;
    title: string;
  };
  factorAssessments: Array<{
    __typename?: 'HealthFactorAssessment';
    id: string;
    meetsRequirements: boolean;
    healthFactor?: {
      __typename?: 'HealthFactor';
      id: string;
      impactLevel?: string | null;
      recommendedResponse?: string | null;
      recommendationTitle?: string | null;
      title?: string | null;
    } | null;
  }>;
};

export type LifestyleSummaryMostRecentLabSubmissionFragment = {
  __typename?: 'LabSubmission';
  id: string;
  registeredDate: any;
  userSurveySubmission?: {
    __typename?: 'UserSurveySubmission';
    id: string;
    surveyAssessment?: {
      __typename?: 'SurveyAssessment';
      id: string;
      lifestyleScore?: number | null;
      maxLifestyleScore: number;
    } | null;
  } | null;
};

export type LifestyleSummaryMostRecentLabSubmissionWithResultsFragment = {
  __typename?: 'LabSubmission';
  id: string;
  registeredDate: any;
  userSurveySubmission?: {
    __typename?: 'UserSurveySubmission';
    id: string;
    surveyAssessment?: {
      __typename?: 'SurveyAssessment';
      id: string;
      lifestyleScore?: number | null;
      maxLifestyleScore: number;
      surveyId: string;
      surveyKey: string;
      categories: Array<{
        __typename?: 'CategoryAssessment';
        id: string;
        categoryScore: number;
        maxCategoryScore: number;
        meetsRequirements: boolean;
        category: {
          __typename?: 'Category';
          id: string;
          key: CategoryKeyEnum;
          description?: string | null;
          title: string;
        };
        factorAssessments: Array<{
          __typename?: 'HealthFactorAssessment';
          id: string;
          meetsRequirements: boolean;
          healthFactor?: {
            __typename?: 'HealthFactor';
            id: string;
            impactLevel?: string | null;
            recommendedResponse?: string | null;
            recommendationTitle?: string | null;
            title?: string | null;
          } | null;
        }>;
      }>;
      selectedActionPlan?: {__typename?: 'ActionPlan'; id: string} | null;
    } | null;
  } | null;
};

export type LifestyleSummaryVariables = Exact<{
  input: FindLearningResourcesInput;
}>;

export type LifestyleSummary = {
  __typename?: 'Query';
  learningResources: Array<{
    __typename?: 'LearningResource';
    id: string;
    duration?: string | null;
    imageUrl: string;
    title: string;
    type: LearningResourceType;
  }>;
  me: {
    __typename?: 'User';
    id: string;
    mostRecentLabSubmission?: {
      __typename?: 'LabSubmission';
      id: string;
      registeredDate: any;
      userSurveySubmission?: {
        __typename?: 'UserSurveySubmission';
        id: string;
        surveyAssessment?: {
          __typename?: 'SurveyAssessment';
          id: string;
          lifestyleScore?: number | null;
          maxLifestyleScore: number;
        } | null;
      } | null;
    } | null;
    mostRecentLabSubmissionWithResults?: {
      __typename?: 'LabSubmission';
      id: string;
      registeredDate: any;
      userSurveySubmission?: {
        __typename?: 'UserSurveySubmission';
        id: string;
        surveyAssessment?: {
          __typename?: 'SurveyAssessment';
          id: string;
          lifestyleScore?: number | null;
          maxLifestyleScore: number;
          surveyId: string;
          surveyKey: string;
          categories: Array<{
            __typename?: 'CategoryAssessment';
            id: string;
            categoryScore: number;
            maxCategoryScore: number;
            meetsRequirements: boolean;
            category: {
              __typename?: 'Category';
              id: string;
              key: CategoryKeyEnum;
              description?: string | null;
              title: string;
            };
            factorAssessments: Array<{
              __typename?: 'HealthFactorAssessment';
              id: string;
              meetsRequirements: boolean;
              healthFactor?: {
                __typename?: 'HealthFactor';
                id: string;
                impactLevel?: string | null;
                recommendedResponse?: string | null;
                recommendationTitle?: string | null;
                title?: string | null;
              } | null;
            }>;
          }>;
          selectedActionPlan?: {__typename?: 'ActionPlan'; id: string} | null;
        } | null;
      } | null;
    } | null;
    subscription?: {
      __typename?: 'Subscription';
      id: string;
      hasActiveSubscription: boolean;
      hasMembership: boolean;
    } | null;
  };
};

export type LifestyleSummaryEmptyVariables = Exact<{
  input: GetSurveyInput;
}>;

export type LifestyleSummaryEmpty = {
  __typename?: 'Query';
  survey?: {
    __typename?: 'Survey';
    id: string;
    categories: Array<{__typename?: 'Category'; id: string; title: string}>;
  } | null;
};

export type MyTallyAgeFormattedAgeFragment = {
  __typename?: 'FormattedAge';
  months: number;
  years: number;
};

export type MyTallyAgeLabResultMetric = {
  __typename?: 'LabResultMetric';
  id: string;
  percentile: number;
  type: LabResultMetricTypeEnum;
};

export type MyTallyAgeLabAssessmentFragment = {
  __typename?: 'LabAssessment';
  deltaAge: number;
  id: string;
  reportUrl: string;
  formattedBioAge: {__typename?: 'FormattedAge'; months: number; years: number};
  formattedChronologicalAge: {__typename?: 'FormattedAge'; months: number; years: number};
  formattedDeltaAge: {__typename?: 'FormattedAge'; months: number; years: number};
  labResultMetrics: Array<{
    __typename?: 'LabResultMetric';
    id: string;
    percentile: number;
    type: LabResultMetricTypeEnum;
  }>;
};

export type MyTallyAgeQueryVariables = Exact<{
  input: UserTrendsInputModel;
}>;

export type MyTallyAgeQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    hasViewedResultsHistory: boolean;
    labSubmissions: Array<{
      __typename?: 'LabSubmission';
      id: string;
      registeredDate: any;
      labAssessment?: {
        __typename?: 'LabAssessment';
        bioAge: number;
        chronologicalAge: number;
        deltaAge: number;
        id: string;
        formattedBioAge: {__typename?: 'FormattedAge'; months: number; years: number};
        formattedChronologicalAge: {__typename?: 'FormattedAge'; months: number; years: number};
        formattedDeltaAge: {__typename?: 'FormattedAge'; months: number; years: number};
      } | null;
      userSurveySubmission?: {
        __typename?: 'UserSurveySubmission';
        id: string;
        surveyAssessment?: {
          __typename?: 'SurveyAssessment';
          id: string;
          lifestyleScore?: number | null;
          maxLifestyleScore: number;
          categories: Array<{
            __typename?: 'CategoryAssessment';
            categoryScore: number;
            id: string;
            maxCategoryScore: number;
            category: {__typename?: 'Category'; id: string; title: string};
          }>;
        } | null;
      } | null;
    }>;
    mostRecentLabSubmission?: {
      __typename?: 'LabSubmission';
      id: string;
      userSurveySubmission?: {
        __typename?: 'UserSurveySubmission';
        surveyAssessment?: {__typename?: 'SurveyAssessment'; id: string} | null;
      } | null;
    } | null;
    mostRecentLabSubmissionWithResults?: {
      __typename?: 'LabSubmission';
      id: string;
      registeredDate: any;
      labAssessment?: {
        __typename?: 'LabAssessment';
        deltaAge: number;
        id: string;
        reportUrl: string;
        formattedBioAge: {__typename?: 'FormattedAge'; months: number; years: number};
        formattedChronologicalAge: {__typename?: 'FormattedAge'; months: number; years: number};
        formattedDeltaAge: {__typename?: 'FormattedAge'; months: number; years: number};
        labResultMetrics: Array<{
          __typename?: 'LabResultMetric';
          id: string;
          percentile: number;
          type: LabResultMetricTypeEnum;
        }>;
      } | null;
      labRecord?: {
        __typename?: 'LabSubmissionRecord';
        hasViewedResultStory: boolean;
        id: string;
      } | null;
    } | null;
    subscription?: {__typename?: 'Subscription'; hasMembership: boolean} | null;
  };
  userTrends: Array<{
    __typename?: 'UserTrend';
    deltaAge: number;
    labSubmissionId: string;
    lifestyleScorePercentage?: number | null;
    registeredDate: any;
    formattedDeltaAge: {__typename?: 'FormattedAge'; months: number; years: number};
    categories: Array<{
      __typename?: 'UserCategoryTrend';
      categoryId: string;
      categoryScorePercentage: number;
      title: string;
    }>;
  }>;
};

export type NotificationQueryFragment = {
  __typename?: 'User';
  id: string;
  receiveEmailNotification: boolean;
  receiveSMSNotification: boolean;
};

export type NotificationsQueryVariables = Exact<{[key: string]: never}>;

export type NotificationsQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    receiveEmailNotification: boolean;
    receiveSMSNotification: boolean;
  };
};

export type UpdateNotificationsVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateNotifications = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'User';
    id: string;
    receiveEmailNotification: boolean;
    receiveSMSNotification: boolean;
  };
};

export type CreateAndApplyDiscountVariables = Exact<{
  createAndApplyDiscountInput: CreateAndApplyDiscountInput;
}>;

export type CreateAndApplyDiscount = {
  __typename?: 'Mutation';
  createAndApplyDiscount: {__typename?: 'User'; id: string};
};

export type UpdateSubscriptionStatusVariables = Exact<{
  subscriptionChanges: UpdateSubscriptionInput;
}>;

export type UpdateSubscriptionStatus = {
  __typename?: 'Mutation';
  updateSubscription: {__typename?: 'User'; id: string};
};

export type GetSimulatedDiscountsVariables = Exact<{
  input: SimulatedDiscountsInput;
}>;

export type GetSimulatedDiscounts = {
  __typename?: 'Query';
  getSimulatedDiscounts: {
    __typename?: 'SimulatedDiscountsResponse';
    discounts: Array<{
      __typename?: 'SimulatedDiscount';
      type: string;
      variantId?: string | null;
      value: number;
      category: string;
      title: string;
    }>;
    discountErrors?: Array<{
      __typename?: 'SimulatedDiscountError';
      discount: string;
      code: string;
      message: string;
    }> | null;
  };
};

export type UpdateSubscriptionVariables = Exact<{
  subscriptionChanges: UpdateSubscriptionInput;
}>;

export type UpdateSubscription = {
  __typename?: 'Mutation';
  updateSubscription: {__typename?: 'User'; id: string};
};

export type ManagePlanQueryVariables = Exact<{[key: string]: never}>;

export type ManagePlanQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    appliedDiscountCancelationOn?: any | null;
    customerAccount?: {
      __typename?: 'CustomerAccount';
      id: string;
      subscription?: {
        __typename?: 'Subscription';
        id: string;
        email: string;
        hasActiveSubscription: boolean;
        hasMembership: boolean;
        status: string;
        pausedProductVariantIds: Array<string>;
        nextBillingAttemptAt?: string | null;
        discounts: Array<{
          __typename?: 'SubscriptionDiscount';
          title: string;
          amount: number;
          category: string;
          productVariantId?: string | null;
          type: string;
        }>;
        items: Array<{
          __typename?: 'SubscriptionItem';
          id: string;
          productId: string;
          variantId: string;
          variantSku: string;
          title: string;
          quantity: number;
          price: number;
        }>;
      } | null;
    } | null;
  };
};

export type ProductDetailsQueryVariables = Exact<{[key: string]: never}>;

export type ProductDetailsQuery = {
  __typename?: 'Query';
  store?: {
    __typename?: 'Store';
    productVariants: Array<{
      __typename?: 'ProductVariant';
      id: string;
      tid: string;
      sku: string;
      title: string;
      type: ProductVariantTypeEnum;
      price: number;
      packageType: ProductPackageTypeEnum;
      productId: number;
      product?: {
        __typename?: 'Product';
        id: string;
        tid: string;
        title: string;
        category: ProductCategoryEnum;
        thumbnail: string;
        displayOrder: number;
        variantIds: Array<number>;
      } | null;
    }>;
  } | null;
};

export type GetDiscountVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type GetDiscount = {
  __typename?: 'Query';
  getDiscount: {__typename?: 'ValidatedDiscount'; discountCode?: string | null};
};

export type PauseSubscriptionQueryVariables = Exact<{[key: string]: never}>;

export type PauseSubscriptionQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    customerAccount?: {
      __typename?: 'CustomerAccount';
      id: string;
      subscription?: {
        __typename?: 'Subscription';
        id: string;
        pausedProductVariantIds: Array<string>;
        items: Array<{
          __typename?: 'SubscriptionItem';
          id: string;
          productId: string;
          variantId: string;
          variantSku: string;
          title: string;
          quantity: number;
          price: number;
        }>;
      } | null;
    } | null;
  };
};

export type PauseSubscriptionItemsMutationVariables = Exact<{
  input: PauseSubscriptionItemsInput;
}>;

export type PauseSubscriptionItemsMutation = {
  __typename?: 'Mutation';
  pauseSubscriptionItems: {__typename?: 'SubscriptionItem'; id: string};
};

export type CustomerSubscriptionInfoBoxesFragment = {
  __typename?: 'Subscription';
  id: string;
  hasMembership: boolean;
  paymentMethodId?: string | null;
  discounts: Array<{
    __typename?: 'SubscriptionDiscount';
    title: string;
    amount: number;
    type: string;
    category: string;
    productVariantId?: string | null;
  }>;
};

export type ProfileInfoBoxQueryVariables = Exact<{[key: string]: never}>;

export type ProfileInfoBoxQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    userProfile?: {
      __typename?: 'UserProfile';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
    } | null;
    customerAccount?: {
      __typename?: 'CustomerAccount';
      id: string;
      subscription?: {
        __typename?: 'Subscription';
        id: string;
        hasMembership: boolean;
        paymentMethodId?: string | null;
        discounts: Array<{
          __typename?: 'SubscriptionDiscount';
          title: string;
          amount: number;
          type: string;
          category: string;
          productVariantId?: string | null;
        }>;
      } | null;
      shippingAddress?: {
        __typename?: 'Address';
        address: string;
        city: string;
        addressDetail?: string | null;
        postalCode: string;
        provinceCode: string;
        province: string;
        countryCode: string;
        country: string;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
      paymentMethods?: Array<{
        __typename?: 'PaymentMethod';
        id: string;
        expiryMonth?: number | null;
        expiryYear?: number | null;
        lastDigits?: string | null;
        brand?: string | null;
        type: PaymentMethodType;
      }> | null;
    } | null;
  };
};

export type ProfileUpcomingOrderQueryVariables = Exact<{[key: string]: never}>;

export type ProfileUpcomingOrderQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    customerAccount?: {
      __typename?: 'CustomerAccount';
      id: string;
      subscription?: {
        __typename?: 'Subscription';
        id: string;
        status: string;
        discounts: Array<{
          __typename?: 'SubscriptionDiscount';
          title: string;
          amount: number;
          type: string;
          category: string;
          productVariantId?: string | null;
        }>;
      } | null;
      upcomingOrder?: {
        __typename?: 'Order';
        id: number;
        billingDate: any;
        status: string;
        subTotal: number;
        shippingTotal: number;
        total: number;
        discountTotal: number;
        discounts: Array<{
          __typename?: 'OrderDiscount';
          title: string;
          type: string;
          value: number;
          category: string;
          productVariantId?: string | null;
        }>;
        orderItems: Array<{
          __typename?: 'OrderItem';
          id: string;
          productTitle: string;
          unitPrice: number;
          quantity: number;
          status: string;
          cost?: number | null;
        }>;
      } | null;
    } | null;
  };
};

export type ProfileCustomerSubscriptionQueryVariables = Exact<{[key: string]: never}>;

export type ProfileCustomerSubscriptionQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    customerAccount?: {
      __typename?: 'CustomerAccount';
      id: string;
      subscription?: {
        __typename?: 'Subscription';
        id: string;
        status: string;
        hasMembership: boolean;
        pausedProductVariantIds: Array<string>;
        items: Array<{
          __typename?: 'SubscriptionItem';
          id: string;
          productId: string;
          variantId: string;
          variantSku: string;
          title: string;
          quantity: number;
          price: number;
        }>;
      } | null;
      upcomingOrder?: {
        __typename?: 'Order';
        id: number;
        billingDate: any;
        status: string;
        subTotal: number;
        shippingTotal: number;
        total: number;
        discountTotal: number;
        discounts: Array<{
          __typename?: 'OrderDiscount';
          title: string;
          type: string;
          value: number;
          category: string;
          productVariantId?: string | null;
        }>;
        orderItems: Array<{
          __typename?: 'OrderItem';
          id: string;
          productTitle: string;
          unitPrice: number;
          quantity: number;
          status: string;
          cost?: number | null;
        }>;
      } | null;
      orders: Array<{
        __typename?: 'Order';
        id: number;
        billingDate: any;
        status: string;
        subTotal: number;
        shippingTotal: number;
        total: number;
        discounts: Array<{
          __typename?: 'OrderDiscount';
          title: string;
          type: string;
          value: number;
          category: string;
          productVariantId?: string | null;
        }>;
        orderItems: Array<{
          __typename?: 'OrderItem';
          id: string;
          productTitle: string;
          unitPrice: number;
          quantity: number;
          status: string;
          cost?: number | null;
          isMembership?: boolean | null;
        }>;
      }>;
    } | null;
  };
};

export type ProfileRecentOrdersQueryVariables = Exact<{[key: string]: never}>;

export type ProfileRecentOrdersQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    customerAccount?: {
      __typename?: 'CustomerAccount';
      id: string;
      orders: Array<{
        __typename?: 'Order';
        id: number;
        name: string;
        billingDate: any;
        status: string;
        subTotal: number;
        discountTotal: number;
        taxTotal: number;
        shippingTotal: number;
        total: number;
        discounts: Array<{
          __typename?: 'OrderDiscount';
          title: string;
          type: string;
          value: number;
          category: string;
          productVariantId?: string | null;
        }>;
        orderItems: Array<{
          __typename?: 'OrderItem';
          id: string;
          productTitle: string;
          unitPrice: number;
          quantity: number;
          status: string;
          cost?: number | null;
          isMembership?: boolean | null;
        }>;
      }>;
    } | null;
  };
};

export type StoreQueryVariables = Exact<{[key: string]: never}>;

export type StoreQuery = {
  __typename?: 'Query';
  store?: {
    __typename?: 'Store';
    products: Array<{
      __typename?: 'Product';
      id: string;
      tid: string;
      title: string;
      category: ProductCategoryEnum;
      thumbnail: string;
      displayOrder: number;
      variantIds: Array<number>;
    }>;
    productVariants: Array<{
      __typename?: 'ProductVariant';
      id: string;
      tid: string;
      sku: string;
      title: string;
      type: ProductVariantTypeEnum;
      price: number;
      packageType: ProductPackageTypeEnum;
      productId: number;
      product?: {
        __typename?: 'Product';
        id: string;
        tid: string;
        title: string;
        category: ProductCategoryEnum;
        thumbnail: string;
        displayOrder: number;
        displayTheme?: string | null;
        variantIds: Array<number>;
      } | null;
    }>;
  } | null;
};

export type UpdateCustomerAddressMutationVariables = Exact<{
  input: UpdateShippingAddressInput;
}>;

export type UpdateCustomerAddressMutation = {
  __typename?: 'Mutation';
  updateCustomerAccountShippingAddress: {
    __typename?: 'Address';
    address: string;
    addressDetail?: string | null;
    city: string;
    countryCode: string;
    provinceCode: string;
    postalCode: string;
    firstName?: string | null;
    lastName?: string | null;
  };
};

export type SendPaymentMethodUpdateLinkMutationVariables = Exact<{[key: string]: never}>;

export type SendPaymentMethodUpdateLinkMutation = {
  __typename?: 'Mutation';
  sendPaymentMethodUpdateLink: {
    __typename?: 'GenericResponse';
    success: boolean;
    code?: string | null;
    message?: string | null;
  };
};

export type UpdateSubscriptionMutationVariables = Exact<{
  subscriptionChanges: UpdateSubscriptionInput;
}>;

export type UpdateSubscriptionMutation = {
  __typename?: 'Mutation';
  updateSubscription: {__typename?: 'User'; id: string};
};

export type ProfileQueryHeaderVariables = Exact<{
  imageVariant: FileImageVariant;
}>;

export type ProfileQueryHeader = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    avatar?: {__typename?: 'File'; id: string; url?: string | null} | null;
    userProfile?: {
      __typename?: 'UserProfile';
      id: string;
      initials: string;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
    } | null;
    subscription?: {__typename?: 'Subscription'; id: string} | null;
    mostRecentLabSubmission?: {__typename?: 'LabSubmission'; id: string} | null;
  };
};

export type ProfilePageQueryVariables = Exact<{[key: string]: never}>;

export type ProfilePageQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    customerAccount?: {
      __typename?: 'CustomerAccount';
      id: string;
      subscription?: {
        __typename?: 'Subscription';
        id: string;
        paymentMethodId?: string | null;
      } | null;
      paymentMethods?: Array<{
        __typename?: 'PaymentMethod';
        id: string;
        brand?: string | null;
        type: PaymentMethodType;
        lastDigits?: string | null;
        expiryMonth?: number | null;
      }> | null;
    } | null;
  };
};

export type RegisterQueryVariables = Exact<{[key: string]: never}>;

export type RegisterQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    receiveSMSNotification: boolean;
    userProfile?: {
      __typename?: 'UserProfile';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      birthday?: string | null;
      email?: string | null;
    } | null;
    labSubmissions: Array<{__typename?: 'LabSubmission'; id: string}>;
  };
};

export type RequestCreateAccountLinkVariables = Exact<{
  input: RequestCreateAccountLinkInput;
}>;

export type RequestCreateAccountLink = {
  __typename?: 'Mutation';
  requestCreateAccountLink: {
    __typename?: 'GenericResponse';
    success: boolean;
    code?: string | null;
  };
};

export type ResetPasswordVariables = Exact<{
  input: ResetPasswordInput;
}>;

export type ResetPassword = {
  __typename?: 'Mutation';
  resetPassword: {__typename?: 'GenericResponse'; message?: string | null; success: boolean};
};

export type ResultStoryQueryVariables = Exact<{
  metricTypes?: InputMaybe<Array<LabResultMetricTypeEnum> | LabResultMetricTypeEnum>;
}>;

export type ResultStoryQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    subscription?: {__typename?: 'Subscription'; hasActiveSubscription: boolean} | null;
    mostRecentLabSubmissionWithResults?: {
      __typename?: 'LabSubmission';
      id: string;
      surveySubmissionId?: string | null;
      labAssessment?: {
        __typename?: 'LabAssessment';
        deltaAge: number;
        id: string;
        reportUrl: string;
        formattedBioAge: {__typename?: 'FormattedAge'; months: number; years: number};
        formattedChronologicalAge: {__typename?: 'FormattedAge'; months: number; years: number};
        formattedDeltaAge: {__typename?: 'FormattedAge'; months: number; years: number};
        labResultMetrics: Array<{
          __typename?: 'LabResultMetric';
          id: string;
          percentile: number;
          type: LabResultMetricTypeEnum;
        }>;
      } | null;
      labRecord?: {
        __typename?: 'LabSubmissionRecord';
        hasViewedResultStory: boolean;
        id: string;
      } | null;
    } | null;
    userProfile?: {__typename?: 'UserProfile'; firstName?: string | null; id: string} | null;
  };
};

export type ResultStoryViewedVariables = Exact<{
  input: UpdateUserViewedLabResultStoryInput;
}>;

export type ResultStoryViewed = {
  __typename?: 'Mutation';
  updateUserViewedLabResultStory: {
    __typename?: 'User';
    id: string;
    mostRecentLabSubmissionWithResults?: {
      __typename?: 'LabSubmission';
      id: string;
      labRecord?: {
        __typename?: 'LabSubmissionRecord';
        hasViewedResultStory: boolean;
        id: string;
      } | null;
    } | null;
  };
};

export type SurveySubmissionVariables = Exact<{
  input: SaveUserSurveySubmissionInput;
}>;

export type SurveySubmission = {
  __typename?: 'Mutation';
  saveUserSurveySubmission: {
    __typename?: 'UserSurveySubmission';
    id: string;
    user: {
      __typename?: 'User';
      id: string;
      mostRecentLabSubmission?: {
        __typename?: 'LabSubmission';
        id: string;
        surveySubmissionId?: string | null;
        userSurveySubmission?: {__typename?: 'UserSurveySubmission'; id: string} | null;
      } | null;
    };
  };
};

export type SurveyQueryVariables = Exact<{
  input: GetSurveyInput;
}>;

export type SurveyQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    mostRecentLabSubmission?: {
      __typename?: 'LabSubmission';
      id: string;
      userSurveySubmission?: {__typename?: 'UserSurveySubmission'; id: string} | null;
    } | null;
    mostRecentLabSubmissionWithResults?: {__typename?: 'LabSubmission'; id: string} | null;
  };
  survey?: {
    __typename?: 'Survey';
    id: string;
    key: string;
    categories: Array<{
      __typename?: 'Category';
      id: string;
      description?: string | null;
      key: CategoryKeyEnum;
      title: string;
      steps: Array<{
        __typename?: 'Step';
        id: string;
        stepType: StepTypeEnum;
        question: {
          __typename?: 'Question';
          id: string;
          description?: string | null;
          questionType: QuestionTypeEnum;
          text: string;
          multipleChoiceConfiguration?: {
            __typename?: 'QuestionMultipleChoiceConfiguration';
            questionChoiceType: QuestionChoiceTypeEnum;
            options: Array<{__typename?: 'MultipleChoiceOption'; id: string; text: string}>;
          } | null;
          longTextConfiguration?: {
            __typename?: 'QuestionLongTextConfiguration';
            placeholder?: string | null;
            minLength?: number | null;
            maxLength?: number | null;
            defaultValue?: string | null;
          } | null;
        };
      }>;
    }>;
  } | null;
};

export type SaveSurveyOnboardingVariables = Exact<{
  input: SaveUserSurveySubmissionInput;
}>;

export type SaveSurveyOnboarding = {
  __typename?: 'Mutation';
  saveUserSurveySubmission: {
    __typename?: 'UserSurveySubmission';
    answers: Array<{
      __typename?: 'UserSurveySubmissionAnswer';
      questionId: string;
      answerOptionIds?: Array<string> | null;
    }>;
  };
};

export type SurveyQueryOnboardingVariables = Exact<{
  input: GetSurveyInput;
}>;

export type SurveyQueryOnboarding = {
  __typename?: 'Query';
  survey?: {
    __typename?: 'Survey';
    id: string;
    key: string;
    questions: Array<{
      __typename?: 'Question';
      id: string;
      description?: string | null;
      text: string;
      questionType: QuestionTypeEnum;
      multipleChoiceConfiguration?: {
        __typename?: 'QuestionMultipleChoiceConfiguration';
        questionChoiceType: QuestionChoiceTypeEnum;
        options: Array<{
          __typename?: 'MultipleChoiceOption';
          id: string;
          description?: string | null;
          text: string;
        }>;
        scale?: {__typename?: 'MultipleChoiceScale'; from: string; to: string} | null;
      } | null;
    }>;
  } | null;
};

export type VerifyAccountQueryVariables = Exact<{[key: string]: never}>;

export type VerifyAccountQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    isVerified: boolean;
    userProfile?: {__typename?: 'UserProfile'; email?: string | null; id: string} | null;
  };
};

export type ChangeEmailVariables = Exact<{
  input: ChangeEmailInput;
}>;

export type ChangeEmail = {
  __typename?: 'Mutation';
  changeEmail: {__typename?: 'GenericResponse'; success: boolean};
};

export type ReRequestEmailChangeVariables = Exact<{
  input: ReRequestEmailChangeInput;
}>;

export type ReRequestEmailChange = {
  __typename?: 'Mutation';
  reRequestEmailChange: {__typename?: 'GenericResponse'; success: boolean};
};

export type VerifyPendingQueryVariables = Exact<{[key: string]: never}>;

export type VerifyPendingQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    isVerified: boolean;
    userProfile?: {__typename?: 'UserProfile'; email?: string | null; id: string} | null;
  };
};

export type ActionPlanAdjustmentListFragment = {
  __typename?: 'HealthFactorAdjustment';
  id: string;
  selected: boolean;
  recommendedResponse: string;
  healthFactorAssessment?: {
    __typename?: 'HealthFactorAssessment';
    id: string;
    healthFactor?: {
      __typename?: 'HealthFactor';
      id: string;
      recommendedResponse?: string | null;
      title?: string | null;
    } | null;
  } | null;
};

export type HealthFactorAssessmentFragment = {
  __typename?: 'HealthFactorAssessment';
  id: string;
  meetsRequirements: boolean;
  healthFactor?: {
    __typename?: 'HealthFactor';
    id: string;
    benefits?: string | null;
    tips?: string | null;
    imageUrl?: string | null;
    title?: string | null;
    recommendationDescription?: string | null;
  } | null;
  categoryAssessment?: {
    __typename?: 'CategoryAssessment';
    id: string;
    category: {__typename?: 'Category'; id: string; title: string; key: CategoryKeyEnum};
  } | null;
};

export type ActionPlanAdjustmentFragment = {
  __typename?: 'HealthFactorAdjustment';
  id: string;
  healthFactorId?: string | null;
  selected: boolean;
  default: boolean;
  impactValue: number;
  impactLevel?: ActionPlanImpactLevel | null;
  recommended: boolean;
  recommendedResponse: string;
  emergingResearch: boolean;
  healthFactorAssessment?: {
    __typename?: 'HealthFactorAssessment';
    id: string;
    meetsRequirements: boolean;
    healthFactor?: {
      __typename?: 'HealthFactor';
      id: string;
      benefits?: string | null;
      tips?: string | null;
      imageUrl?: string | null;
      title?: string | null;
      recommendationDescription?: string | null;
    } | null;
    categoryAssessment?: {
      __typename?: 'CategoryAssessment';
      id: string;
      category: {__typename?: 'Category'; id: string; title: string; key: CategoryKeyEnum};
    } | null;
  } | null;
};

export type UpdateUserAvatarVariables = Exact<{
  input: UpdateUserInput;
  imageVariant: FileImageVariant;
}>;

export type UpdateUserAvatar = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'User';
    id: string;
    avatar?: {__typename?: 'File'; id: string; url?: string | null} | null;
  };
};

export type GetPromotionalBannerVariables = Exact<{[key: string]: never}>;

export type GetPromotionalBanner = {
  __typename?: 'Query';
  promotionalBanner?: {
    __typename?: 'PromotionalBanner';
    id: string;
    title: string;
    content?: any | null;
    textColor?: string | null;
    backgroundColor?: string | null;
    isBannerActive: boolean;
  } | null;
};

export type LearningResourceCardFragment = {
  __typename?: 'LearningResource';
  id: string;
  duration?: string | null;
  imageUrl: string;
  title: string;
  type: LearningResourceType;
};

export type ReferenceListItemFragment = {
  __typename?: 'Reference';
  id: string;
  title?: string | null;
  publication?: string | null;
  url?: string | null;
  labels: Array<string>;
};

export type FormattedAgeFragment = {__typename?: 'FormattedAge'; months: number; years: number};

export type TestResultCategory = {
  __typename?: 'CategoryAssessment';
  categoryScore: number;
  id: string;
  maxCategoryScore: number;
  category: {__typename?: 'Category'; id: string; title: string};
};

export type TestResultLabSubmission = {
  __typename?: 'LabSubmission';
  id: string;
  registeredDate: any;
  labAssessment?: {
    __typename?: 'LabAssessment';
    bioAge: number;
    chronologicalAge: number;
    deltaAge: number;
    id: string;
    formattedBioAge: {__typename?: 'FormattedAge'; months: number; years: number};
    formattedChronologicalAge: {__typename?: 'FormattedAge'; months: number; years: number};
    formattedDeltaAge: {__typename?: 'FormattedAge'; months: number; years: number};
  } | null;
  userSurveySubmission?: {
    __typename?: 'UserSurveySubmission';
    id: string;
    surveyAssessment?: {
      __typename?: 'SurveyAssessment';
      id: string;
      lifestyleScore?: number | null;
      maxLifestyleScore: number;
      categories: Array<{
        __typename?: 'CategoryAssessment';
        categoryScore: number;
        id: string;
        maxCategoryScore: number;
        category: {__typename?: 'Category'; id: string; title: string};
      }>;
    } | null;
  } | null;
};

export type SurveyQuestionFragment = {
  __typename?: 'Question';
  id: string;
  description?: string | null;
  questionType: QuestionTypeEnum;
  text: string;
  multipleChoiceConfiguration?: {
    __typename?: 'QuestionMultipleChoiceConfiguration';
    questionChoiceType: QuestionChoiceTypeEnum;
    options: Array<{__typename?: 'MultipleChoiceOption'; id: string; text: string}>;
  } | null;
  longTextConfiguration?: {
    __typename?: 'QuestionLongTextConfiguration';
    placeholder?: string | null;
    minLength?: number | null;
    maxLength?: number | null;
    defaultValue?: string | null;
  } | null;
};

export type UserIdentificationQueryVariables = Exact<{[key: string]: never}>;

export type UserIdentificationQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    labSubmissionsWithResultCount: number;
    userProfile?: {__typename?: 'UserProfile'; email?: string | null} | null;
    subscription?: {__typename?: 'Subscription'; hasActiveSubscription: boolean} | null;
    mostRecentLabSubmissionWithResults?: {
      __typename?: 'LabSubmission';
      id: string;
      labAssessment?: {__typename?: 'LabAssessment'; id: string; bioAge: number} | null;
      userSurveySubmission?: {
        __typename?: 'UserSurveySubmission';
        id: string;
        surveyAssessment?: {
          __typename?: 'SurveyAssessment';
          id: string;
          lifestyleScore?: number | null;
          selectedActionPlan?: {__typename?: 'ActionPlan'; id: string} | null;
        } | null;
      } | null;
    } | null;
  };
};

export type UserStateQueryVariables = Exact<{
  imageVariant: FileImageVariant;
}>;

export type UserStateQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    isVerified: boolean;
    timezone?: string | null;
    avatar?: {__typename?: 'File'; id: string; url?: string | null} | null;
    userProfile?: {
      __typename?: 'UserProfile';
      firstName?: string | null;
      id: string;
      email?: string | null;
      initials: string;
      lastName?: string | null;
    } | null;
    subscription?: {
      __typename?: 'Subscription';
      id: string;
      hasActiveSubscription: boolean;
      hasMembership: boolean;
    } | null;
  };
};

export const HealthFactorAssessmentFragment = gql`
  fragment HealthFactorAssessmentFragment on HealthFactorAssessment {
    id
    meetsRequirements
    healthFactor {
      id
      benefits
      tips
      imageUrl
      title
      recommendationDescription
    }
    categoryAssessment {
      id
      category {
        id
        title
        key
      }
    }
  }
`;
export const ActionPlanAdjustmentFragment = gql`
  fragment ActionPlanAdjustmentFragment on HealthFactorAdjustment {
    id
    healthFactorId
    selected
    default
    impactValue
    impactLevel
    recommended
    recommendedResponse
    emergingResearch
    healthFactorAssessment {
      ...HealthFactorAssessmentFragment
    }
  }
  ${HealthFactorAssessmentFragment}
`;
export const ActionPlanFragment = gql`
  fragment ActionPlanFragment on ActionPlan {
    id
    active
    adjustments {
      ...ActionPlanAdjustmentFragment
    }
  }
  ${ActionPlanAdjustmentFragment}
`;
export const CheckInFragment = gql`
  fragment CheckInFragment on CheckIn {
    id
    completed
    endedOn
    startedOn
  }
`;
export const CheckInCheckInQuestionFragment = gql`
  fragment CheckInCheckInQuestionFragment on CheckInQuestion {
    actionItemTitle
    answerBoolean
    benefits
    context
    healthFactor {
      id
      title
    }
    hitCount
    id
    imageUrl
    impactLevel
    tips
    title
  }
`;
export const CheckInCurrentTestPeriodCheckInFragment = gql`
  fragment CheckInCurrentTestPeriodCheckInFragment on CheckIn {
    completed
    id
    startedOn
  }
`;
export const CheckInCurrentTestPeriodFragment = gql`
  fragment CheckInCurrentTestPeriodFragment on TestPeriod {
    checkInStreakCount
    checkInStats(input: {includeCurrentCheckIn: true}) {
      completed
      endedOn
      startedOn
    }
    completedCheckIns
    earliestCheckInStartOn
    id
    startedAt
  }
`;
export const CheckInCardTestPeriodFragment = gql`
  fragment CheckInCardTestPeriodFragment on TestPeriod {
    checkInStats(input: {includeCurrentCheckIn: true}) {
      completed
      endedOn
      startedOn
    }
    id
    startedAt
  }
`;
export const DashboardLabStatusFragment = gql`
  fragment DashboardLabStatusFragment on LabStatus {
    id
    createdAt
    status
  }
`;
export const DashboardMostRecentLabSubmissionFragment = gql`
  fragment DashboardMostRecentLabSubmissionFragment on LabSubmission {
    id
    registeredDate
    status
    userSurveySubmission {
      id
      surveyAssessment {
        id
        lifestyleScore
        maxLifestyleScore
      }
    }
    labAssessment {
      id
    }
    labStatuses {
      ...DashboardLabStatusFragment
    }
  }
  ${DashboardLabStatusFragment}
`;
export const ActionPlanAdjustmentListFragment = gql`
  fragment ActionPlanAdjustmentListFragment on HealthFactorAdjustment {
    id
    selected
    healthFactorAssessment {
      healthFactor {
        id
        recommendedResponse
        title
      }
      id
    }
    recommendedResponse
  }
`;
export const SelectedActionPlanFragment = gql`
  fragment SelectedActionPlanFragment on ActionPlan {
    id
    adjustments {
      ...ActionPlanAdjustmentListFragment
    }
  }
  ${ActionPlanAdjustmentListFragment}
`;
export const SurveyAssessmentFragment = gql`
  fragment SurveyAssessmentFragment on SurveyAssessment {
    id
    lifestyleScore
    maxLifestyleScore
    categories {
      id
      meetsRequirements
      category {
        id
        title
        key
      }
    }
    selectedActionPlan {
      ...SelectedActionPlanFragment
    }
  }
  ${SelectedActionPlanFragment}
`;
export const AgeFormattedAgeFragment = gql`
  fragment AgeFormattedAgeFragment on FormattedAge {
    months
    years
  }
`;
export const AgeLabResultMetric = gql`
  fragment AgeLabResultMetric on LabResultMetric {
    id
    percentile
    type
  }
`;
export const AgeLabAssessmentFragment = gql`
  fragment AgeLabAssessmentFragment on LabAssessment {
    deltaAge
    formattedBioAge {
      ...AgeFormattedAgeFragment
    }
    formattedChronologicalAge {
      ...AgeFormattedAgeFragment
    }
    formattedDeltaAge {
      ...AgeFormattedAgeFragment
    }
    id
    labResultMetrics {
      ...AgeLabResultMetric
    }
  }
  ${AgeFormattedAgeFragment}
  ${AgeLabResultMetric}
`;
export const LabSubmissionRecordFragment = gql`
  fragment LabSubmissionRecordFragment on LabSubmissionRecord {
    hasViewedResultStory
    id
  }
`;
export const MostRecentLabSubmissionWithResultsFragment = gql`
  fragment MostRecentLabSubmissionWithResultsFragment on LabSubmission {
    id
    registeredDate
    status
    userSurveySubmission {
      id
      surveyAssessment {
        ...SurveyAssessmentFragment
      }
    }
    labAssessment {
      ...AgeLabAssessmentFragment
    }
    labRecord {
      ...LabSubmissionRecordFragment
    }
  }
  ${SurveyAssessmentFragment}
  ${AgeLabAssessmentFragment}
  ${LabSubmissionRecordFragment}
`;
export const DashboardUserFragment = gql`
  fragment DashboardUserFragment on User {
    id
    labSubmissions {
      id
    }
    mostRecentLabSubmission {
      ...DashboardMostRecentLabSubmissionFragment
    }
    mostRecentLabSubmissionWithResults {
      ...MostRecentLabSubmissionWithResultsFragment
    }
    subscription {
      hasActiveSubscription
      hasMembership
      id
    }
    userProfile {
      id
      firstName
    }
    customerAccount {
      id
      subscription {
        id
        status
        hasMembership
        items {
          id
          productId
          variantId
          variantSku
          title
          quantity
          price
        }
        pausedProductVariantIds
      }
    }
  }
  ${DashboardMostRecentLabSubmissionFragment}
  ${MostRecentLabSubmissionWithResultsFragment}
`;
export const ContactDetailsUserProfileFragment = gql`
  fragment ContactDetailsUserProfileFragment on UserProfile {
    email
    formattedPhoneNumber @client
    id
    phoneNumber
  }
`;
export const HealthFactorAssessmentQuestion = gql`
  fragment HealthFactorAssessmentQuestion on Question {
    id
    text
    questionType
    multipleChoiceConfiguration {
      questionChoiceType
      options {
        id
        text
      }
    }
  }
`;
export const HealthFactorAssessmentAnswer = gql`
  fragment HealthFactorAssessmentAnswer on UserSurveySubmissionAnswer {
    answerDate
    answerNumeric
    answerOptionIds
    answerText
    questionId
  }
`;
export const LifestylePreviewCategoryFragment = gql`
  fragment LifestylePreviewCategoryFragment on CategoryAssessment {
    category {
      id
      title
    }
    categoryScore
    id
    maxCategoryScore
  }
`;
export const LifestyleSummaryMostRecentLabSubmissionFragment = gql`
  fragment LifestyleSummaryMostRecentLabSubmissionFragment on LabSubmission {
    id
    registeredDate
    userSurveySubmission {
      id
      surveyAssessment {
        id
        lifestyleScore
        maxLifestyleScore
      }
    }
  }
`;
export const LifestyleCategoryAssessmentFragment = gql`
  fragment LifestyleCategoryAssessmentFragment on CategoryAssessment {
    id
    categoryScore
    maxCategoryScore
    meetsRequirements
    category {
      id
      key
      description
      title
    }
    factorAssessments {
      id
      meetsRequirements
      healthFactor {
        id
        impactLevel
        recommendedResponse
        recommendationTitle
        title
      }
    }
  }
`;
export const LifestyleSummaryMostRecentLabSubmissionWithResultsFragment = gql`
  fragment LifestyleSummaryMostRecentLabSubmissionWithResultsFragment on LabSubmission {
    id
    registeredDate
    userSurveySubmission {
      id
      surveyAssessment {
        categories {
          id
          ...LifestyleCategoryAssessmentFragment
        }
        id
        lifestyleScore
        maxLifestyleScore
        surveyId
        surveyKey
        selectedActionPlan {
          id
        }
      }
    }
  }
  ${LifestyleCategoryAssessmentFragment}
`;
export const MyTallyAgeFormattedAgeFragment = gql`
  fragment MyTallyAgeFormattedAgeFragment on FormattedAge {
    months
    years
  }
`;
export const MyTallyAgeLabResultMetric = gql`
  fragment MyTallyAgeLabResultMetric on LabResultMetric {
    id
    percentile
    type
  }
`;
export const MyTallyAgeLabAssessmentFragment = gql`
  fragment MyTallyAgeLabAssessmentFragment on LabAssessment {
    deltaAge
    formattedBioAge {
      ...MyTallyAgeFormattedAgeFragment
    }
    formattedChronologicalAge {
      ...MyTallyAgeFormattedAgeFragment
    }
    formattedDeltaAge {
      ...MyTallyAgeFormattedAgeFragment
    }
    id
    labResultMetrics {
      ...MyTallyAgeLabResultMetric
    }
    reportUrl
  }
  ${MyTallyAgeFormattedAgeFragment}
  ${MyTallyAgeLabResultMetric}
`;
export const NotificationQueryFragment = gql`
  fragment NotificationQueryFragment on User {
    id
    receiveEmailNotification
    receiveSMSNotification
  }
`;
export const CustomerSubscriptionInfoBoxesFragment = gql`
  fragment CustomerSubscriptionInfoBoxesFragment on Subscription {
    id
    hasMembership
    paymentMethodId
    discounts {
      title
      amount
      type
      category
      productVariantId
    }
  }
`;
export const LearningResourceCardFragment = gql`
  fragment LearningResourceCardFragment on LearningResource {
    id
    duration
    imageUrl
    title
    type
  }
`;
export const ReferenceListItemFragment = gql`
  fragment ReferenceListItemFragment on Reference {
    id
    title
    publication
    url
    labels
  }
`;
export const FormattedAgeFragment = gql`
  fragment FormattedAgeFragment on FormattedAge {
    months
    years
  }
`;
export const TestResultCategory = gql`
  fragment TestResultCategory on CategoryAssessment {
    category {
      id
      title
    }
    categoryScore
    id
    maxCategoryScore
  }
`;
export const TestResultLabSubmission = gql`
  fragment TestResultLabSubmission on LabSubmission {
    id
    labAssessment {
      bioAge
      chronologicalAge
      deltaAge
      formattedBioAge {
        ...FormattedAgeFragment
      }
      formattedChronologicalAge {
        ...FormattedAgeFragment
      }
      formattedDeltaAge {
        ...FormattedAgeFragment
      }
      id
    }
    registeredDate
    userSurveySubmission {
      id
      surveyAssessment {
        categories {
          ...TestResultCategory
        }
        id
        lifestyleScore
        maxLifestyleScore
      }
    }
  }
  ${FormattedAgeFragment}
  ${TestResultCategory}
`;
export const SurveyQuestionFragment = gql`
  fragment SurveyQuestionFragment on Question {
    id
    description
    questionType
    text
    multipleChoiceConfiguration {
      questionChoiceType
      options {
        id
        text
      }
    }
    longTextConfiguration {
      placeholder
      minLength
      maxLength
      defaultValue
    }
  }
`;
export const MarkDocument = gql`
  mutation mark($input: VerifyUserInput!) {
    verifyUser(input: $input) {
      message
      success
    }
  }
`;
export type MarkMutationFn = Apollo.MutationFunction<Mark, MarkVariables>;

/**
 * __useMark__
 *
 * To run a mutation, you first call `useMark` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMark` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mark, { data, loading, error }] = useMark({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMark(baseOptions?: Apollo.MutationHookOptions<Mark, MarkVariables>) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<Mark, MarkVariables>(MarkDocument, options);
}
export type MarkHookResult = ReturnType<typeof useMark>;
export type MarkMutationResult = Apollo.MutationResult<Mark>;
export type MarkMutationOptions = Apollo.BaseMutationOptions<Mark, MarkVariables>;
export const CreateAuthenticationTokenMutationDocument = gql`
  mutation CreateAuthenticationTokenMutation($email: String!, $password: String!) {
    accessToken: createAccessToken(
      input: {type: Authentication, email: $email, password: $password}
    ) {
      token
      userId
    }
  }
`;
export type CreateAuthenticationTokenMutationMutationFn = Apollo.MutationFunction<
  CreateAuthenticationTokenMutation,
  CreateAuthenticationTokenMutationVariables
>;

/**
 * __useCreateAuthenticationTokenMutation__
 *
 * To run a mutation, you first call `useCreateAuthenticationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthenticationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthenticationTokenMutation, { data, loading, error }] = useCreateAuthenticationTokenMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCreateAuthenticationTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAuthenticationTokenMutation,
    CreateAuthenticationTokenMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CreateAuthenticationTokenMutation,
    CreateAuthenticationTokenMutationVariables
  >(CreateAuthenticationTokenMutationDocument, options);
}
export type CreateAuthenticationTokenMutationHookResult = ReturnType<
  typeof useCreateAuthenticationTokenMutation
>;
export type CreateAuthenticationTokenMutationMutationResult =
  Apollo.MutationResult<CreateAuthenticationTokenMutation>;
export type CreateAuthenticationTokenMutationMutationOptions = Apollo.BaseMutationOptions<
  CreateAuthenticationTokenMutation,
  CreateAuthenticationTokenMutationVariables
>;
export const CreateFileMutationDocument = gql`
  mutation CreateFileMutation($input: CreateFileInput!) {
    createFile(input: $input) {
      id
      uploadUrl
      contentType
    }
  }
`;
export type CreateFileMutationMutationFn = Apollo.MutationFunction<
  CreateFileMutation,
  CreateFileMutationVariables
>;

/**
 * __useCreateFileMutation__
 *
 * To run a mutation, you first call `useCreateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileMutation, { data, loading, error }] = useCreateFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFileMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateFileMutation, CreateFileMutationVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<CreateFileMutation, CreateFileMutationVariables>(
    CreateFileMutationDocument,
    options,
  );
}
export type CreateFileMutationHookResult = ReturnType<typeof useCreateFileMutation>;
export type CreateFileMutationMutationResult = Apollo.MutationResult<CreateFileMutation>;
export type CreateFileMutationMutationOptions = Apollo.BaseMutationOptions<
  CreateFileMutation,
  CreateFileMutationVariables
>;
export const CreateLabSubmissionMutationDocument = gql`
  mutation CreateLabSubmissionMutation($input: CreateLabSubmissionInput!) {
    labSubmission: createLabSubmission(input: $input) {
      id
    }
  }
`;
export type CreateLabSubmissionMutationMutationFn = Apollo.MutationFunction<
  CreateLabSubmissionMutation,
  CreateLabSubmissionMutationVariables
>;

/**
 * __useCreateLabSubmissionMutation__
 *
 * To run a mutation, you first call `useCreateLabSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLabSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLabSubmissionMutation, { data, loading, error }] = useCreateLabSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLabSubmissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLabSubmissionMutation,
    CreateLabSubmissionMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<CreateLabSubmissionMutation, CreateLabSubmissionMutationVariables>(
    CreateLabSubmissionMutationDocument,
    options,
  );
}
export type CreateLabSubmissionMutationHookResult = ReturnType<
  typeof useCreateLabSubmissionMutation
>;
export type CreateLabSubmissionMutationMutationResult =
  Apollo.MutationResult<CreateLabSubmissionMutation>;
export type CreateLabSubmissionMutationMutationOptions = Apollo.BaseMutationOptions<
  CreateLabSubmissionMutation,
  CreateLabSubmissionMutationVariables
>;
export const UpdateLabSubmissionMutationDocument = gql`
  mutation UpdateLabSubmissionMutation($input: UpdateLabSubmissionInput!) {
    labSubmission: updateLabSubmission(input: $input) {
      id
    }
  }
`;
export type UpdateLabSubmissionMutationMutationFn = Apollo.MutationFunction<
  UpdateLabSubmissionMutation,
  UpdateLabSubmissionMutationVariables
>;

/**
 * __useUpdateLabSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateLabSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLabSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLabSubmissionMutation, { data, loading, error }] = useUpdateLabSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLabSubmissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLabSubmissionMutation,
    UpdateLabSubmissionMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateLabSubmissionMutation, UpdateLabSubmissionMutationVariables>(
    UpdateLabSubmissionMutationDocument,
    options,
  );
}
export type UpdateLabSubmissionMutationHookResult = ReturnType<
  typeof useUpdateLabSubmissionMutation
>;
export type UpdateLabSubmissionMutationMutationResult =
  Apollo.MutationResult<UpdateLabSubmissionMutation>;
export type UpdateLabSubmissionMutationMutationOptions = Apollo.BaseMutationOptions<
  UpdateLabSubmissionMutation,
  UpdateLabSubmissionMutationVariables
>;
export const MarkActionPlanOnboardingCompleteDocument = gql`
  mutation markActionPlanOnboardingComplete {
    markActionPlanOnboardingComplete {
      id
      completedActionPlanOnboarding
    }
  }
`;
export type MarkActionPlanOnboardingCompleteMutationFn = Apollo.MutationFunction<
  MarkActionPlanOnboardingComplete,
  MarkActionPlanOnboardingCompleteVariables
>;

/**
 * __useMarkActionPlanOnboardingComplete__
 *
 * To run a mutation, you first call `useMarkActionPlanOnboardingComplete` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkActionPlanOnboardingComplete` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markActionPlanOnboardingComplete, { data, loading, error }] = useMarkActionPlanOnboardingComplete({
 *   variables: {
 *   },
 * });
 */
export function useMarkActionPlanOnboardingComplete(
  baseOptions?: Apollo.MutationHookOptions<
    MarkActionPlanOnboardingComplete,
    MarkActionPlanOnboardingCompleteVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    MarkActionPlanOnboardingComplete,
    MarkActionPlanOnboardingCompleteVariables
  >(MarkActionPlanOnboardingCompleteDocument, options);
}
export type MarkActionPlanOnboardingCompleteHookResult = ReturnType<
  typeof useMarkActionPlanOnboardingComplete
>;
export type MarkActionPlanOnboardingCompleteMutationResult =
  Apollo.MutationResult<MarkActionPlanOnboardingComplete>;
export type MarkActionPlanOnboardingCompleteMutationOptions = Apollo.BaseMutationOptions<
  MarkActionPlanOnboardingComplete,
  MarkActionPlanOnboardingCompleteVariables
>;
export const RequestVerificationMutationDocument = gql`
  mutation RequestVerificationMutation {
    requestVerification {
      message
      success
    }
  }
`;
export type RequestVerificationMutationMutationFn = Apollo.MutationFunction<
  RequestVerificationMutation,
  RequestVerificationMutationVariables
>;

/**
 * __useRequestVerificationMutation__
 *
 * To run a mutation, you first call `useRequestVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestVerificationMutation, { data, loading, error }] = useRequestVerificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestVerificationMutation,
    RequestVerificationMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<RequestVerificationMutation, RequestVerificationMutationVariables>(
    RequestVerificationMutationDocument,
    options,
  );
}
export type RequestVerificationMutationHookResult = ReturnType<
  typeof useRequestVerificationMutation
>;
export type RequestVerificationMutationMutationResult =
  Apollo.MutationResult<RequestVerificationMutation>;
export type RequestVerificationMutationMutationOptions = Apollo.BaseMutationOptions<
  RequestVerificationMutation,
  RequestVerificationMutationVariables
>;
export const SetTimeZoneDocument = gql`
  mutation SetTimeZone($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      timezone
    }
  }
`;
export type SetTimeZoneMutationFn = Apollo.MutationFunction<SetTimeZone, SetTimeZoneVariables>;

/**
 * __useSetTimeZone__
 *
 * To run a mutation, you first call `useSetTimeZone` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTimeZone` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTimeZone, { data, loading, error }] = useSetTimeZone({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTimeZone(
  baseOptions?: Apollo.MutationHookOptions<SetTimeZone, SetTimeZoneVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SetTimeZone, SetTimeZoneVariables>(SetTimeZoneDocument, options);
}
export type SetTimeZoneHookResult = ReturnType<typeof useSetTimeZone>;
export type SetTimeZoneMutationResult = Apollo.MutationResult<SetTimeZone>;
export type SetTimeZoneMutationOptions = Apollo.BaseMutationOptions<
  SetTimeZone,
  SetTimeZoneVariables
>;
export const UpdateViewedResultsHistoryDocument = gql`
  mutation updateViewedResultsHistory {
    updateViewedResultsHistory {
      hasViewedResultsHistory
      id
    }
  }
`;
export type UpdateViewedResultsHistoryMutationFn = Apollo.MutationFunction<
  UpdateViewedResultsHistory,
  UpdateViewedResultsHistoryVariables
>;

/**
 * __useUpdateViewedResultsHistory__
 *
 * To run a mutation, you first call `useUpdateViewedResultsHistory` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateViewedResultsHistory` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateViewedResultsHistory, { data, loading, error }] = useUpdateViewedResultsHistory({
 *   variables: {
 *   },
 * });
 */
export function useUpdateViewedResultsHistory(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateViewedResultsHistory,
    UpdateViewedResultsHistoryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateViewedResultsHistory, UpdateViewedResultsHistoryVariables>(
    UpdateViewedResultsHistoryDocument,
    options,
  );
}
export type UpdateViewedResultsHistoryHookResult = ReturnType<typeof useUpdateViewedResultsHistory>;
export type UpdateViewedResultsHistoryMutationResult =
  Apollo.MutationResult<UpdateViewedResultsHistory>;
export type UpdateViewedResultsHistoryMutationOptions = Apollo.BaseMutationOptions<
  UpdateViewedResultsHistory,
  UpdateViewedResultsHistoryVariables
>;
export const VerifyUserDocument = gql`
  mutation VerifyUser($input: VerifyUserInput!) {
    verifyUser(input: $input) {
      message
      success
    }
  }
`;
export type VerifyUserMutationFn = Apollo.MutationFunction<VerifyUser, VerifyUserVariables>;

/**
 * __useVerifyUser__
 *
 * To run a mutation, you first call `useVerifyUser` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUser` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUser, { data, loading, error }] = useVerifyUser({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyUser(
  baseOptions?: Apollo.MutationHookOptions<VerifyUser, VerifyUserVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<VerifyUser, VerifyUserVariables>(VerifyUserDocument, options);
}
export type VerifyUserHookResult = ReturnType<typeof useVerifyUser>;
export type VerifyUserMutationResult = Apollo.MutationResult<VerifyUser>;
export type VerifyUserMutationOptions = Apollo.BaseMutationOptions<VerifyUser, VerifyUserVariables>;
export const MultipassUrlQueryDocument = gql`
  query MultipassUrlQuery($returnUrl: String!) {
    me {
      id
      multipassUrl(returnUrl: $returnUrl)
    }
  }
`;

/**
 * __useMultipassUrlQuery__
 *
 * To run a query within a React component, call `useMultipassUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultipassUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultipassUrlQuery({
 *   variables: {
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useMultipassUrlQuery(
  baseOptions: Apollo.QueryHookOptions<MultipassUrlQuery, MultipassUrlQueryVariables> &
    ({variables: MultipassUrlQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<MultipassUrlQuery, MultipassUrlQueryVariables>(
    MultipassUrlQueryDocument,
    options,
  );
}
export function useMultipassUrlQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MultipassUrlQuery, MultipassUrlQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<MultipassUrlQuery, MultipassUrlQueryVariables>(
    MultipassUrlQueryDocument,
    options,
  );
}
export function useMultipassUrlQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MultipassUrlQuery, MultipassUrlQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<MultipassUrlQuery, MultipassUrlQueryVariables>(
    MultipassUrlQueryDocument,
    options,
  );
}
export type MultipassUrlQueryHookResult = ReturnType<typeof useMultipassUrlQuery>;
export type MultipassUrlQueryLazyQueryHookResult = ReturnType<typeof useMultipassUrlQueryLazyQuery>;
export type MultipassUrlQuerySuspenseQueryHookResult = ReturnType<
  typeof useMultipassUrlQuerySuspenseQuery
>;
export type MultipassUrlQueryQueryResult = Apollo.QueryResult<
  MultipassUrlQuery,
  MultipassUrlQueryVariables
>;
export const SurveyIdQueryDocument = gql`
  query SurveyIdQuery($input: GetSurveyInput!) {
    survey(input: $input) {
      id
    }
  }
`;

/**
 * __useSurveyIdQuery__
 *
 * To run a query within a React component, call `useSurveyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSurveyIdQuery(
  baseOptions: Apollo.QueryHookOptions<SurveyIdQuery, SurveyIdQueryVariables> &
    ({variables: SurveyIdQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SurveyIdQuery, SurveyIdQueryVariables>(SurveyIdQueryDocument, options);
}
export function useSurveyIdQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SurveyIdQuery, SurveyIdQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SurveyIdQuery, SurveyIdQueryVariables>(SurveyIdQueryDocument, options);
}
export function useSurveyIdQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SurveyIdQuery, SurveyIdQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SurveyIdQuery, SurveyIdQueryVariables>(
    SurveyIdQueryDocument,
    options,
  );
}
export type SurveyIdQueryHookResult = ReturnType<typeof useSurveyIdQuery>;
export type SurveyIdQueryLazyQueryHookResult = ReturnType<typeof useSurveyIdQueryLazyQuery>;
export type SurveyIdQuerySuspenseQueryHookResult = ReturnType<typeof useSurveyIdQuerySuspenseQuery>;
export type SurveyIdQueryQueryResult = Apollo.QueryResult<SurveyIdQuery, SurveyIdQueryVariables>;
export const RequestEmailChangeDocument = gql`
  mutation RequestEmailChange($input: RequestEmailChangeInput!) {
    requestEmailChange(input: $input) {
      success
    }
  }
`;
export type RequestEmailChangeMutationFn = Apollo.MutationFunction<
  RequestEmailChange,
  RequestEmailChangeVariables
>;

/**
 * __useRequestEmailChange__
 *
 * To run a mutation, you first call `useRequestEmailChange` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEmailChange` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEmailChange, { data, loading, error }] = useRequestEmailChange({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestEmailChange(
  baseOptions?: Apollo.MutationHookOptions<RequestEmailChange, RequestEmailChangeVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<RequestEmailChange, RequestEmailChangeVariables>(
    RequestEmailChangeDocument,
    options,
  );
}
export type RequestEmailChangeHookResult = ReturnType<typeof useRequestEmailChange>;
export type RequestEmailChangeMutationResult = Apollo.MutationResult<RequestEmailChange>;
export type RequestEmailChangeMutationOptions = Apollo.BaseMutationOptions<
  RequestEmailChange,
  RequestEmailChangeVariables
>;
export const ActionPlanPageQueryDocument = gql`
  query ActionPlanPageQuery {
    me {
      id
      subscription {
        id
        hasActiveSubscription
        hasMembership
      }
      userProfile {
        id
        firstName
      }
      mostRecentLabSubmission {
        id
        userSurveySubmission {
          id
        }
      }
      mostRecentLabSubmissionWithResults {
        id
        registeredDate
        labAssessment {
          deltaAge
          id
        }
        userSurveySubmission {
          id
          surveyAssessment {
            id
            submissionId
            actionPlans {
              ...ActionPlanFragment
            }
          }
        }
      }
      completedActionPlanOnboarding
    }
    currentCheckIn {
      id
      ...CheckInFragment
    }
    currentTestPeriod {
      checkInStats(input: {includeCurrentCheckIn: true}) {
        completed
        endedOn
        startedOn
      }
      id
      startedAt
    }
  }
  ${ActionPlanFragment}
  ${CheckInFragment}
`;

/**
 * __useActionPlanPageQuery__
 *
 * To run a query within a React component, call `useActionPlanPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionPlanPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionPlanPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useActionPlanPageQuery(
  baseOptions?: Apollo.QueryHookOptions<ActionPlanPageQuery, ActionPlanPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ActionPlanPageQuery, ActionPlanPageQueryVariables>(
    ActionPlanPageQueryDocument,
    options,
  );
}
export function useActionPlanPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ActionPlanPageQuery, ActionPlanPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ActionPlanPageQuery, ActionPlanPageQueryVariables>(
    ActionPlanPageQueryDocument,
    options,
  );
}
export function useActionPlanPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActionPlanPageQuery, ActionPlanPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ActionPlanPageQuery, ActionPlanPageQueryVariables>(
    ActionPlanPageQueryDocument,
    options,
  );
}
export type ActionPlanPageQueryHookResult = ReturnType<typeof useActionPlanPageQuery>;
export type ActionPlanPageQueryLazyQueryHookResult = ReturnType<
  typeof useActionPlanPageQueryLazyQuery
>;
export type ActionPlanPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useActionPlanPageQuerySuspenseQuery
>;
export type ActionPlanPageQueryQueryResult = Apollo.QueryResult<
  ActionPlanPageQuery,
  ActionPlanPageQueryVariables
>;
export const ChangePasswordQueryDocument = gql`
  query ChangePasswordQuery {
    me {
      id
      userProfile {
        id
        email
      }
    }
  }
`;

/**
 * __useChangePasswordQuery__
 *
 * To run a query within a React component, call `useChangePasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangePasswordQuery({
 *   variables: {
 *   },
 * });
 */
export function useChangePasswordQuery(
  baseOptions?: Apollo.QueryHookOptions<ChangePasswordQuery, ChangePasswordQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ChangePasswordQuery, ChangePasswordQueryVariables>(
    ChangePasswordQueryDocument,
    options,
  );
}
export function useChangePasswordQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ChangePasswordQuery, ChangePasswordQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ChangePasswordQuery, ChangePasswordQueryVariables>(
    ChangePasswordQueryDocument,
    options,
  );
}
export function useChangePasswordQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChangePasswordQuery, ChangePasswordQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ChangePasswordQuery, ChangePasswordQueryVariables>(
    ChangePasswordQueryDocument,
    options,
  );
}
export type ChangePasswordQueryHookResult = ReturnType<typeof useChangePasswordQuery>;
export type ChangePasswordQueryLazyQueryHookResult = ReturnType<
  typeof useChangePasswordQueryLazyQuery
>;
export type ChangePasswordQuerySuspenseQueryHookResult = ReturnType<
  typeof useChangePasswordQuerySuspenseQuery
>;
export type ChangePasswordQueryQueryResult = Apollo.QueryResult<
  ChangePasswordQuery,
  ChangePasswordQueryVariables
>;
export const UpdateUserPasswordMutationDocument = gql`
  mutation UpdateUserPasswordMutation($input: UpdateUserPasswordInput!) {
    updateUserPassword(input: $input) {
      success
    }
  }
`;
export type UpdateUserPasswordMutationMutationFn = Apollo.MutationFunction<
  UpdateUserPasswordMutation,
  UpdateUserPasswordMutationVariables
>;

/**
 * __useUpdateUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPasswordMutation, { data, loading, error }] = useUpdateUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserPasswordMutation,
    UpdateUserPasswordMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(
    UpdateUserPasswordMutationDocument,
    options,
  );
}
export type UpdateUserPasswordMutationHookResult = ReturnType<typeof useUpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationMutationResult =
  Apollo.MutationResult<UpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserPasswordMutation,
  UpdateUserPasswordMutationVariables
>;
export const CheckInQueryDocument = gql`
  query CheckInQuery {
    currentCheckIn {
      ...CheckInCurrentTestPeriodCheckInFragment
      actionItemsHitPercentage
      endedOn
      submittedAt
      questions {
        ...CheckInCheckInQuestionFragment
      }
    }
    me {
      id
      subscription {
        hasActiveSubscription
      }
      mostRecentLabSubmissionWithResults {
        id
        userSurveySubmission {
          id
          surveyAssessment {
            id
            selectedActionPlan {
              id
            }
          }
        }
      }
    }
    currentTestPeriod {
      ...CheckInCurrentTestPeriodFragment
    }
  }
  ${CheckInCurrentTestPeriodCheckInFragment}
  ${CheckInCheckInQuestionFragment}
  ${CheckInCurrentTestPeriodFragment}
`;

/**
 * __useCheckInQuery__
 *
 * To run a query within a React component, call `useCheckInQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckInQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckInQuery(
  baseOptions?: Apollo.QueryHookOptions<CheckInQuery, CheckInQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CheckInQuery, CheckInQueryVariables>(CheckInQueryDocument, options);
}
export function useCheckInQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CheckInQuery, CheckInQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<CheckInQuery, CheckInQueryVariables>(CheckInQueryDocument, options);
}
export function useCheckInQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CheckInQuery, CheckInQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<CheckInQuery, CheckInQueryVariables>(
    CheckInQueryDocument,
    options,
  );
}
export type CheckInQueryHookResult = ReturnType<typeof useCheckInQuery>;
export type CheckInQueryLazyQueryHookResult = ReturnType<typeof useCheckInQueryLazyQuery>;
export type CheckInQuerySuspenseQueryHookResult = ReturnType<typeof useCheckInQuerySuspenseQuery>;
export type CheckInQueryQueryResult = Apollo.QueryResult<CheckInQuery, CheckInQueryVariables>;
export const CreateCheckInAnswersDocument = gql`
  mutation createCheckInAnswers($input: CreateCheckInAnswersInput!) {
    createCheckInAnswers(input: $input) {
      actionItemsHitPercentage
      completed
      id
      questions {
        answerBoolean
        hitCount
        id
      }
      testPeriod {
        ...CheckInCurrentTestPeriodFragment
      }
    }
  }
  ${CheckInCurrentTestPeriodFragment}
`;
export type CreateCheckInAnswersMutationFn = Apollo.MutationFunction<
  CreateCheckInAnswers,
  CreateCheckInAnswersVariables
>;

/**
 * __useCreateCheckInAnswers__
 *
 * To run a mutation, you first call `useCreateCheckInAnswers` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckInAnswers` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckInAnswers, { data, loading, error }] = useCreateCheckInAnswers({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckInAnswers(
  baseOptions?: Apollo.MutationHookOptions<CreateCheckInAnswers, CreateCheckInAnswersVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<CreateCheckInAnswers, CreateCheckInAnswersVariables>(
    CreateCheckInAnswersDocument,
    options,
  );
}
export type CreateCheckInAnswersHookResult = ReturnType<typeof useCreateCheckInAnswers>;
export type CreateCheckInAnswersMutationResult = Apollo.MutationResult<CreateCheckInAnswers>;
export type CreateCheckInAnswersMutationOptions = Apollo.BaseMutationOptions<
  CreateCheckInAnswers,
  CreateCheckInAnswersVariables
>;
export const CreateUserAccountMutationDocument = gql`
  mutation CreateUserAccountMutation($input: CreateUserAccountInput!) {
    createUserAccount(input: $input) {
      authToken
      userId
    }
  }
`;
export type CreateUserAccountMutationMutationFn = Apollo.MutationFunction<
  CreateUserAccountMutation,
  CreateUserAccountMutationVariables
>;

/**
 * __useCreateUserAccountMutation__
 *
 * To run a mutation, you first call `useCreateUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserAccountMutation, { data, loading, error }] = useCreateUserAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserAccountMutation,
    CreateUserAccountMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<CreateUserAccountMutation, CreateUserAccountMutationVariables>(
    CreateUserAccountMutationDocument,
    options,
  );
}
export type CreateUserAccountMutationHookResult = ReturnType<typeof useCreateUserAccountMutation>;
export type CreateUserAccountMutationMutationResult =
  Apollo.MutationResult<CreateUserAccountMutation>;
export type CreateUserAccountMutationMutationOptions = Apollo.BaseMutationOptions<
  CreateUserAccountMutation,
  CreateUserAccountMutationVariables
>;
export const UserAccountSearchDocument = gql`
  query UserAccountSearch($email: String!) {
    searchAccount(email: $email) {
      hasAccount
      subscriptionStatus
    }
  }
`;

/**
 * __useUserAccountSearch__
 *
 * To run a query within a React component, call `useUserAccountSearch` and pass it any options that fit your needs.
 * When your component renders, `useUserAccountSearch` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAccountSearch({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserAccountSearch(
  baseOptions: Apollo.QueryHookOptions<UserAccountSearch, UserAccountSearchVariables> &
    ({variables: UserAccountSearchVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<UserAccountSearch, UserAccountSearchVariables>(
    UserAccountSearchDocument,
    options,
  );
}
export function useUserAccountSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserAccountSearch, UserAccountSearchVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<UserAccountSearch, UserAccountSearchVariables>(
    UserAccountSearchDocument,
    options,
  );
}
export function useUserAccountSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserAccountSearch, UserAccountSearchVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<UserAccountSearch, UserAccountSearchVariables>(
    UserAccountSearchDocument,
    options,
  );
}
export type UserAccountSearchHookResult = ReturnType<typeof useUserAccountSearch>;
export type UserAccountSearchLazyQueryHookResult = ReturnType<typeof useUserAccountSearchLazyQuery>;
export type UserAccountSearchSuspenseQueryHookResult = ReturnType<
  typeof useUserAccountSearchSuspenseQuery
>;
export type UserAccountSearchQueryResult = Apollo.QueryResult<
  UserAccountSearch,
  UserAccountSearchVariables
>;
export const DashboardQueryDocument = gql`
  query DashboardQuery {
    me {
      ...DashboardUserFragment
    }
    currentTestPeriod {
      ...CheckInCardTestPeriodFragment
    }
    learningResources(input: {context: Dashboard}) {
      ...LearningResourceCardFragment
    }
  }
  ${DashboardUserFragment}
  ${CheckInCardTestPeriodFragment}
  ${LearningResourceCardFragment}
`;

/**
 * __useDashboardQuery__
 *
 * To run a query within a React component, call `useDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardQuery(
  baseOptions?: Apollo.QueryHookOptions<DashboardQuery, DashboardQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<DashboardQuery, DashboardQueryVariables>(DashboardQueryDocument, options);
}
export function useDashboardQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DashboardQuery, DashboardQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<DashboardQuery, DashboardQueryVariables>(
    DashboardQueryDocument,
    options,
  );
}
export function useDashboardQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DashboardQuery, DashboardQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<DashboardQuery, DashboardQueryVariables>(
    DashboardQueryDocument,
    options,
  );
}
export type DashboardQueryHookResult = ReturnType<typeof useDashboardQuery>;
export type DashboardQueryLazyQueryHookResult = ReturnType<typeof useDashboardQueryLazyQuery>;
export type DashboardQuerySuspenseQueryHookResult = ReturnType<
  typeof useDashboardQuerySuspenseQuery
>;
export type DashboardQueryQueryResult = Apollo.QueryResult<DashboardQuery, DashboardQueryVariables>;
export const UpdateActionPlanDocument = gql`
  mutation UpdateActionPlan($input: UpdateActionPlanInput!) {
    updateActionPlan(input: $input) {
      id
    }
  }
`;
export type UpdateActionPlanMutationFn = Apollo.MutationFunction<
  UpdateActionPlan,
  UpdateActionPlanVariables
>;

/**
 * __useUpdateActionPlan__
 *
 * To run a mutation, you first call `useUpdateActionPlan` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionPlan` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionPlan, { data, loading, error }] = useUpdateActionPlan({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActionPlan(
  baseOptions?: Apollo.MutationHookOptions<UpdateActionPlan, UpdateActionPlanVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateActionPlan, UpdateActionPlanVariables>(
    UpdateActionPlanDocument,
    options,
  );
}
export type UpdateActionPlanHookResult = ReturnType<typeof useUpdateActionPlan>;
export type UpdateActionPlanMutationResult = Apollo.MutationResult<UpdateActionPlan>;
export type UpdateActionPlanMutationOptions = Apollo.BaseMutationOptions<
  UpdateActionPlan,
  UpdateActionPlanVariables
>;
export const ContactDetailsQueryDocument = gql`
  query ContactDetailsQuery {
    me {
      id
      userProfile {
        ...ContactDetailsUserProfileFragment
      }
    }
  }
  ${ContactDetailsUserProfileFragment}
`;

/**
 * __useContactDetailsQuery__
 *
 * To run a query within a React component, call `useContactDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<ContactDetailsQuery, ContactDetailsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ContactDetailsQuery, ContactDetailsQueryVariables>(
    ContactDetailsQueryDocument,
    options,
  );
}
export function useContactDetailsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContactDetailsQuery, ContactDetailsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ContactDetailsQuery, ContactDetailsQueryVariables>(
    ContactDetailsQueryDocument,
    options,
  );
}
export function useContactDetailsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ContactDetailsQuery, ContactDetailsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ContactDetailsQuery, ContactDetailsQueryVariables>(
    ContactDetailsQueryDocument,
    options,
  );
}
export type ContactDetailsQueryHookResult = ReturnType<typeof useContactDetailsQuery>;
export type ContactDetailsQueryLazyQueryHookResult = ReturnType<
  typeof useContactDetailsQueryLazyQuery
>;
export type ContactDetailsQuerySuspenseQueryHookResult = ReturnType<
  typeof useContactDetailsQuerySuspenseQuery
>;
export type ContactDetailsQueryQueryResult = Apollo.QueryResult<
  ContactDetailsQuery,
  ContactDetailsQueryVariables
>;
export const UpdateContactDetailsDocument = gql`
  mutation UpdateContactDetails($input: UpdateUserProfileInput!) {
    updateUserProfile(input: $input) {
      ...ContactDetailsUserProfileFragment
    }
  }
  ${ContactDetailsUserProfileFragment}
`;
export type UpdateContactDetailsMutationFn = Apollo.MutationFunction<
  UpdateContactDetails,
  UpdateContactDetailsVariables
>;

/**
 * __useUpdateContactDetails__
 *
 * To run a mutation, you first call `useUpdateContactDetails` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactDetails` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactDetails, { data, loading, error }] = useUpdateContactDetails({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactDetails(
  baseOptions?: Apollo.MutationHookOptions<UpdateContactDetails, UpdateContactDetailsVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateContactDetails, UpdateContactDetailsVariables>(
    UpdateContactDetailsDocument,
    options,
  );
}
export type UpdateContactDetailsHookResult = ReturnType<typeof useUpdateContactDetails>;
export type UpdateContactDetailsMutationResult = Apollo.MutationResult<UpdateContactDetails>;
export type UpdateContactDetailsMutationOptions = Apollo.BaseMutationOptions<
  UpdateContactDetails,
  UpdateContactDetailsVariables
>;
export const EditProfileQueryDocument = gql`
  query EditProfileQuery($imageVariant: FileImageVariant!) {
    me {
      id
      avatar {
        id
        url(variant: $imageVariant, raw: false)
      }
      userProfile {
        email
        birthSex
        birthday
        firstName
        formattedBirthSex @client
        formattedBirthday @client
        formattedHeight @client
        formattedWeight @client
        formattedPhoneNumber @client
        phoneNumber
        height
        heightDisplayUnit
        id
        initials @client
        lastName
        pronouns
        weight
        weightDisplayUnit
      }
    }
  }
`;

/**
 * __useEditProfileQuery__
 *
 * To run a query within a React component, call `useEditProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProfileQuery({
 *   variables: {
 *      imageVariant: // value for 'imageVariant'
 *   },
 * });
 */
export function useEditProfileQuery(
  baseOptions: Apollo.QueryHookOptions<EditProfileQuery, EditProfileQueryVariables> &
    ({variables: EditProfileQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<EditProfileQuery, EditProfileQueryVariables>(
    EditProfileQueryDocument,
    options,
  );
}
export function useEditProfileQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EditProfileQuery, EditProfileQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<EditProfileQuery, EditProfileQueryVariables>(
    EditProfileQueryDocument,
    options,
  );
}
export function useEditProfileQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EditProfileQuery, EditProfileQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<EditProfileQuery, EditProfileQueryVariables>(
    EditProfileQueryDocument,
    options,
  );
}
export type EditProfileQueryHookResult = ReturnType<typeof useEditProfileQuery>;
export type EditProfileQueryLazyQueryHookResult = ReturnType<typeof useEditProfileQueryLazyQuery>;
export type EditProfileQuerySuspenseQueryHookResult = ReturnType<
  typeof useEditProfileQuerySuspenseQuery
>;
export type EditProfileQueryQueryResult = Apollo.QueryResult<
  EditProfileQuery,
  EditProfileQueryVariables
>;
export const UpdateUserProfileDocument = gql`
  mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
    updateUserProfile(input: $input) {
      birthSex
      birthday
      firstName
      height
      heightDisplayUnit
      id
      lastName
      pronouns
      weight
      weightDisplayUnit
    }
  }
`;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<
  UpdateUserProfile,
  UpdateUserProfileVariables
>;

/**
 * __useUpdateUserProfile__
 *
 * To run a mutation, you first call `useUpdateUserProfile` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfile` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfile, { data, loading, error }] = useUpdateUserProfile({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserProfile(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserProfile, UpdateUserProfileVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateUserProfile, UpdateUserProfileVariables>(
    UpdateUserProfileDocument,
    options,
  );
}
export type UpdateUserProfileHookResult = ReturnType<typeof useUpdateUserProfile>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfile>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserProfile,
  UpdateUserProfileVariables
>;
export const RequestPasswordResetDocument = gql`
  mutation RequestPasswordReset($input: RequestPasswordResetInput!) {
    requestPasswordReset(input: $input) {
      message
      success
    }
  }
`;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<
  RequestPasswordReset,
  RequestPasswordResetVariables
>;

/**
 * __useRequestPasswordReset__
 *
 * To run a mutation, you first call `useRequestPasswordReset` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordReset` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordReset, { data, loading, error }] = useRequestPasswordReset({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordReset(
  baseOptions?: Apollo.MutationHookOptions<RequestPasswordReset, RequestPasswordResetVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<RequestPasswordReset, RequestPasswordResetVariables>(
    RequestPasswordResetDocument,
    options,
  );
}
export type RequestPasswordResetHookResult = ReturnType<typeof useRequestPasswordReset>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordReset>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<
  RequestPasswordReset,
  RequestPasswordResetVariables
>;
export const HealthFactorQueryDocument = gql`
  query HealthFactorQuery($input: GetHealthFactorInput!) {
    healthFactor(input: $input) {
      id
      imageUrl
      impactLevel
      recommendationDescription
      recommendationTitle
      recommendedResponse
      title
      emergingResearch
      media {
        id
        thumbnailUrl
        url
      }
      references {
        id
        labels
        title
        url
      }
      researchSnack {
        id
        description
        title
      }
    }
  }
`;

/**
 * __useHealthFactorQuery__
 *
 * To run a query within a React component, call `useHealthFactorQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthFactorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthFactorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHealthFactorQuery(
  baseOptions: Apollo.QueryHookOptions<HealthFactorQuery, HealthFactorQueryVariables> &
    ({variables: HealthFactorQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<HealthFactorQuery, HealthFactorQueryVariables>(
    HealthFactorQueryDocument,
    options,
  );
}
export function useHealthFactorQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HealthFactorQuery, HealthFactorQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<HealthFactorQuery, HealthFactorQueryVariables>(
    HealthFactorQueryDocument,
    options,
  );
}
export function useHealthFactorQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HealthFactorQuery, HealthFactorQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<HealthFactorQuery, HealthFactorQueryVariables>(
    HealthFactorQueryDocument,
    options,
  );
}
export type HealthFactorQueryHookResult = ReturnType<typeof useHealthFactorQuery>;
export type HealthFactorQueryLazyQueryHookResult = ReturnType<typeof useHealthFactorQueryLazyQuery>;
export type HealthFactorQuerySuspenseQueryHookResult = ReturnType<
  typeof useHealthFactorQuerySuspenseQuery
>;
export type HealthFactorQueryQueryResult = Apollo.QueryResult<
  HealthFactorQuery,
  HealthFactorQueryVariables
>;
export const HealthFactorAssessmentQueryDocument = gql`
  query HealthFactorAssessmentQuery($input: GetSurveyAssessmentInput!) {
    me {
      id
      mostRecentLabSubmissionWithResults {
        id
        userSurveySubmission {
          id
          surveyAssessment {
            id
            selectedActionPlan {
              adjustments {
                ...ActionPlanAdjustmentListFragment
              }
              id
            }
          }
        }
      }
    }
    surveyAssessment(input: $input) {
      id
      categories {
        id
        category {
          id
          steps {
            id
            question {
              ...HealthFactorAssessmentQuestion
            }
          }
        }
        factorAssessments {
          id
          answerId
          meetsRequirements
          healthFactor {
            id
            imageUrl
            impactLevel
            questionId
            recommendationDescription
            recommendationTitle
            recommendedResponse
            title
            emergingResearch
            media {
              id
              thumbnailUrl
              url
            }
            references {
              id
              labels
              title
              url
            }
            researchSnack {
              id
              description
              title
            }
          }
        }
      }
      userSurveySubmission {
        id
        answers {
          ...HealthFactorAssessmentAnswer
        }
      }
    }
  }
  ${ActionPlanAdjustmentListFragment}
  ${HealthFactorAssessmentQuestion}
  ${HealthFactorAssessmentAnswer}
`;

/**
 * __useHealthFactorAssessmentQuery__
 *
 * To run a query within a React component, call `useHealthFactorAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthFactorAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthFactorAssessmentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHealthFactorAssessmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    HealthFactorAssessmentQuery,
    HealthFactorAssessmentQueryVariables
  > &
    ({variables: HealthFactorAssessmentQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<HealthFactorAssessmentQuery, HealthFactorAssessmentQueryVariables>(
    HealthFactorAssessmentQueryDocument,
    options,
  );
}
export function useHealthFactorAssessmentQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HealthFactorAssessmentQuery,
    HealthFactorAssessmentQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<HealthFactorAssessmentQuery, HealthFactorAssessmentQueryVariables>(
    HealthFactorAssessmentQueryDocument,
    options,
  );
}
export function useHealthFactorAssessmentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HealthFactorAssessmentQuery,
        HealthFactorAssessmentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<HealthFactorAssessmentQuery, HealthFactorAssessmentQueryVariables>(
    HealthFactorAssessmentQueryDocument,
    options,
  );
}
export type HealthFactorAssessmentQueryHookResult = ReturnType<
  typeof useHealthFactorAssessmentQuery
>;
export type HealthFactorAssessmentQueryLazyQueryHookResult = ReturnType<
  typeof useHealthFactorAssessmentQueryLazyQuery
>;
export type HealthFactorAssessmentQuerySuspenseQueryHookResult = ReturnType<
  typeof useHealthFactorAssessmentQuerySuspenseQuery
>;
export type HealthFactorAssessmentQueryQueryResult = Apollo.QueryResult<
  HealthFactorAssessmentQuery,
  HealthFactorAssessmentQueryVariables
>;
export const LearningResourceQueryDocument = gql`
  query LearningResourceQuery($learningResourceId: String!) {
    learningResource(input: {learningResourceId: $learningResourceId}) {
      id
      title
      slug
      type
      duration
      imageUrl
      body
      publishedDate
      updatedDate
      videoUrl
      author {
        name
        credentials
        avatarUrl
      }
      references {
        id
        ...ReferenceListItemFragment
      }
    }
    learningResources(input: {context: Learning}) {
      ...LearningResourceCardFragment
    }
  }
  ${ReferenceListItemFragment}
  ${LearningResourceCardFragment}
`;

/**
 * __useLearningResourceQuery__
 *
 * To run a query within a React component, call `useLearningResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningResourceQuery({
 *   variables: {
 *      learningResourceId: // value for 'learningResourceId'
 *   },
 * });
 */
export function useLearningResourceQuery(
  baseOptions: Apollo.QueryHookOptions<LearningResourceQuery, LearningResourceQueryVariables> &
    ({variables: LearningResourceQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<LearningResourceQuery, LearningResourceQueryVariables>(
    LearningResourceQueryDocument,
    options,
  );
}
export function useLearningResourceQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LearningResourceQuery, LearningResourceQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<LearningResourceQuery, LearningResourceQueryVariables>(
    LearningResourceQueryDocument,
    options,
  );
}
export function useLearningResourceQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LearningResourceQuery, LearningResourceQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<LearningResourceQuery, LearningResourceQueryVariables>(
    LearningResourceQueryDocument,
    options,
  );
}
export type LearningResourceQueryHookResult = ReturnType<typeof useLearningResourceQuery>;
export type LearningResourceQueryLazyQueryHookResult = ReturnType<
  typeof useLearningResourceQueryLazyQuery
>;
export type LearningResourceQuerySuspenseQueryHookResult = ReturnType<
  typeof useLearningResourceQuerySuspenseQuery
>;
export type LearningResourceQueryQueryResult = Apollo.QueryResult<
  LearningResourceQuery,
  LearningResourceQueryVariables
>;
export const LifestylePreviewDocument = gql`
  query LifestylePreview {
    me {
      id
      subscription {
        hasActiveSubscription
      }
      mostRecentLabSubmission {
        id
        registeredDate
        userSurveySubmission {
          id
          surveyAssessment {
            categories {
              ...LifestylePreviewCategoryFragment
            }
            id
            lifestyleScore
            maxLifestyleScore
            surveyId
            surveyKey
          }
        }
      }
    }
  }
  ${LifestylePreviewCategoryFragment}
`;

/**
 * __useLifestylePreview__
 *
 * To run a query within a React component, call `useLifestylePreview` and pass it any options that fit your needs.
 * When your component renders, `useLifestylePreview` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifestylePreview({
 *   variables: {
 *   },
 * });
 */
export function useLifestylePreview(
  baseOptions?: Apollo.QueryHookOptions<LifestylePreview, LifestylePreviewVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<LifestylePreview, LifestylePreviewVariables>(
    LifestylePreviewDocument,
    options,
  );
}
export function useLifestylePreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LifestylePreview, LifestylePreviewVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<LifestylePreview, LifestylePreviewVariables>(
    LifestylePreviewDocument,
    options,
  );
}
export function useLifestylePreviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LifestylePreview, LifestylePreviewVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<LifestylePreview, LifestylePreviewVariables>(
    LifestylePreviewDocument,
    options,
  );
}
export type LifestylePreviewHookResult = ReturnType<typeof useLifestylePreview>;
export type LifestylePreviewLazyQueryHookResult = ReturnType<typeof useLifestylePreviewLazyQuery>;
export type LifestylePreviewSuspenseQueryHookResult = ReturnType<
  typeof useLifestylePreviewSuspenseQuery
>;
export type LifestylePreviewQueryResult = Apollo.QueryResult<
  LifestylePreview,
  LifestylePreviewVariables
>;
export const LifestyleSummaryDocument = gql`
  query LifestyleSummary($input: FindLearningResourcesInput!) {
    learningResources(input: $input) {
      ...LearningResourceCardFragment
    }
    me {
      id
      mostRecentLabSubmission {
        ...LifestyleSummaryMostRecentLabSubmissionFragment
      }
      mostRecentLabSubmissionWithResults {
        ...LifestyleSummaryMostRecentLabSubmissionWithResultsFragment
      }
      subscription {
        id
        hasActiveSubscription
        hasMembership
      }
    }
  }
  ${LearningResourceCardFragment}
  ${LifestyleSummaryMostRecentLabSubmissionFragment}
  ${LifestyleSummaryMostRecentLabSubmissionWithResultsFragment}
`;

/**
 * __useLifestyleSummary__
 *
 * To run a query within a React component, call `useLifestyleSummary` and pass it any options that fit your needs.
 * When your component renders, `useLifestyleSummary` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifestyleSummary({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLifestyleSummary(
  baseOptions: Apollo.QueryHookOptions<LifestyleSummary, LifestyleSummaryVariables> &
    ({variables: LifestyleSummaryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<LifestyleSummary, LifestyleSummaryVariables>(
    LifestyleSummaryDocument,
    options,
  );
}
export function useLifestyleSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LifestyleSummary, LifestyleSummaryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<LifestyleSummary, LifestyleSummaryVariables>(
    LifestyleSummaryDocument,
    options,
  );
}
export function useLifestyleSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LifestyleSummary, LifestyleSummaryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<LifestyleSummary, LifestyleSummaryVariables>(
    LifestyleSummaryDocument,
    options,
  );
}
export type LifestyleSummaryHookResult = ReturnType<typeof useLifestyleSummary>;
export type LifestyleSummaryLazyQueryHookResult = ReturnType<typeof useLifestyleSummaryLazyQuery>;
export type LifestyleSummarySuspenseQueryHookResult = ReturnType<
  typeof useLifestyleSummarySuspenseQuery
>;
export type LifestyleSummaryQueryResult = Apollo.QueryResult<
  LifestyleSummary,
  LifestyleSummaryVariables
>;
export const LifestyleSummaryEmptyDocument = gql`
  query LifestyleSummaryEmpty($input: GetSurveyInput!) {
    survey(input: $input) {
      categories {
        id
        title
      }
      id
    }
  }
`;

/**
 * __useLifestyleSummaryEmpty__
 *
 * To run a query within a React component, call `useLifestyleSummaryEmpty` and pass it any options that fit your needs.
 * When your component renders, `useLifestyleSummaryEmpty` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifestyleSummaryEmpty({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLifestyleSummaryEmpty(
  baseOptions: Apollo.QueryHookOptions<LifestyleSummaryEmpty, LifestyleSummaryEmptyVariables> &
    ({variables: LifestyleSummaryEmptyVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<LifestyleSummaryEmpty, LifestyleSummaryEmptyVariables>(
    LifestyleSummaryEmptyDocument,
    options,
  );
}
export function useLifestyleSummaryEmptyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LifestyleSummaryEmpty, LifestyleSummaryEmptyVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<LifestyleSummaryEmpty, LifestyleSummaryEmptyVariables>(
    LifestyleSummaryEmptyDocument,
    options,
  );
}
export function useLifestyleSummaryEmptySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LifestyleSummaryEmpty, LifestyleSummaryEmptyVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<LifestyleSummaryEmpty, LifestyleSummaryEmptyVariables>(
    LifestyleSummaryEmptyDocument,
    options,
  );
}
export type LifestyleSummaryEmptyHookResult = ReturnType<typeof useLifestyleSummaryEmpty>;
export type LifestyleSummaryEmptyLazyQueryHookResult = ReturnType<
  typeof useLifestyleSummaryEmptyLazyQuery
>;
export type LifestyleSummaryEmptySuspenseQueryHookResult = ReturnType<
  typeof useLifestyleSummaryEmptySuspenseQuery
>;
export type LifestyleSummaryEmptyQueryResult = Apollo.QueryResult<
  LifestyleSummaryEmpty,
  LifestyleSummaryEmptyVariables
>;
export const MyTallyAgeQueryDocument = gql`
  query MyTallyAgeQuery($input: UserTrendsInputModel!) {
    me {
      id
      hasViewedResultsHistory
      labSubmissions {
        id
        ...TestResultLabSubmission
      }
      id
      mostRecentLabSubmission {
        id
        userSurveySubmission {
          surveyAssessment {
            id
          }
        }
      }
      mostRecentLabSubmissionWithResults {
        id
        registeredDate
        labAssessment {
          ...MyTallyAgeLabAssessmentFragment
        }
        labRecord {
          hasViewedResultStory
          id
        }
      }
      subscription {
        hasMembership
      }
    }
    userTrends(input: $input) {
      deltaAge
      formattedDeltaAge {
        months
        years
      }
      labSubmissionId
      lifestyleScorePercentage
      registeredDate
      categories {
        categoryId
        categoryScorePercentage
        title
      }
    }
  }
  ${TestResultLabSubmission}
  ${MyTallyAgeLabAssessmentFragment}
`;

/**
 * __useMyTallyAgeQuery__
 *
 * To run a query within a React component, call `useMyTallyAgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTallyAgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTallyAgeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMyTallyAgeQuery(
  baseOptions: Apollo.QueryHookOptions<MyTallyAgeQuery, MyTallyAgeQueryVariables> &
    ({variables: MyTallyAgeQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<MyTallyAgeQuery, MyTallyAgeQueryVariables>(
    MyTallyAgeQueryDocument,
    options,
  );
}
export function useMyTallyAgeQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyTallyAgeQuery, MyTallyAgeQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<MyTallyAgeQuery, MyTallyAgeQueryVariables>(
    MyTallyAgeQueryDocument,
    options,
  );
}
export function useMyTallyAgeQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyTallyAgeQuery, MyTallyAgeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<MyTallyAgeQuery, MyTallyAgeQueryVariables>(
    MyTallyAgeQueryDocument,
    options,
  );
}
export type MyTallyAgeQueryHookResult = ReturnType<typeof useMyTallyAgeQuery>;
export type MyTallyAgeQueryLazyQueryHookResult = ReturnType<typeof useMyTallyAgeQueryLazyQuery>;
export type MyTallyAgeQuerySuspenseQueryHookResult = ReturnType<
  typeof useMyTallyAgeQuerySuspenseQuery
>;
export type MyTallyAgeQueryQueryResult = Apollo.QueryResult<
  MyTallyAgeQuery,
  MyTallyAgeQueryVariables
>;
export const NotificationsQueryDocument = gql`
  query NotificationsQuery {
    me {
      ...NotificationQueryFragment
    }
  }
  ${NotificationQueryFragment}
`;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsQuery(
  baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(
    NotificationsQueryDocument,
    options,
  );
}
export function useNotificationsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(
    NotificationsQueryDocument,
    options,
  );
}
export function useNotificationsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<NotificationsQuery, NotificationsQueryVariables>(
    NotificationsQueryDocument,
    options,
  );
}
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsQueryLazyQueryHookResult = ReturnType<
  typeof useNotificationsQueryLazyQuery
>;
export type NotificationsQuerySuspenseQueryHookResult = ReturnType<
  typeof useNotificationsQuerySuspenseQuery
>;
export type NotificationsQueryQueryResult = Apollo.QueryResult<
  NotificationsQuery,
  NotificationsQueryVariables
>;
export const UpdateNotificationsDocument = gql`
  mutation UpdateNotifications($input: UpdateUserInput!) {
    updateUser(input: $input) {
      ...NotificationQueryFragment
    }
  }
  ${NotificationQueryFragment}
`;
export type UpdateNotificationsMutationFn = Apollo.MutationFunction<
  UpdateNotifications,
  UpdateNotificationsVariables
>;

/**
 * __useUpdateNotifications__
 *
 * To run a mutation, you first call `useUpdateNotifications` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotifications` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotifications, { data, loading, error }] = useUpdateNotifications({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotifications(
  baseOptions?: Apollo.MutationHookOptions<UpdateNotifications, UpdateNotificationsVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateNotifications, UpdateNotificationsVariables>(
    UpdateNotificationsDocument,
    options,
  );
}
export type UpdateNotificationsHookResult = ReturnType<typeof useUpdateNotifications>;
export type UpdateNotificationsMutationResult = Apollo.MutationResult<UpdateNotifications>;
export type UpdateNotificationsMutationOptions = Apollo.BaseMutationOptions<
  UpdateNotifications,
  UpdateNotificationsVariables
>;
export const CreateAndApplyDiscountDocument = gql`
  mutation CreateAndApplyDiscount($createAndApplyDiscountInput: CreateAndApplyDiscountInput!) {
    createAndApplyDiscount(input: $createAndApplyDiscountInput) {
      id
    }
  }
`;
export type CreateAndApplyDiscountMutationFn = Apollo.MutationFunction<
  CreateAndApplyDiscount,
  CreateAndApplyDiscountVariables
>;

/**
 * __useCreateAndApplyDiscount__
 *
 * To run a mutation, you first call `useCreateAndApplyDiscount` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndApplyDiscount` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndApplyDiscount, { data, loading, error }] = useCreateAndApplyDiscount({
 *   variables: {
 *      createAndApplyDiscountInput: // value for 'createAndApplyDiscountInput'
 *   },
 * });
 */
export function useCreateAndApplyDiscount(
  baseOptions?: Apollo.MutationHookOptions<CreateAndApplyDiscount, CreateAndApplyDiscountVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<CreateAndApplyDiscount, CreateAndApplyDiscountVariables>(
    CreateAndApplyDiscountDocument,
    options,
  );
}
export type CreateAndApplyDiscountHookResult = ReturnType<typeof useCreateAndApplyDiscount>;
export type CreateAndApplyDiscountMutationResult = Apollo.MutationResult<CreateAndApplyDiscount>;
export type CreateAndApplyDiscountMutationOptions = Apollo.BaseMutationOptions<
  CreateAndApplyDiscount,
  CreateAndApplyDiscountVariables
>;
export const UpdateSubscriptionStatusDocument = gql`
  mutation UpdateSubscriptionStatus($subscriptionChanges: UpdateSubscriptionInput!) {
    updateSubscription(subscriptionChanges: $subscriptionChanges) {
      id
    }
  }
`;
export type UpdateSubscriptionStatusMutationFn = Apollo.MutationFunction<
  UpdateSubscriptionStatus,
  UpdateSubscriptionStatusVariables
>;

/**
 * __useUpdateSubscriptionStatus__
 *
 * To run a mutation, you first call `useUpdateSubscriptionStatus` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionStatus` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionStatus, { data, loading, error }] = useUpdateSubscriptionStatus({
 *   variables: {
 *      subscriptionChanges: // value for 'subscriptionChanges'
 *   },
 * });
 */
export function useUpdateSubscriptionStatus(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSubscriptionStatus,
    UpdateSubscriptionStatusVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateSubscriptionStatus, UpdateSubscriptionStatusVariables>(
    UpdateSubscriptionStatusDocument,
    options,
  );
}
export type UpdateSubscriptionStatusHookResult = ReturnType<typeof useUpdateSubscriptionStatus>;
export type UpdateSubscriptionStatusMutationResult =
  Apollo.MutationResult<UpdateSubscriptionStatus>;
export type UpdateSubscriptionStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateSubscriptionStatus,
  UpdateSubscriptionStatusVariables
>;
export const GetSimulatedDiscountsDocument = gql`
  query GetSimulatedDiscounts($input: SimulatedDiscountsInput!) {
    getSimulatedDiscounts(input: $input) {
      discounts {
        type
        variantId
        value
        category
        title
      }
      discountErrors {
        discount
        code
        message
      }
    }
  }
`;

/**
 * __useGetSimulatedDiscounts__
 *
 * To run a query within a React component, call `useGetSimulatedDiscounts` and pass it any options that fit your needs.
 * When your component renders, `useGetSimulatedDiscounts` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimulatedDiscounts({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSimulatedDiscounts(
  baseOptions: Apollo.QueryHookOptions<GetSimulatedDiscounts, GetSimulatedDiscountsVariables> &
    ({variables: GetSimulatedDiscountsVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<GetSimulatedDiscounts, GetSimulatedDiscountsVariables>(
    GetSimulatedDiscountsDocument,
    options,
  );
}
export function useGetSimulatedDiscountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSimulatedDiscounts, GetSimulatedDiscountsVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<GetSimulatedDiscounts, GetSimulatedDiscountsVariables>(
    GetSimulatedDiscountsDocument,
    options,
  );
}
export function useGetSimulatedDiscountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSimulatedDiscounts, GetSimulatedDiscountsVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<GetSimulatedDiscounts, GetSimulatedDiscountsVariables>(
    GetSimulatedDiscountsDocument,
    options,
  );
}
export type GetSimulatedDiscountsHookResult = ReturnType<typeof useGetSimulatedDiscounts>;
export type GetSimulatedDiscountsLazyQueryHookResult = ReturnType<
  typeof useGetSimulatedDiscountsLazyQuery
>;
export type GetSimulatedDiscountsSuspenseQueryHookResult = ReturnType<
  typeof useGetSimulatedDiscountsSuspenseQuery
>;
export type GetSimulatedDiscountsQueryResult = Apollo.QueryResult<
  GetSimulatedDiscounts,
  GetSimulatedDiscountsVariables
>;
export const UpdateSubscriptionDocument = gql`
  mutation UpdateSubscription($subscriptionChanges: UpdateSubscriptionInput!) {
    updateSubscription(subscriptionChanges: $subscriptionChanges) {
      id
    }
  }
`;
export type UpdateSubscriptionMutationFn = Apollo.MutationFunction<
  UpdateSubscription,
  UpdateSubscriptionVariables
>;

/**
 * __useUpdateSubscription__
 *
 * To run a mutation, you first call `useUpdateSubscription` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscription` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscription, { data, loading, error }] = useUpdateSubscription({
 *   variables: {
 *      subscriptionChanges: // value for 'subscriptionChanges'
 *   },
 * });
 */
export function useUpdateSubscription(
  baseOptions?: Apollo.MutationHookOptions<UpdateSubscription, UpdateSubscriptionVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateSubscription, UpdateSubscriptionVariables>(
    UpdateSubscriptionDocument,
    options,
  );
}
export type UpdateSubscriptionHookResult = ReturnType<typeof useUpdateSubscription>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscription>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  UpdateSubscription,
  UpdateSubscriptionVariables
>;
export const ManagePlanQueryDocument = gql`
  query ManagePlanQuery {
    me {
      id
      appliedDiscountCancelationOn
      customerAccount {
        id
        subscription {
          id
          email
          hasActiveSubscription
          hasMembership
          status
          discounts {
            title
            amount
            category
            productVariantId
            type
          }
          items {
            id
            productId
            variantId
            variantSku
            title
            quantity
            price
          }
          pausedProductVariantIds
          nextBillingAttemptAt
        }
      }
    }
  }
`;

/**
 * __useManagePlanQuery__
 *
 * To run a query within a React component, call `useManagePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagePlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagePlanQuery(
  baseOptions?: Apollo.QueryHookOptions<ManagePlanQuery, ManagePlanQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ManagePlanQuery, ManagePlanQueryVariables>(
    ManagePlanQueryDocument,
    options,
  );
}
export function useManagePlanQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ManagePlanQuery, ManagePlanQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ManagePlanQuery, ManagePlanQueryVariables>(
    ManagePlanQueryDocument,
    options,
  );
}
export function useManagePlanQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ManagePlanQuery, ManagePlanQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ManagePlanQuery, ManagePlanQueryVariables>(
    ManagePlanQueryDocument,
    options,
  );
}
export type ManagePlanQueryHookResult = ReturnType<typeof useManagePlanQuery>;
export type ManagePlanQueryLazyQueryHookResult = ReturnType<typeof useManagePlanQueryLazyQuery>;
export type ManagePlanQuerySuspenseQueryHookResult = ReturnType<
  typeof useManagePlanQuerySuspenseQuery
>;
export type ManagePlanQueryQueryResult = Apollo.QueryResult<
  ManagePlanQuery,
  ManagePlanQueryVariables
>;
export const ProductDetailsQueryDocument = gql`
  query ProductDetailsQuery {
    store {
      productVariants {
        id
        tid
        sku
        title
        type
        price
        packageType
        productId
        product {
          id
          tid
          title
          category
          thumbnail
          displayOrder
          variantIds
        }
      }
    }
  }
`;

/**
 * __useProductDetailsQuery__
 *
 * To run a query within a React component, call `useProductDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<ProductDetailsQuery, ProductDetailsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ProductDetailsQuery, ProductDetailsQueryVariables>(
    ProductDetailsQueryDocument,
    options,
  );
}
export function useProductDetailsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProductDetailsQuery, ProductDetailsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ProductDetailsQuery, ProductDetailsQueryVariables>(
    ProductDetailsQueryDocument,
    options,
  );
}
export function useProductDetailsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProductDetailsQuery, ProductDetailsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ProductDetailsQuery, ProductDetailsQueryVariables>(
    ProductDetailsQueryDocument,
    options,
  );
}
export type ProductDetailsQueryHookResult = ReturnType<typeof useProductDetailsQuery>;
export type ProductDetailsQueryLazyQueryHookResult = ReturnType<
  typeof useProductDetailsQueryLazyQuery
>;
export type ProductDetailsQuerySuspenseQueryHookResult = ReturnType<
  typeof useProductDetailsQuerySuspenseQuery
>;
export type ProductDetailsQueryQueryResult = Apollo.QueryResult<
  ProductDetailsQuery,
  ProductDetailsQueryVariables
>;
export const GetDiscountDocument = gql`
  query GetDiscount($code: String!) {
    getDiscount(code: $code) {
      discountCode
    }
  }
`;

/**
 * __useGetDiscount__
 *
 * To run a query within a React component, call `useGetDiscount` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscount` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscount({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetDiscount(
  baseOptions: Apollo.QueryHookOptions<GetDiscount, GetDiscountVariables> &
    ({variables: GetDiscountVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<GetDiscount, GetDiscountVariables>(GetDiscountDocument, options);
}
export function useGetDiscountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDiscount, GetDiscountVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<GetDiscount, GetDiscountVariables>(GetDiscountDocument, options);
}
export function useGetDiscountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDiscount, GetDiscountVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<GetDiscount, GetDiscountVariables>(GetDiscountDocument, options);
}
export type GetDiscountHookResult = ReturnType<typeof useGetDiscount>;
export type GetDiscountLazyQueryHookResult = ReturnType<typeof useGetDiscountLazyQuery>;
export type GetDiscountSuspenseQueryHookResult = ReturnType<typeof useGetDiscountSuspenseQuery>;
export type GetDiscountQueryResult = Apollo.QueryResult<GetDiscount, GetDiscountVariables>;
export const PauseSubscriptionQueryDocument = gql`
  query PauseSubscriptionQuery {
    me {
      id
      customerAccount {
        id
        subscription {
          id
          items {
            id
            productId
            variantId
            variantSku
            title
            quantity
            price
          }
          pausedProductVariantIds
        }
      }
    }
  }
`;

/**
 * __usePauseSubscriptionQuery__
 *
 * To run a query within a React component, call `usePauseSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePauseSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePauseSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function usePauseSubscriptionQuery(
  baseOptions?: Apollo.QueryHookOptions<PauseSubscriptionQuery, PauseSubscriptionQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<PauseSubscriptionQuery, PauseSubscriptionQueryVariables>(
    PauseSubscriptionQueryDocument,
    options,
  );
}
export function usePauseSubscriptionQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PauseSubscriptionQuery,
    PauseSubscriptionQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<PauseSubscriptionQuery, PauseSubscriptionQueryVariables>(
    PauseSubscriptionQueryDocument,
    options,
  );
}
export function usePauseSubscriptionQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PauseSubscriptionQuery, PauseSubscriptionQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<PauseSubscriptionQuery, PauseSubscriptionQueryVariables>(
    PauseSubscriptionQueryDocument,
    options,
  );
}
export type PauseSubscriptionQueryHookResult = ReturnType<typeof usePauseSubscriptionQuery>;
export type PauseSubscriptionQueryLazyQueryHookResult = ReturnType<
  typeof usePauseSubscriptionQueryLazyQuery
>;
export type PauseSubscriptionQuerySuspenseQueryHookResult = ReturnType<
  typeof usePauseSubscriptionQuerySuspenseQuery
>;
export type PauseSubscriptionQueryQueryResult = Apollo.QueryResult<
  PauseSubscriptionQuery,
  PauseSubscriptionQueryVariables
>;
export const PauseSubscriptionItemsMutationDocument = gql`
  mutation PauseSubscriptionItemsMutation($input: PauseSubscriptionItemsInput!) {
    pauseSubscriptionItems(input: $input) {
      id
    }
  }
`;
export type PauseSubscriptionItemsMutationMutationFn = Apollo.MutationFunction<
  PauseSubscriptionItemsMutation,
  PauseSubscriptionItemsMutationVariables
>;

/**
 * __usePauseSubscriptionItemsMutation__
 *
 * To run a mutation, you first call `usePauseSubscriptionItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseSubscriptionItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseSubscriptionItemsMutation, { data, loading, error }] = usePauseSubscriptionItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePauseSubscriptionItemsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PauseSubscriptionItemsMutation,
    PauseSubscriptionItemsMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    PauseSubscriptionItemsMutation,
    PauseSubscriptionItemsMutationVariables
  >(PauseSubscriptionItemsMutationDocument, options);
}
export type PauseSubscriptionItemsMutationHookResult = ReturnType<
  typeof usePauseSubscriptionItemsMutation
>;
export type PauseSubscriptionItemsMutationMutationResult =
  Apollo.MutationResult<PauseSubscriptionItemsMutation>;
export type PauseSubscriptionItemsMutationMutationOptions = Apollo.BaseMutationOptions<
  PauseSubscriptionItemsMutation,
  PauseSubscriptionItemsMutationVariables
>;
export const ProfileInfoBoxQueryDocument = gql`
  query ProfileInfoBoxQuery {
    me {
      id
      userProfile {
        id
        firstName
        lastName
        email
      }
      customerAccount {
        id
        subscription {
          ...CustomerSubscriptionInfoBoxesFragment
        }
        shippingAddress {
          address
          city
          addressDetail
          postalCode
          provinceCode
          province
          countryCode
          country
          firstName
          lastName
        }
        paymentMethods {
          id
          expiryMonth
          expiryYear
          lastDigits
          brand
          type
        }
      }
    }
  }
  ${CustomerSubscriptionInfoBoxesFragment}
`;

/**
 * __useProfileInfoBoxQuery__
 *
 * To run a query within a React component, call `useProfileInfoBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileInfoBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileInfoBoxQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileInfoBoxQuery(
  baseOptions?: Apollo.QueryHookOptions<ProfileInfoBoxQuery, ProfileInfoBoxQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ProfileInfoBoxQuery, ProfileInfoBoxQueryVariables>(
    ProfileInfoBoxQueryDocument,
    options,
  );
}
export function useProfileInfoBoxQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProfileInfoBoxQuery, ProfileInfoBoxQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ProfileInfoBoxQuery, ProfileInfoBoxQueryVariables>(
    ProfileInfoBoxQueryDocument,
    options,
  );
}
export function useProfileInfoBoxQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProfileInfoBoxQuery, ProfileInfoBoxQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ProfileInfoBoxQuery, ProfileInfoBoxQueryVariables>(
    ProfileInfoBoxQueryDocument,
    options,
  );
}
export type ProfileInfoBoxQueryHookResult = ReturnType<typeof useProfileInfoBoxQuery>;
export type ProfileInfoBoxQueryLazyQueryHookResult = ReturnType<
  typeof useProfileInfoBoxQueryLazyQuery
>;
export type ProfileInfoBoxQuerySuspenseQueryHookResult = ReturnType<
  typeof useProfileInfoBoxQuerySuspenseQuery
>;
export type ProfileInfoBoxQueryQueryResult = Apollo.QueryResult<
  ProfileInfoBoxQuery,
  ProfileInfoBoxQueryVariables
>;
export const ProfileUpcomingOrderQueryDocument = gql`
  query ProfileUpcomingOrderQuery {
    me {
      id
      customerAccount {
        id
        subscription {
          id
          status
          discounts {
            title
            amount
            type
            category
            productVariantId
          }
        }
        upcomingOrder {
          id
          billingDate
          status
          subTotal
          shippingTotal
          total
          discountTotal
          discounts {
            title
            type
            value
            category
            productVariantId
          }
          orderItems {
            id
            productTitle
            unitPrice
            quantity
            status
            cost
          }
        }
      }
    }
  }
`;

/**
 * __useProfileUpcomingOrderQuery__
 *
 * To run a query within a React component, call `useProfileUpcomingOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileUpcomingOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileUpcomingOrderQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileUpcomingOrderQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProfileUpcomingOrderQuery,
    ProfileUpcomingOrderQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ProfileUpcomingOrderQuery, ProfileUpcomingOrderQueryVariables>(
    ProfileUpcomingOrderQueryDocument,
    options,
  );
}
export function useProfileUpcomingOrderQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProfileUpcomingOrderQuery,
    ProfileUpcomingOrderQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ProfileUpcomingOrderQuery, ProfileUpcomingOrderQueryVariables>(
    ProfileUpcomingOrderQueryDocument,
    options,
  );
}
export function useProfileUpcomingOrderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProfileUpcomingOrderQuery,
        ProfileUpcomingOrderQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ProfileUpcomingOrderQuery, ProfileUpcomingOrderQueryVariables>(
    ProfileUpcomingOrderQueryDocument,
    options,
  );
}
export type ProfileUpcomingOrderQueryHookResult = ReturnType<typeof useProfileUpcomingOrderQuery>;
export type ProfileUpcomingOrderQueryLazyQueryHookResult = ReturnType<
  typeof useProfileUpcomingOrderQueryLazyQuery
>;
export type ProfileUpcomingOrderQuerySuspenseQueryHookResult = ReturnType<
  typeof useProfileUpcomingOrderQuerySuspenseQuery
>;
export type ProfileUpcomingOrderQueryQueryResult = Apollo.QueryResult<
  ProfileUpcomingOrderQuery,
  ProfileUpcomingOrderQueryVariables
>;
export const ProfileCustomerSubscriptionQueryDocument = gql`
  query ProfileCustomerSubscriptionQuery {
    me {
      id
      customerAccount {
        id
        subscription {
          id
          status
          hasMembership
          items {
            id
            productId
            variantId
            variantSku
            title
            quantity
            price
          }
          pausedProductVariantIds
        }
        upcomingOrder {
          id
          billingDate
          status
          subTotal
          shippingTotal
          total
          discountTotal
          discounts {
            title
            type
            value
            category
            productVariantId
          }
          orderItems {
            id
            productTitle
            unitPrice
            quantity
            status
            cost
          }
        }
        orders {
          id
          billingDate
          status
          subTotal
          shippingTotal
          total
          discounts {
            title
            type
            value
            category
            productVariantId
          }
          orderItems {
            id
            productTitle
            unitPrice
            quantity
            status
            cost
            isMembership
          }
        }
      }
    }
  }
`;

/**
 * __useProfileCustomerSubscriptionQuery__
 *
 * To run a query within a React component, call `useProfileCustomerSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileCustomerSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileCustomerSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileCustomerSubscriptionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProfileCustomerSubscriptionQuery,
    ProfileCustomerSubscriptionQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<
    ProfileCustomerSubscriptionQuery,
    ProfileCustomerSubscriptionQueryVariables
  >(ProfileCustomerSubscriptionQueryDocument, options);
}
export function useProfileCustomerSubscriptionQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProfileCustomerSubscriptionQuery,
    ProfileCustomerSubscriptionQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    ProfileCustomerSubscriptionQuery,
    ProfileCustomerSubscriptionQueryVariables
  >(ProfileCustomerSubscriptionQueryDocument, options);
}
export function useProfileCustomerSubscriptionQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProfileCustomerSubscriptionQuery,
        ProfileCustomerSubscriptionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    ProfileCustomerSubscriptionQuery,
    ProfileCustomerSubscriptionQueryVariables
  >(ProfileCustomerSubscriptionQueryDocument, options);
}
export type ProfileCustomerSubscriptionQueryHookResult = ReturnType<
  typeof useProfileCustomerSubscriptionQuery
>;
export type ProfileCustomerSubscriptionQueryLazyQueryHookResult = ReturnType<
  typeof useProfileCustomerSubscriptionQueryLazyQuery
>;
export type ProfileCustomerSubscriptionQuerySuspenseQueryHookResult = ReturnType<
  typeof useProfileCustomerSubscriptionQuerySuspenseQuery
>;
export type ProfileCustomerSubscriptionQueryQueryResult = Apollo.QueryResult<
  ProfileCustomerSubscriptionQuery,
  ProfileCustomerSubscriptionQueryVariables
>;
export const ProfileRecentOrdersQueryDocument = gql`
  query ProfileRecentOrdersQuery {
    me {
      id
      customerAccount {
        id
        orders {
          id
          name
          billingDate
          status
          subTotal
          discountTotal
          taxTotal
          shippingTotal
          total
          discounts {
            title
            type
            value
            category
            productVariantId
          }
          orderItems {
            id
            productTitle
            unitPrice
            quantity
            status
            cost
            isMembership
          }
        }
      }
    }
  }
`;

/**
 * __useProfileRecentOrdersQuery__
 *
 * To run a query within a React component, call `useProfileRecentOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileRecentOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileRecentOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileRecentOrdersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProfileRecentOrdersQuery,
    ProfileRecentOrdersQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ProfileRecentOrdersQuery, ProfileRecentOrdersQueryVariables>(
    ProfileRecentOrdersQueryDocument,
    options,
  );
}
export function useProfileRecentOrdersQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProfileRecentOrdersQuery,
    ProfileRecentOrdersQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ProfileRecentOrdersQuery, ProfileRecentOrdersQueryVariables>(
    ProfileRecentOrdersQueryDocument,
    options,
  );
}
export function useProfileRecentOrdersQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProfileRecentOrdersQuery, ProfileRecentOrdersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ProfileRecentOrdersQuery, ProfileRecentOrdersQueryVariables>(
    ProfileRecentOrdersQueryDocument,
    options,
  );
}
export type ProfileRecentOrdersQueryHookResult = ReturnType<typeof useProfileRecentOrdersQuery>;
export type ProfileRecentOrdersQueryLazyQueryHookResult = ReturnType<
  typeof useProfileRecentOrdersQueryLazyQuery
>;
export type ProfileRecentOrdersQuerySuspenseQueryHookResult = ReturnType<
  typeof useProfileRecentOrdersQuerySuspenseQuery
>;
export type ProfileRecentOrdersQueryQueryResult = Apollo.QueryResult<
  ProfileRecentOrdersQuery,
  ProfileRecentOrdersQueryVariables
>;
export const StoreQueryDocument = gql`
  query StoreQuery {
    store {
      products {
        id
        tid
        title
        category
        thumbnail
        displayOrder
        variantIds
      }
      productVariants {
        id
        tid
        sku
        title
        type
        price
        packageType
        productId
        product {
          id
          tid
          title
          category
          thumbnail
          displayOrder
          displayTheme
          variantIds
        }
      }
    }
  }
`;

/**
 * __useStoreQuery__
 *
 * To run a query within a React component, call `useStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoreQuery(
  baseOptions?: Apollo.QueryHookOptions<StoreQuery, StoreQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<StoreQuery, StoreQueryVariables>(StoreQueryDocument, options);
}
export function useStoreQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<StoreQuery, StoreQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<StoreQuery, StoreQueryVariables>(StoreQueryDocument, options);
}
export function useStoreQuerySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StoreQuery, StoreQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<StoreQuery, StoreQueryVariables>(StoreQueryDocument, options);
}
export type StoreQueryHookResult = ReturnType<typeof useStoreQuery>;
export type StoreQueryLazyQueryHookResult = ReturnType<typeof useStoreQueryLazyQuery>;
export type StoreQuerySuspenseQueryHookResult = ReturnType<typeof useStoreQuerySuspenseQuery>;
export type StoreQueryQueryResult = Apollo.QueryResult<StoreQuery, StoreQueryVariables>;
export const UpdateCustomerAddressMutationDocument = gql`
  mutation UpdateCustomerAddressMutation($input: UpdateShippingAddressInput!) {
    updateCustomerAccountShippingAddress(input: $input) {
      address
      addressDetail
      city
      countryCode
      provinceCode
      postalCode
      firstName
      lastName
    }
  }
`;
export type UpdateCustomerAddressMutationMutationFn = Apollo.MutationFunction<
  UpdateCustomerAddressMutation,
  UpdateCustomerAddressMutationVariables
>;

/**
 * __useUpdateCustomerAddressMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerAddressMutation, { data, loading, error }] = useUpdateCustomerAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomerAddressMutation,
    UpdateCustomerAddressMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>(
    UpdateCustomerAddressMutationDocument,
    options,
  );
}
export type UpdateCustomerAddressMutationHookResult = ReturnType<
  typeof useUpdateCustomerAddressMutation
>;
export type UpdateCustomerAddressMutationMutationResult =
  Apollo.MutationResult<UpdateCustomerAddressMutation>;
export type UpdateCustomerAddressMutationMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomerAddressMutation,
  UpdateCustomerAddressMutationVariables
>;
export const SendPaymentMethodUpdateLinkMutationDocument = gql`
  mutation SendPaymentMethodUpdateLinkMutation {
    sendPaymentMethodUpdateLink {
      success
      code
      message
    }
  }
`;
export type SendPaymentMethodUpdateLinkMutationMutationFn = Apollo.MutationFunction<
  SendPaymentMethodUpdateLinkMutation,
  SendPaymentMethodUpdateLinkMutationVariables
>;

/**
 * __useSendPaymentMethodUpdateLinkMutation__
 *
 * To run a mutation, you first call `useSendPaymentMethodUpdateLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPaymentMethodUpdateLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPaymentMethodUpdateLinkMutation, { data, loading, error }] = useSendPaymentMethodUpdateLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendPaymentMethodUpdateLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendPaymentMethodUpdateLinkMutation,
    SendPaymentMethodUpdateLinkMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    SendPaymentMethodUpdateLinkMutation,
    SendPaymentMethodUpdateLinkMutationVariables
  >(SendPaymentMethodUpdateLinkMutationDocument, options);
}
export type SendPaymentMethodUpdateLinkMutationHookResult = ReturnType<
  typeof useSendPaymentMethodUpdateLinkMutation
>;
export type SendPaymentMethodUpdateLinkMutationMutationResult =
  Apollo.MutationResult<SendPaymentMethodUpdateLinkMutation>;
export type SendPaymentMethodUpdateLinkMutationMutationOptions = Apollo.BaseMutationOptions<
  SendPaymentMethodUpdateLinkMutation,
  SendPaymentMethodUpdateLinkMutationVariables
>;
export const UpdateSubscriptionMutationDocument = gql`
  mutation UpdateSubscriptionMutation($subscriptionChanges: UpdateSubscriptionInput!) {
    updateSubscription(subscriptionChanges: $subscriptionChanges) {
      id
    }
  }
`;
export type UpdateSubscriptionMutationMutationFn = Apollo.MutationFunction<
  UpdateSubscriptionMutation,
  UpdateSubscriptionMutationVariables
>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      subscriptionChanges: // value for 'subscriptionChanges'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSubscriptionMutation,
    UpdateSubscriptionMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(
    UpdateSubscriptionMutationDocument,
    options,
  );
}
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationMutationResult =
  Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationMutationOptions = Apollo.BaseMutationOptions<
  UpdateSubscriptionMutation,
  UpdateSubscriptionMutationVariables
>;
export const ProfileQueryHeaderDocument = gql`
  query profileQueryHeader($imageVariant: FileImageVariant!) {
    me {
      id
      avatar {
        id
        url(variant: $imageVariant, raw: false)
      }
      userProfile {
        id
        initials @client
        firstName
        lastName
        email
      }
      subscription {
        id
      }
      mostRecentLabSubmission {
        id
      }
    }
  }
`;

/**
 * __useProfileQueryHeader__
 *
 * To run a query within a React component, call `useProfileQueryHeader` and pass it any options that fit your needs.
 * When your component renders, `useProfileQueryHeader` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQueryHeader({
 *   variables: {
 *      imageVariant: // value for 'imageVariant'
 *   },
 * });
 */
export function useProfileQueryHeader(
  baseOptions: Apollo.QueryHookOptions<ProfileQueryHeader, ProfileQueryHeaderVariables> &
    ({variables: ProfileQueryHeaderVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ProfileQueryHeader, ProfileQueryHeaderVariables>(
    ProfileQueryHeaderDocument,
    options,
  );
}
export function useProfileQueryHeaderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProfileQueryHeader, ProfileQueryHeaderVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ProfileQueryHeader, ProfileQueryHeaderVariables>(
    ProfileQueryHeaderDocument,
    options,
  );
}
export function useProfileQueryHeaderSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProfileQueryHeader, ProfileQueryHeaderVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ProfileQueryHeader, ProfileQueryHeaderVariables>(
    ProfileQueryHeaderDocument,
    options,
  );
}
export type ProfileQueryHeaderHookResult = ReturnType<typeof useProfileQueryHeader>;
export type ProfileQueryHeaderLazyQueryHookResult = ReturnType<
  typeof useProfileQueryHeaderLazyQuery
>;
export type ProfileQueryHeaderSuspenseQueryHookResult = ReturnType<
  typeof useProfileQueryHeaderSuspenseQuery
>;
export type ProfileQueryHeaderQueryResult = Apollo.QueryResult<
  ProfileQueryHeader,
  ProfileQueryHeaderVariables
>;
export const ProfilePageQueryDocument = gql`
  query ProfilePageQuery {
    me {
      id
      customerAccount {
        id
        subscription {
          id
          paymentMethodId
        }
        paymentMethods {
          id
          brand
          type
          lastDigits
          expiryMonth
        }
      }
    }
  }
`;

/**
 * __useProfilePageQuery__
 *
 * To run a query within a React component, call `useProfilePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfilePageQuery(
  baseOptions?: Apollo.QueryHookOptions<ProfilePageQuery, ProfilePageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ProfilePageQuery, ProfilePageQueryVariables>(
    ProfilePageQueryDocument,
    options,
  );
}
export function useProfilePageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProfilePageQuery, ProfilePageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ProfilePageQuery, ProfilePageQueryVariables>(
    ProfilePageQueryDocument,
    options,
  );
}
export function useProfilePageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProfilePageQuery, ProfilePageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ProfilePageQuery, ProfilePageQueryVariables>(
    ProfilePageQueryDocument,
    options,
  );
}
export type ProfilePageQueryHookResult = ReturnType<typeof useProfilePageQuery>;
export type ProfilePageQueryLazyQueryHookResult = ReturnType<typeof useProfilePageQueryLazyQuery>;
export type ProfilePageQuerySuspenseQueryHookResult = ReturnType<
  typeof useProfilePageQuerySuspenseQuery
>;
export type ProfilePageQueryQueryResult = Apollo.QueryResult<
  ProfilePageQuery,
  ProfilePageQueryVariables
>;
export const RegisterQueryDocument = gql`
  query RegisterQuery {
    me {
      id
      receiveSMSNotification
      userProfile {
        id
        firstName
        lastName
        birthday
        email
      }
      labSubmissions {
        id
      }
    }
  }
`;

/**
 * __useRegisterQuery__
 *
 * To run a query within a React component, call `useRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegisterQuery(
  baseOptions?: Apollo.QueryHookOptions<RegisterQuery, RegisterQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<RegisterQuery, RegisterQueryVariables>(RegisterQueryDocument, options);
}
export function useRegisterQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RegisterQuery, RegisterQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<RegisterQuery, RegisterQueryVariables>(RegisterQueryDocument, options);
}
export function useRegisterQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RegisterQuery, RegisterQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<RegisterQuery, RegisterQueryVariables>(
    RegisterQueryDocument,
    options,
  );
}
export type RegisterQueryHookResult = ReturnType<typeof useRegisterQuery>;
export type RegisterQueryLazyQueryHookResult = ReturnType<typeof useRegisterQueryLazyQuery>;
export type RegisterQuerySuspenseQueryHookResult = ReturnType<typeof useRegisterQuerySuspenseQuery>;
export type RegisterQueryQueryResult = Apollo.QueryResult<RegisterQuery, RegisterQueryVariables>;
export const RequestCreateAccountLinkDocument = gql`
  mutation RequestCreateAccountLink($input: RequestCreateAccountLinkInput!) {
    requestCreateAccountLink(input: $input) {
      success
      code
    }
  }
`;
export type RequestCreateAccountLinkMutationFn = Apollo.MutationFunction<
  RequestCreateAccountLink,
  RequestCreateAccountLinkVariables
>;

/**
 * __useRequestCreateAccountLink__
 *
 * To run a mutation, you first call `useRequestCreateAccountLink` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCreateAccountLink` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCreateAccountLink, { data, loading, error }] = useRequestCreateAccountLink({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCreateAccountLink(
  baseOptions?: Apollo.MutationHookOptions<
    RequestCreateAccountLink,
    RequestCreateAccountLinkVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<RequestCreateAccountLink, RequestCreateAccountLinkVariables>(
    RequestCreateAccountLinkDocument,
    options,
  );
}
export type RequestCreateAccountLinkHookResult = ReturnType<typeof useRequestCreateAccountLink>;
export type RequestCreateAccountLinkMutationResult =
  Apollo.MutationResult<RequestCreateAccountLink>;
export type RequestCreateAccountLinkMutationOptions = Apollo.BaseMutationOptions<
  RequestCreateAccountLink,
  RequestCreateAccountLinkVariables
>;
export const ResetPasswordDocument = gql`
  mutation ResetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      message
      success
    }
  }
`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<
  ResetPassword,
  ResetPasswordVariables
>;

/**
 * __useResetPassword__
 *
 * To run a mutation, you first call `useResetPassword` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPassword` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPassword, { data, loading, error }] = useResetPassword({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPassword(
  baseOptions?: Apollo.MutationHookOptions<ResetPassword, ResetPasswordVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<ResetPassword, ResetPasswordVariables>(ResetPasswordDocument, options);
}
export type ResetPasswordHookResult = ReturnType<typeof useResetPassword>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPassword>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetPassword,
  ResetPasswordVariables
>;
export const ResultStoryQueryDocument = gql`
  query ResultStoryQuery($metricTypes: [LabResultMetricTypeEnum!]) {
    me {
      id
      subscription {
        hasActiveSubscription
      }
      mostRecentLabSubmissionWithResults {
        id
        labAssessment {
          deltaAge
          formattedBioAge {
            months
            years
          }
          formattedChronologicalAge {
            months
            years
          }
          formattedDeltaAge {
            months
            years
          }
          id
          labResultMetrics(metricTypes: $metricTypes) {
            id
            percentile
            type
          }
          reportUrl
        }
        labRecord {
          hasViewedResultStory
          id
        }
        surveySubmissionId
      }
      userProfile {
        firstName
        id
      }
    }
  }
`;

/**
 * __useResultStoryQuery__
 *
 * To run a query within a React component, call `useResultStoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useResultStoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResultStoryQuery({
 *   variables: {
 *      metricTypes: // value for 'metricTypes'
 *   },
 * });
 */
export function useResultStoryQuery(
  baseOptions?: Apollo.QueryHookOptions<ResultStoryQuery, ResultStoryQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ResultStoryQuery, ResultStoryQueryVariables>(
    ResultStoryQueryDocument,
    options,
  );
}
export function useResultStoryQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ResultStoryQuery, ResultStoryQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ResultStoryQuery, ResultStoryQueryVariables>(
    ResultStoryQueryDocument,
    options,
  );
}
export function useResultStoryQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResultStoryQuery, ResultStoryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ResultStoryQuery, ResultStoryQueryVariables>(
    ResultStoryQueryDocument,
    options,
  );
}
export type ResultStoryQueryHookResult = ReturnType<typeof useResultStoryQuery>;
export type ResultStoryQueryLazyQueryHookResult = ReturnType<typeof useResultStoryQueryLazyQuery>;
export type ResultStoryQuerySuspenseQueryHookResult = ReturnType<
  typeof useResultStoryQuerySuspenseQuery
>;
export type ResultStoryQueryQueryResult = Apollo.QueryResult<
  ResultStoryQuery,
  ResultStoryQueryVariables
>;
export const ResultStoryViewedDocument = gql`
  mutation resultStoryViewed($input: UpdateUserViewedLabResultStoryInput!) {
    updateUserViewedLabResultStory(input: $input) {
      id
      mostRecentLabSubmissionWithResults {
        id
        labRecord {
          hasViewedResultStory
          id
        }
      }
    }
  }
`;
export type ResultStoryViewedMutationFn = Apollo.MutationFunction<
  ResultStoryViewed,
  ResultStoryViewedVariables
>;

/**
 * __useResultStoryViewed__
 *
 * To run a mutation, you first call `useResultStoryViewed` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResultStoryViewed` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resultStoryViewed, { data, loading, error }] = useResultStoryViewed({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResultStoryViewed(
  baseOptions?: Apollo.MutationHookOptions<ResultStoryViewed, ResultStoryViewedVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<ResultStoryViewed, ResultStoryViewedVariables>(
    ResultStoryViewedDocument,
    options,
  );
}
export type ResultStoryViewedHookResult = ReturnType<typeof useResultStoryViewed>;
export type ResultStoryViewedMutationResult = Apollo.MutationResult<ResultStoryViewed>;
export type ResultStoryViewedMutationOptions = Apollo.BaseMutationOptions<
  ResultStoryViewed,
  ResultStoryViewedVariables
>;
export const SurveySubmissionDocument = gql`
  mutation SurveySubmission($input: SaveUserSurveySubmissionInput!) {
    saveUserSurveySubmission(input: $input) {
      id
      user {
        id
        mostRecentLabSubmission {
          id
          surveySubmissionId
          userSurveySubmission {
            id
          }
        }
      }
    }
  }
`;
export type SurveySubmissionMutationFn = Apollo.MutationFunction<
  SurveySubmission,
  SurveySubmissionVariables
>;

/**
 * __useSurveySubmission__
 *
 * To run a mutation, you first call `useSurveySubmission` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveySubmission` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveySubmission, { data, loading, error }] = useSurveySubmission({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSurveySubmission(
  baseOptions?: Apollo.MutationHookOptions<SurveySubmission, SurveySubmissionVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SurveySubmission, SurveySubmissionVariables>(
    SurveySubmissionDocument,
    options,
  );
}
export type SurveySubmissionHookResult = ReturnType<typeof useSurveySubmission>;
export type SurveySubmissionMutationResult = Apollo.MutationResult<SurveySubmission>;
export type SurveySubmissionMutationOptions = Apollo.BaseMutationOptions<
  SurveySubmission,
  SurveySubmissionVariables
>;
export const SurveyQueryDocument = gql`
  query SurveyQuery($input: GetSurveyInput!) {
    me {
      id
      mostRecentLabSubmission {
        id
        userSurveySubmission {
          id
        }
      }
      mostRecentLabSubmissionWithResults {
        id
      }
    }
    survey(input: $input) {
      id
      key
      categories {
        id
        description
        key
        title
        steps {
          id
          stepType
          question {
            ...SurveyQuestionFragment
          }
        }
      }
    }
  }
  ${SurveyQuestionFragment}
`;

/**
 * __useSurveyQuery__
 *
 * To run a query within a React component, call `useSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSurveyQuery(
  baseOptions: Apollo.QueryHookOptions<SurveyQuery, SurveyQueryVariables> &
    ({variables: SurveyQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SurveyQuery, SurveyQueryVariables>(SurveyQueryDocument, options);
}
export function useSurveyQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SurveyQuery, SurveyQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SurveyQuery, SurveyQueryVariables>(SurveyQueryDocument, options);
}
export function useSurveyQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SurveyQuery, SurveyQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SurveyQuery, SurveyQueryVariables>(SurveyQueryDocument, options);
}
export type SurveyQueryHookResult = ReturnType<typeof useSurveyQuery>;
export type SurveyQueryLazyQueryHookResult = ReturnType<typeof useSurveyQueryLazyQuery>;
export type SurveyQuerySuspenseQueryHookResult = ReturnType<typeof useSurveyQuerySuspenseQuery>;
export type SurveyQueryQueryResult = Apollo.QueryResult<SurveyQuery, SurveyQueryVariables>;
export const SaveSurveyOnboardingDocument = gql`
  mutation SaveSurveyOnboarding($input: SaveUserSurveySubmissionInput!) {
    saveUserSurveySubmission(input: $input) {
      answers {
        questionId
        answerOptionIds
      }
    }
  }
`;
export type SaveSurveyOnboardingMutationFn = Apollo.MutationFunction<
  SaveSurveyOnboarding,
  SaveSurveyOnboardingVariables
>;

/**
 * __useSaveSurveyOnboarding__
 *
 * To run a mutation, you first call `useSaveSurveyOnboarding` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSurveyOnboarding` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSurveyOnboarding, { data, loading, error }] = useSaveSurveyOnboarding({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSurveyOnboarding(
  baseOptions?: Apollo.MutationHookOptions<SaveSurveyOnboarding, SaveSurveyOnboardingVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SaveSurveyOnboarding, SaveSurveyOnboardingVariables>(
    SaveSurveyOnboardingDocument,
    options,
  );
}
export type SaveSurveyOnboardingHookResult = ReturnType<typeof useSaveSurveyOnboarding>;
export type SaveSurveyOnboardingMutationResult = Apollo.MutationResult<SaveSurveyOnboarding>;
export type SaveSurveyOnboardingMutationOptions = Apollo.BaseMutationOptions<
  SaveSurveyOnboarding,
  SaveSurveyOnboardingVariables
>;
export const SurveyQueryOnboardingDocument = gql`
  query SurveyQueryOnboarding($input: GetSurveyInput!) {
    survey(input: $input) {
      id
      key
      questions {
        id
        description
        text
        questionType
        multipleChoiceConfiguration {
          questionChoiceType
          options {
            id
            description
            text
          }
          scale {
            from
            to
          }
        }
      }
    }
  }
`;

/**
 * __useSurveyQueryOnboarding__
 *
 * To run a query within a React component, call `useSurveyQueryOnboarding` and pass it any options that fit your needs.
 * When your component renders, `useSurveyQueryOnboarding` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyQueryOnboarding({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSurveyQueryOnboarding(
  baseOptions: Apollo.QueryHookOptions<SurveyQueryOnboarding, SurveyQueryOnboardingVariables> &
    ({variables: SurveyQueryOnboardingVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SurveyQueryOnboarding, SurveyQueryOnboardingVariables>(
    SurveyQueryOnboardingDocument,
    options,
  );
}
export function useSurveyQueryOnboardingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SurveyQueryOnboarding, SurveyQueryOnboardingVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SurveyQueryOnboarding, SurveyQueryOnboardingVariables>(
    SurveyQueryOnboardingDocument,
    options,
  );
}
export function useSurveyQueryOnboardingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SurveyQueryOnboarding, SurveyQueryOnboardingVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SurveyQueryOnboarding, SurveyQueryOnboardingVariables>(
    SurveyQueryOnboardingDocument,
    options,
  );
}
export type SurveyQueryOnboardingHookResult = ReturnType<typeof useSurveyQueryOnboarding>;
export type SurveyQueryOnboardingLazyQueryHookResult = ReturnType<
  typeof useSurveyQueryOnboardingLazyQuery
>;
export type SurveyQueryOnboardingSuspenseQueryHookResult = ReturnType<
  typeof useSurveyQueryOnboardingSuspenseQuery
>;
export type SurveyQueryOnboardingQueryResult = Apollo.QueryResult<
  SurveyQueryOnboarding,
  SurveyQueryOnboardingVariables
>;
export const VerifyAccountQueryDocument = gql`
  query VerifyAccountQuery {
    me {
      id
      isVerified
      userProfile {
        email
        id
      }
    }
  }
`;

/**
 * __useVerifyAccountQuery__
 *
 * To run a query within a React component, call `useVerifyAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useVerifyAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<VerifyAccountQuery, VerifyAccountQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<VerifyAccountQuery, VerifyAccountQueryVariables>(
    VerifyAccountQueryDocument,
    options,
  );
}
export function useVerifyAccountQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<VerifyAccountQuery, VerifyAccountQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<VerifyAccountQuery, VerifyAccountQueryVariables>(
    VerifyAccountQueryDocument,
    options,
  );
}
export function useVerifyAccountQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifyAccountQuery, VerifyAccountQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<VerifyAccountQuery, VerifyAccountQueryVariables>(
    VerifyAccountQueryDocument,
    options,
  );
}
export type VerifyAccountQueryHookResult = ReturnType<typeof useVerifyAccountQuery>;
export type VerifyAccountQueryLazyQueryHookResult = ReturnType<
  typeof useVerifyAccountQueryLazyQuery
>;
export type VerifyAccountQuerySuspenseQueryHookResult = ReturnType<
  typeof useVerifyAccountQuerySuspenseQuery
>;
export type VerifyAccountQueryQueryResult = Apollo.QueryResult<
  VerifyAccountQuery,
  VerifyAccountQueryVariables
>;
export const ChangeEmailDocument = gql`
  mutation ChangeEmail($input: ChangeEmailInput!) {
    changeEmail(input: $input) {
      success
    }
  }
`;
export type ChangeEmailMutationFn = Apollo.MutationFunction<ChangeEmail, ChangeEmailVariables>;

/**
 * __useChangeEmail__
 *
 * To run a mutation, you first call `useChangeEmail` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmail` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmail, { data, loading, error }] = useChangeEmail({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeEmail(
  baseOptions?: Apollo.MutationHookOptions<ChangeEmail, ChangeEmailVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<ChangeEmail, ChangeEmailVariables>(ChangeEmailDocument, options);
}
export type ChangeEmailHookResult = ReturnType<typeof useChangeEmail>;
export type ChangeEmailMutationResult = Apollo.MutationResult<ChangeEmail>;
export type ChangeEmailMutationOptions = Apollo.BaseMutationOptions<
  ChangeEmail,
  ChangeEmailVariables
>;
export const ReRequestEmailChangeDocument = gql`
  mutation ReRequestEmailChange($input: ReRequestEmailChangeInput!) {
    reRequestEmailChange(input: $input) {
      success
    }
  }
`;
export type ReRequestEmailChangeMutationFn = Apollo.MutationFunction<
  ReRequestEmailChange,
  ReRequestEmailChangeVariables
>;

/**
 * __useReRequestEmailChange__
 *
 * To run a mutation, you first call `useReRequestEmailChange` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReRequestEmailChange` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reRequestEmailChange, { data, loading, error }] = useReRequestEmailChange({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReRequestEmailChange(
  baseOptions?: Apollo.MutationHookOptions<ReRequestEmailChange, ReRequestEmailChangeVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<ReRequestEmailChange, ReRequestEmailChangeVariables>(
    ReRequestEmailChangeDocument,
    options,
  );
}
export type ReRequestEmailChangeHookResult = ReturnType<typeof useReRequestEmailChange>;
export type ReRequestEmailChangeMutationResult = Apollo.MutationResult<ReRequestEmailChange>;
export type ReRequestEmailChangeMutationOptions = Apollo.BaseMutationOptions<
  ReRequestEmailChange,
  ReRequestEmailChangeVariables
>;
export const VerifyPendingQueryDocument = gql`
  query VerifyPendingQuery {
    me {
      id
      isVerified
      userProfile {
        email
        id
      }
    }
  }
`;

/**
 * __useVerifyPendingQuery__
 *
 * To run a query within a React component, call `useVerifyPendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyPendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyPendingQuery({
 *   variables: {
 *   },
 * });
 */
export function useVerifyPendingQuery(
  baseOptions?: Apollo.QueryHookOptions<VerifyPendingQuery, VerifyPendingQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<VerifyPendingQuery, VerifyPendingQueryVariables>(
    VerifyPendingQueryDocument,
    options,
  );
}
export function useVerifyPendingQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<VerifyPendingQuery, VerifyPendingQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<VerifyPendingQuery, VerifyPendingQueryVariables>(
    VerifyPendingQueryDocument,
    options,
  );
}
export function useVerifyPendingQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifyPendingQuery, VerifyPendingQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<VerifyPendingQuery, VerifyPendingQueryVariables>(
    VerifyPendingQueryDocument,
    options,
  );
}
export type VerifyPendingQueryHookResult = ReturnType<typeof useVerifyPendingQuery>;
export type VerifyPendingQueryLazyQueryHookResult = ReturnType<
  typeof useVerifyPendingQueryLazyQuery
>;
export type VerifyPendingQuerySuspenseQueryHookResult = ReturnType<
  typeof useVerifyPendingQuerySuspenseQuery
>;
export type VerifyPendingQueryQueryResult = Apollo.QueryResult<
  VerifyPendingQuery,
  VerifyPendingQueryVariables
>;
export const UpdateUserAvatarDocument = gql`
  mutation UpdateUserAvatar($input: UpdateUserInput!, $imageVariant: FileImageVariant!) {
    updateUser(input: $input) {
      id
      avatar {
        id
        url(variant: $imageVariant, raw: false)
      }
    }
  }
`;
export type UpdateUserAvatarMutationFn = Apollo.MutationFunction<
  UpdateUserAvatar,
  UpdateUserAvatarVariables
>;

/**
 * __useUpdateUserAvatar__
 *
 * To run a mutation, you first call `useUpdateUserAvatar` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAvatar` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAvatar, { data, loading, error }] = useUpdateUserAvatar({
 *   variables: {
 *      input: // value for 'input'
 *      imageVariant: // value for 'imageVariant'
 *   },
 * });
 */
export function useUpdateUserAvatar(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserAvatar, UpdateUserAvatarVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateUserAvatar, UpdateUserAvatarVariables>(
    UpdateUserAvatarDocument,
    options,
  );
}
export type UpdateUserAvatarHookResult = ReturnType<typeof useUpdateUserAvatar>;
export type UpdateUserAvatarMutationResult = Apollo.MutationResult<UpdateUserAvatar>;
export type UpdateUserAvatarMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserAvatar,
  UpdateUserAvatarVariables
>;
export const GetPromotionalBannerDocument = gql`
  query GetPromotionalBanner {
    promotionalBanner {
      id
      title
      content
      textColor
      backgroundColor
      isBannerActive
    }
  }
`;

/**
 * __useGetPromotionalBanner__
 *
 * To run a query within a React component, call `useGetPromotionalBanner` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotionalBanner` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotionalBanner({
 *   variables: {
 *   },
 * });
 */
export function useGetPromotionalBanner(
  baseOptions?: Apollo.QueryHookOptions<GetPromotionalBanner, GetPromotionalBannerVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<GetPromotionalBanner, GetPromotionalBannerVariables>(
    GetPromotionalBannerDocument,
    options,
  );
}
export function useGetPromotionalBannerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPromotionalBanner, GetPromotionalBannerVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<GetPromotionalBanner, GetPromotionalBannerVariables>(
    GetPromotionalBannerDocument,
    options,
  );
}
export function useGetPromotionalBannerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPromotionalBanner, GetPromotionalBannerVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<GetPromotionalBanner, GetPromotionalBannerVariables>(
    GetPromotionalBannerDocument,
    options,
  );
}
export type GetPromotionalBannerHookResult = ReturnType<typeof useGetPromotionalBanner>;
export type GetPromotionalBannerLazyQueryHookResult = ReturnType<
  typeof useGetPromotionalBannerLazyQuery
>;
export type GetPromotionalBannerSuspenseQueryHookResult = ReturnType<
  typeof useGetPromotionalBannerSuspenseQuery
>;
export type GetPromotionalBannerQueryResult = Apollo.QueryResult<
  GetPromotionalBanner,
  GetPromotionalBannerVariables
>;
export const UserIdentificationQueryDocument = gql`
  query UserIdentificationQuery {
    me {
      id
      userProfile {
        email
      }
      subscription {
        hasActiveSubscription
      }
      labSubmissionsWithResultCount
      mostRecentLabSubmissionWithResults {
        id
        labAssessment {
          id
          bioAge
        }
        userSurveySubmission {
          id
          surveyAssessment {
            id
            lifestyleScore
            selectedActionPlan {
              id
            }
          }
        }
      }
    }
  }
`;

/**
 * __useUserIdentificationQuery__
 *
 * To run a query within a React component, call `useUserIdentificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserIdentificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserIdentificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserIdentificationQuery(
  baseOptions?: Apollo.QueryHookOptions<UserIdentificationQuery, UserIdentificationQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<UserIdentificationQuery, UserIdentificationQueryVariables>(
    UserIdentificationQueryDocument,
    options,
  );
}
export function useUserIdentificationQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserIdentificationQuery,
    UserIdentificationQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<UserIdentificationQuery, UserIdentificationQueryVariables>(
    UserIdentificationQueryDocument,
    options,
  );
}
export function useUserIdentificationQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserIdentificationQuery, UserIdentificationQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<UserIdentificationQuery, UserIdentificationQueryVariables>(
    UserIdentificationQueryDocument,
    options,
  );
}
export type UserIdentificationQueryHookResult = ReturnType<typeof useUserIdentificationQuery>;
export type UserIdentificationQueryLazyQueryHookResult = ReturnType<
  typeof useUserIdentificationQueryLazyQuery
>;
export type UserIdentificationQuerySuspenseQueryHookResult = ReturnType<
  typeof useUserIdentificationQuerySuspenseQuery
>;
export type UserIdentificationQueryQueryResult = Apollo.QueryResult<
  UserIdentificationQuery,
  UserIdentificationQueryVariables
>;
export const UserStateQueryDocument = gql`
  query UserStateQuery($imageVariant: FileImageVariant!) {
    me {
      avatar {
        id
        url(variant: $imageVariant, raw: false)
      }
      id
      isVerified
      timezone
      userProfile {
        firstName
        id
        email
        initials @client
        lastName
      }
      subscription {
        id
        hasActiveSubscription
        hasMembership
      }
    }
  }
`;

/**
 * __useUserStateQuery__
 *
 * To run a query within a React component, call `useUserStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStateQuery({
 *   variables: {
 *      imageVariant: // value for 'imageVariant'
 *   },
 * });
 */
export function useUserStateQuery(
  baseOptions: Apollo.QueryHookOptions<UserStateQuery, UserStateQueryVariables> &
    ({variables: UserStateQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<UserStateQuery, UserStateQueryVariables>(UserStateQueryDocument, options);
}
export function useUserStateQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserStateQuery, UserStateQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<UserStateQuery, UserStateQueryVariables>(
    UserStateQueryDocument,
    options,
  );
}
export function useUserStateQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserStateQuery, UserStateQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<UserStateQuery, UserStateQueryVariables>(
    UserStateQueryDocument,
    options,
  );
}
export type UserStateQueryHookResult = ReturnType<typeof useUserStateQuery>;
export type UserStateQueryLazyQueryHookResult = ReturnType<typeof useUserStateQueryLazyQuery>;
export type UserStateQuerySuspenseQueryHookResult = ReturnType<
  typeof useUserStateQuerySuspenseQuery
>;
export type UserStateQueryQueryResult = Apollo.QueryResult<UserStateQuery, UserStateQueryVariables>;
